const cityCode = [
  {
    code: 'IWD',
    name_ja: 'アイアンウッド',
    name_en: 'IRONWOOD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IWD',
  },
  {
    code: 'IMT',
    name_ja: 'アイアンマウンテン',
    name_en: 'IRON MOUNTAIN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IMT',
  },
  {
    code: 'IDA',
    name_ja: 'アイダホフォールズ',
    name_en: 'IDAHO FALLS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IDA',
  },
  {
    code: 'ILY',
    name_ja: 'アイラ',
    name_en: 'ISLAY',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'ILY',
  },
  {
    code: 'EIN',
    name_ja: 'アイントホーベン',
    name_en: 'EINDHOVEN',
    area_code: 'eur',
    country_code: 'NL',
    flag: 1,
    display: null,
    air_city_code: 'EIN',
  },
  {
    code: 'AGB',
    name_ja: 'アウグスブルク',
    name_en: 'AUGSBURG',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: '',
  },
  {
    code: 'IXU',
    name_ja: 'アウランガバード',
    name_en: 'AURANGABAD',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IXU',
  },
  {
    code: 'ACA',
    name_ja: 'アカプルコ',
    name_en: 'ACAPULCO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: 4,
    air_city_code: 'ACA',
  },
  {
    code: 'AGA',
    name_ja: 'アガジール',
    name_en: 'AGADIR',
    area_code: 'afr',
    country_code: 'MA',
    flag: 1,
    display: null,
    air_city_code: 'AGA',
  },
  {
    code: 'IXA',
    name_ja: 'アガタラ',
    name_en: 'AGARTALA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IXA',
  },
  {
    code: 'ACC',
    name_ja: 'アクラ',
    name_en: 'ACCRA',
    area_code: 'afr',
    country_code: 'GH',
    flag: 1,
    display: null,
    air_city_code: 'ACC',
  },
  {
    code: 'CAK',
    name_ja: 'アクロン・カントン',
    name_en: 'AKRON/CANTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CAK',
  },
  {
    code: 'AGU',
    name_ja: 'アグアスカリエンテス',
    name_en: 'AGUASCALIENTES',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'AGU',
  },
  {
    code: 'AGR',
    name_ja: 'アグラ',
    name_en: 'AGRA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'AGR',
  },
  {
    code: 'ADD',
    name_ja: 'アシスアベバ',
    name_en: 'ADDIS ABABA',
    area_code: 'afr',
    country_code: 'ET',
    flag: 1,
    display: null,
    air_city_code: 'ADD',
  },
  {
    code: 'ATZ',
    name_ja: 'アシット',
    name_en: 'ASSIUT',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: null,
    air_city_code: 'ATZ',
  },
  {
    code: 'ASB',
    name_ja: 'アシハバード',
    name_en: 'ASHGABAD',
    area_code: 'asi',
    country_code: 'TM',
    flag: 1,
    display: null,
    air_city_code: 'ASB',
  },
  {
    code: 'AJA',
    name_ja: 'アジャクシオ',
    name_en: 'AJACCIO',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'AJA',
  },
  {
    code: 'TSE',
    name_ja: 'アスタナ',
    name_en: 'ASTANA',
    area_code: 'asi',
    country_code: 'KZ',
    flag: 1,
    display: null,
    air_city_code: 'TSE',
  },
  {
    code: 'JTY',
    name_ja: 'アスティパレア島',
    name_en: 'ASTIPALAIA',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'JTY',
  },
  {
    code: 'OVD',
    name_ja: 'アストゥリアス',
    name_en: 'ASTURIAS',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'OVD',
  },
  {
    code: 'ASE',
    name_ja: 'アスペン',
    name_en: 'ASPEN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ASE',
  },
  {
    code: 'ASM',
    name_ja: 'アスマラ',
    name_en: 'ASMARA',
    area_code: 'afr',
    country_code: 'ER',
    flag: 1,
    display: null,
    air_city_code: 'ASM',
  },
  {
    code: 'ASW',
    name_ja: 'アスワン',
    name_en: 'ASWAN',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: null,
    air_city_code: 'ASW',
  },
  {
    code: 'ASU',
    name_ja: 'アスンシオン',
    name_en: 'ASUNCION',
    area_code: 'sam',
    country_code: 'PY',
    flag: 1,
    display: null,
    air_city_code: 'ASU',
  },
  {
    code: 'AHN',
    name_ja: 'アセンズ',
    name_en: 'ATHENS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AHN',
  },
  {
    code: 'ADA',
    name_ja: 'アダナ',
    name_en: 'ADANA',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'ADA',
  },
  {
    code: 'AVL',
    name_ja: 'アッシュビル',
    name_en: 'ASHEVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AVL',
  },
  {
    code: 'ATW',
    name_ja: 'アップルトン',
    name_en: 'APPLETON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ATW',
  },
  {
    code: 'ATH',
    name_ja: 'アテネ',
    name_en: 'ATHENS',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: 1,
    air_city_code: 'ATH',
  },
  {
    code: 'ADL',
    name_ja: 'アデレード',
    name_en: 'ADELAIDE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'ADL',
  },
  {
    code: 'ATL',
    name_ja: 'アトランタ',
    name_en: 'ATLANTA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ATL',
  },
  {
    code: 'ACY',
    name_ja: 'アトランティックシティ',
    name_en: 'ATLANTIC CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ACY',
  },
  {
    code: 'ANA',
    name_ja: 'アナハイム',
    name_en: 'ANAHEIM',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LAX',
  },
  {
    code: 'ANI',
    name_ja: 'アニアック',
    name_en: 'ANIAK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ANI',
  },
  {
    code: 'ANB',
    name_ja: 'アニストン',
    name_en: 'ANNISTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ANB',
  },
  {
    code: 'NCY',
    name_ja: 'アヌシー',
    name_en: 'ANNECY',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'NCY',
  },
  {
    code: 'ABA',
    name_ja: 'アバカン',
    name_en: 'ABAKAN',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'ABA',
  },
  {
    code: 'ABZ',
    name_ja: 'アバディーン',
    name_en: 'ABERDEEN',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'ABZ',
  },
  {
    code: 'ABR',
    name_ja: 'アバディーン（サウスダコタ州）',
    name_en: 'ABERDEEN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ABR',
  },
  {
    code: 'ABJ',
    name_ja: 'アビジャン',
    name_en: 'ABIDJAN',
    area_code: 'afr',
    country_code: 'CI',
    flag: 1,
    display: null,
    air_city_code: 'ABJ',
  },
  {
    code: 'AVN',
    name_ja: 'アビニョン',
    name_en: 'AVIGNON',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'AVN',
  },
  {
    code: 'ABI',
    name_ja: 'アビリーン',
    name_en: 'ABILENE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ABI',
  },
  {
    code: 'UTN',
    name_ja: 'アピントン',
    name_en: 'UPINGTON',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'UTN',
  },
  {
    code: 'AMD',
    name_ja: 'アフマダバード',
    name_en: 'AHMEDABAD',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'AMD',
  },
  {
    code: 'ABS',
    name_ja: 'アブシンベル',
    name_en: 'ABU SIMBEL',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: null,
    air_city_code: 'ABS',
  },
  {
    code: 'ABV',
    name_ja: 'アブジャ',
    name_en: 'ABUJA',
    area_code: 'afr',
    country_code: 'NG',
    flag: 1,
    display: null,
    air_city_code: 'ABV',
  },
  {
    code: 'AUH',
    name_ja: 'アブダビ',
    name_en: 'ABU DHABI',
    area_code: 'afr',
    country_code: 'AE',
    flag: 1,
    display: 2,
    air_city_code: 'AUH',
  },
  {
    code: 'AMA',
    name_ja: 'アマリロ',
    name_en: 'AMARILLO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AMA',
  },
  {
    code: 'AMF',
    name_ja: 'アマルフィ',
    name_en: 'AMALFI',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'NAP',
  },
  {
    code: 'AMS',
    name_ja: 'アムステルダム',
    name_en: 'AMSTERDAM',
    area_code: 'eur',
    country_code: 'NL',
    flag: 1,
    display: 1,
    air_city_code: 'AMS',
  },
  {
    code: 'ATQ',
    name_ja: 'アムリトサル',
    name_en: 'AMRITSAR',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'ATQ',
  },
  {
    code: 'AIA',
    name_ja: 'アライアンス',
    name_en: 'ALLIANCE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AIA',
  },
  {
    code: 'AJU',
    name_ja: 'アラカンジュ',
    name_en: 'ARACAJU',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'AJU',
  },
  {
    code: 'ARU',
    name_ja: 'アラサツーバ',
    name_en: 'ARACATUBA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'ARU',
  },
  {
    code: 'ALM',
    name_ja: 'アラモゴード',
    name_en: 'ALAMOGORDO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ALM',
  },
  {
    code: 'ALS',
    name_ja: 'アラモサ',
    name_en: 'ALAMOSA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ALS',
  },
  {
    code: 'ARI',
    name_ja: 'アリカ',
    name_en: 'ARICA',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'ARI',
  },
  {
    code: 'ALC',
    name_ja: 'アリカンテ',
    name_en: 'ALICANTE',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'ALC',
  },
  {
    code: 'ASP',
    name_ja: 'アリススプリングス',
    name_en: 'ALICE SPRINGS',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'ASP',
  },
  {
    code: 'ARH',
    name_ja: 'アルカンゲルスク',
    name_en: 'ARKHANQEISK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'ARH',
  },
  {
    code: 'AHO',
    name_ja: 'アルゲーロ',
    name_en: 'ALGHERO',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'AHO',
  },
  {
    code: 'ALG',
    name_ja: 'アルジェ',
    name_en: 'ALGIERS',
    area_code: 'afr',
    country_code: 'DZ',
    flag: 1,
    display: null,
    air_city_code: 'ALG',
  },
  {
    code: 'ALF',
    name_ja: 'アルタ',
    name_en: 'ALTA',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'ALF',
  },
  {
    code: 'AXR',
    name_ja: 'アルツア',
    name_en: 'ARUTUA',
    area_code: 'oce',
    country_code: 'PF',
    flag: 1,
    display: null,
    air_city_code: 'AXR',
  },
  {
    code: 'ACH',
    name_ja: 'アルテンハイム',
    name_en: 'AL TENRHEIN',
    area_code: 'eur',
    country_code: 'CH',
    flag: 1,
    display: null,
    air_city_code: 'ACH',
  },
  {
    code: 'AOO',
    name_ja: 'アルトゥーナ',
    name_en: 'ALTOONA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AOO',
  },
  {
    code: 'AUA',
    name_ja: 'アルバ',
    name_en: 'ARUBA',
    area_code: 'sam',
    country_code: 'AW',
    flag: 1,
    display: null,
    air_city_code: 'AUA',
  },
  {
    code: 'ABQ',
    name_ja: 'アルバカ－キ',
    name_en: 'ALBUQUERQUE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ABQ',
  },
  {
    code: 'ALH',
    name_ja: 'アルバニイ',
    name_en: 'ALBANY',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'ALH',
  },
  {
    code: 'ABY',
    name_ja: 'アルバニー（ジョージア州）',
    name_en: 'ALBANY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ABY',
  },
  {
    code: 'ALB',
    name_ja: 'アルバニー（ニューヨーク州）',
    name_en: 'ALBANY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ALB',
  },
  {
    code: 'APN',
    name_ja: 'アルピーナ',
    name_en: 'ALPENA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'APN',
  },
  {
    code: 'LEI',
    name_ja: 'アルメリア',
    name_en: 'ALMERIA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'LEI',
  },
  {
    code: 'AAN',
    name_ja: 'アル・アイン',
    name_en: 'AL AIN',
    area_code: 'afr',
    country_code: 'AE',
    flag: 1,
    display: null,
    air_city_code: 'AAN',
  },
  {
    code: 'ALY',
    name_ja: 'アレクサンドリア',
    name_en: 'ALEXANDRIA',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: null,
    air_city_code: 'ALY',
  },
  {
    code: 'ESF',
    name_ja: 'アレクサンドリア',
    name_en: 'ALEXANDRIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ESF',
  },
  {
    code: 'AEX',
    name_ja: 'アレクサンドリア（ルイジアナ州）',
    name_en: 'ALEXANDRIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AEX',
  },
  {
    code: 'ALP',
    name_ja: 'アレッポ',
    name_en: 'ALEPPO',
    area_code: 'afr',
    country_code: 'SY',
    flag: 1,
    display: null,
    air_city_code: 'ALP',
  },
  {
    code: 'ABE',
    name_ja: 'アレンタウン',
    name_en: 'ALLENTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ABE',
  },
  {
    code: 'YAL',
    name_ja: 'アレートベイ',
    name_en: 'ALERT BAY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YAL',
  },
  {
    code: 'GUR',
    name_ja: 'アロタウ',
    name_en: 'ALOTAU',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'GUR',
  },
  {
    code: 'AOR',
    name_ja: 'アロースター',
    name_en: 'ALOR SETAR',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'AOR',
  },
  {
    code: 'ANK',
    name_ja: 'アンカラ',
    name_en: 'ANKARA',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'ANK',
  },
  {
    code: 'ANC',
    name_ja: 'アンカレッジ',
    name_en: 'ANCHORAGE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ANC',
  },
  {
    code: 'AXA',
    name_ja: 'アンギラ',
    name_en: 'ANGUILLA',
    area_code: 'sam',
    country_code: 'AI',
    flag: 1,
    display: null,
    air_city_code: 'AXA',
  },
  {
    code: 'AOI',
    name_ja: 'アンコナ',
    name_en: 'ANCONA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'AOI',
  },
  {
    code: 'ANE',
    name_ja: 'アンジェー',
    name_en: 'ANGERS',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'ANE',
  },
  {
    code: 'TNR',
    name_ja: 'アンタナナリボ',
    name_en: 'ANTANANARIVO',
    area_code: 'afr',
    country_code: 'MG',
    flag: 1,
    display: null,
    air_city_code: 'TNR',
  },
  {
    code: 'AYT',
    name_ja: 'アンタルヤ',
    name_en: 'ANTALYA',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'AYT',
  },
  {
    code: 'ANU',
    name_ja: 'アンティグア',
    name_en: 'ANTIGUA',
    area_code: 'sam',
    country_code: 'AG',
    flag: 1,
    display: null,
    air_city_code: 'ANU',
  },
  {
    code: 'ANF',
    name_ja: 'アントファガスタ',
    name_en: 'ANTOFAGASTA',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'ANF',
  },
  {
    code: 'ANR',
    name_ja: 'アントワープ',
    name_en: 'ANTWERP',
    area_code: 'eur',
    country_code: 'BE',
    flag: 1,
    display: null,
    air_city_code: 'ANR',
  },
  {
    code: 'ASD',
    name_ja: 'アンドロスタウン',
    name_en: 'ANDROS TOWN',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'ASD',
  },
  {
    code: 'AMQ',
    name_ja: 'アンボン',
    name_en: 'AMBON',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'AMQ',
  },
  {
    code: 'AMM',
    name_ja: 'アンマン',
    name_en: 'AMMAN',
    area_code: 'afr',
    country_code: 'JO',
    flag: 1,
    display: null,
    air_city_code: 'AMM',
  },
  {
    code: 'ACV',
    name_ja: 'アーカタ（ユーリカ）',
    name_en: 'ARCATA/EUREKA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ACV',
  },
  {
    code: 'ATC',
    name_ja: 'アートヒューズタウン',
    name_en: 'ARTHUR&rsquo;S TOWN',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'ATC',
  },
  {
    code: 'YEK',
    name_ja: 'アービアト',
    name_en: 'ARVIAT',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YEK',
  },
  {
    code: 'APW',
    name_ja: 'アーピア',
    name_en: 'APIA',
    area_code: 'oce',
    country_code: 'WS',
    flag: 1,
    display: null,
    air_city_code: 'APW',
  },
  {
    code: 'AJI',
    name_ja: 'アール',
    name_en: 'AGRI',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'AJI',
  },
  {
    code: 'ARM',
    name_ja: 'ア－ミデ－ル',
    name_en: 'ARMIDALE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'ARM',
  },
  {
    code: 'YZF',
    name_ja: 'イエローナイフ',
    name_en: 'YELLOW KNIFE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YZF',
  },
  {
    code: 'WEH',
    name_ja: 'イカイ（威海）',
    name_en: 'WEIHAI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'WEH',
  },
  {
    code: 'YFB',
    name_ja: 'イカルイト',
    name_en: 'IQALUIT',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YFB',
  },
  {
    code: 'IQQ',
    name_ja: 'イキケ',
    name_en: 'IQUIQUE',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'IQQ',
  },
  {
    code: 'IQT',
    name_ja: 'イキトス',
    name_en: 'IQUITOS',
    area_code: 'sam',
    country_code: 'PE',
    flag: 1,
    display: null,
    air_city_code: 'IQT',
  },
  {
    code: 'IGR',
    name_ja: 'イグアス',
    name_en: 'IGUAZU',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: 2,
    air_city_code: 'IGR',
  },
  {
    code: 'IGU',
    name_ja: 'イグアスフォールズ',
    name_en: 'IGUASSU FALLS',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: 3,
    air_city_code: 'IGU',
  },
  {
    code: 'ITH',
    name_ja: 'イサカ',
    name_en: 'ITHACA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ITH',
  },
  {
    code: 'IST',
    name_ja: 'イスタンブール',
    name_en: 'ISTANBUL',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: 1,
    air_city_code: 'IST',
  },
  {
    code: 'IFN',
    name_ja: 'イスファハーン',
    name_en: 'ISFAHAN',
    area_code: 'afr',
    country_code: 'IR',
    flag: 1,
    display: null,
    air_city_code: 'IFN',
  },
  {
    code: 'ISB',
    name_ja: 'イスラマバード',
    name_en: 'ISLAMABAD',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'ISB',
  },
  {
    code: 'ISP',
    name_ja: 'イスリップ',
    name_en: 'ISLIP',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ISP',
  },
  {
    code: 'IZM',
    name_ja: 'イズミール',
    name_en: 'IZMIR',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'IZM',
  },
  {
    code: 'YEV',
    name_ja: 'イヌビク',
    name_en: 'INUVIK',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YEV',
  },
  {
    code: 'IBE',
    name_ja: 'イバゲ',
    name_en: 'IBAGUE',
    area_code: 'sam',
    country_code: 'CO',
    flag: 1,
    display: null,
    air_city_code: 'IBE',
  },
  {
    code: 'IBZ',
    name_ja: 'イビーサ',
    name_en: 'IBIZA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'IBZ',
  },
  {
    code: 'IPH',
    name_ja: 'イポー',
    name_en: 'IPOH',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'IPH',
  },
  {
    code: 'ILI',
    name_ja: 'イリアンナ',
    name_en: 'ILIAMNA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ILI',
  },
  {
    code: 'ELY',
    name_ja: 'イリー（ネバダ州）',
    name_en: 'ELY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ELY',
  },
  {
    code: 'IKT',
    name_ja: 'イルクーツク',
    name_en: 'IRKUTSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'IKT',
  },
  {
    code: 'ILP',
    name_ja: 'イルデバン',
    name_en: 'ILE DES PINS',
    area_code: 'oce',
    country_code: 'NC',
    flag: 1,
    display: null,
    air_city_code: 'ILP',
  },
  {
    code: 'ILO',
    name_ja: 'イロイロ',
    name_en: 'ILOILO',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'ILO',
  },
  {
    code: 'INN',
    name_ja: 'インスブルック',
    name_en: 'INNSBRUCK',
    area_code: 'eur',
    country_code: 'AT',
    flag: 1,
    display: null,
    air_city_code: 'INN',
  },
  {
    code: 'INL',
    name_ja: 'インターナショナルフォールズ',
    name_en: 'INTERNATIONAL FALLS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'INL',
  },
  {
    code: 'JKG',
    name_ja: 'インチェピング',
    name_en: 'JONKOPING',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'JKG',
  },
  {
    code: 'IND',
    name_ja: 'インディアナポリス',
    name_en: 'INDIANAPOLIS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IND',
  },
  {
    code: 'IDR',
    name_ja: 'インドール',
    name_en: 'INDORE',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IDR',
  },
  {
    code: 'IVR',
    name_ja: 'インバエル',
    name_en: 'INVERELL',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'IVR',
  },
  {
    code: 'IVC',
    name_ja: 'インバカーギル',
    name_en: 'INVERCARGILL',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'IVC',
  },
  {
    code: 'INV',
    name_ja: 'インバネス',
    name_en: 'INVERNESS',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'INV',
  },
  {
    code: 'IMF',
    name_ja: 'インパール',
    name_en: 'IMPHAL',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IMF',
  },
  {
    code: 'NRS',
    name_ja: 'インペリアルビーチ',
    name_en: 'IMPERIAL BEACH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'NRS',
  },
  {
    code: 'IYK',
    name_ja: 'インヨーカーン',
    name_en: 'INYOKERN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IYK',
  },
  {
    code: 'IVL',
    name_ja: 'イヴァロ',
    name_en: 'IVALO',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'IVL',
  },
  {
    code: 'EGV',
    name_ja: 'イーグルリバー',
    name_en: 'EAGLE RIVER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EGV',
  },
  {
    code: 'IPC',
    name_ja: 'イースター',
    name_en: 'EASTER ISLAND',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'IPC',
  },
  {
    code: 'ESD',
    name_ja: 'イーストサウンド',
    name_en: 'EASTSOUND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ESD',
  },
  {
    code: 'HTO',
    name_ja: 'イーストハンプトン',
    name_en: 'EAST HAMPTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HTO',
  },
  {
    code: 'EMA',
    name_ja: 'イーストミッドランド',
    name_en: 'EAST MIDLANDS',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'EMA',
  },
  {
    code: 'ELS',
    name_ja: 'イーストロンドン',
    name_en: 'EAST LONDON',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'ELS',
  },
  {
    code: 'WDG',
    name_ja: 'イーニッド（オクラホマ州）',
    name_en: 'ENID',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'WDG',
  },
  {
    code: 'WEF',
    name_ja: 'イ坊',
    name_en: 'WEIFANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'WEF',
  },
  {
    code: 'YWS',
    name_ja: 'ウィスラ－',
    name_en: 'WHISTLER',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YVR',
  },
  {
    code: 'ICT',
    name_ja: 'ウィチタ',
    name_en: 'WICHITA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ICT',
  },
  {
    code: 'SPS',
    name_ja: 'ウィチタフォールズ',
    name_en: 'WICHITA FALLS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SPS',
  },
  {
    code: 'YWG',
    name_ja: 'ウィニペグ',
    name_en: 'WINNIPEG',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YWG',
  },
  {
    code: 'IPT',
    name_ja: 'ウィリアムズポート',
    name_en: 'WILLIAMSPORT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IPT',
  },
  {
    code: 'YWL',
    name_ja: 'ウィリアムズレイク',
    name_en: 'WILLAMS LAKE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YWL',
  },
  {
    code: 'ISN',
    name_ja: 'ウィリストン',
    name_en: 'WILLISTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ISN',
  },
  {
    code: 'AVP',
    name_ja: 'ウィルクスバレー',
    name_en: 'WILKES-BARRE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AVP',
  },
  {
    code: 'ILM',
    name_ja: 'ウィルミントン',
    name_en: 'WILMINGTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ILM',
  },
  {
    code: 'INT',
    name_ja: 'ウィンストンサレム',
    name_en: 'WINSTON-SALEM',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'INT',
  },
  {
    code: 'INW',
    name_ja: 'ウィンズロー',
    name_en: 'WINSLOW',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'INW',
  },
  {
    code: 'WDH',
    name_ja: 'ウィンドフォーク',
    name_en: 'WINDHOEK',
    area_code: 'afr',
    country_code: 'NA',
    flag: 1,
    display: null,
    air_city_code: 'WDH',
  },
  {
    code: 'VIE',
    name_ja: 'ウィーン',
    name_en: 'VIENNA',
    area_code: 'eur',
    country_code: 'AT',
    flag: 1,
    display: 1,
    air_city_code: 'VIE',
  },
  {
    code: 'YQG',
    name_ja: 'ウインザー',
    name_en: 'WINDSOR',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQG',
  },
  {
    code: 'GWT',
    name_ja: 'ウェスターランド',
    name_en: 'WESTERLAND',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'GWT',
  },
  {
    code: 'WST',
    name_ja: 'ウェスターリー',
    name_en: 'WESTERLY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'WST',
  },
  {
    code: 'WTD',
    name_ja: 'ウェストエンド',
    name_en: 'WESTEND',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'WTD',
  },
  {
    code: 'WLG',
    name_ja: 'ウェリントン',
    name_en: 'WELLINGTON',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: 4,
    air_city_code: 'WLG',
  },
  {
    code: 'WWK',
    name_ja: 'ウェワク',
    name_en: 'WEWAK',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'WWK',
  },
  {
    code: 'ACT',
    name_ja: 'ウェーコー',
    name_en: 'WACO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ACT',
  },
  {
    code: 'WEI',
    name_ja: 'ウエイパ',
    name_en: 'WEIPA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'WEI',
  },
  {
    code: 'WYS',
    name_ja: 'ウエストイエローストン',
    name_en: 'WEST YELLOWSTONE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'WYS',
  },
  {
    code: 'HPN',
    name_ja: 'ウエストチェスターカントリー',
    name_en: 'WESTCHESTER COUNTY/WHITE PLAINS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HPN',
  },
  {
    code: 'PBI',
    name_ja: 'ウエストパームビーチ',
    name_en: 'WEST PALM BEACH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PBI',
  },
  {
    code: 'WSZ',
    name_ja: 'ウエストポート',
    name_en: 'WESTPORT',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'WSZ',
  },
  {
    code: 'EAT',
    name_ja: 'ウエナッチ',
    name_en: 'WENATCHEE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EAT',
  },
  {
    code: 'ALW',
    name_ja: 'ウォラウォラ',
    name_en: 'WALLA WALLA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ALW',
  },
  {
    code: 'WVB',
    name_ja: 'ウォルビスベイ',
    name_en: 'WALVIS BAY',
    area_code: 'afr',
    country_code: 'NA',
    flag: 1,
    display: null,
    air_city_code: 'WVB',
  },
  {
    code: 'WKR',
    name_ja: 'ウォーカーズカイ',
    name_en: 'WALKERS CAY',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'WKR',
  },
  {
    code: 'ATY',
    name_ja: 'ウォータータウン（サウスダコタ州）',
    name_en: 'WATERTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ATY',
  },
  {
    code: 'ART',
    name_ja: 'ウォータータウン（ニューヨーク州）',
    name_en: 'WATERTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ART',
  },
  {
    code: 'WVL',
    name_ja: 'ウォータービル',
    name_en: 'WATERVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'WVL',
  },
  {
    code: 'YKF',
    name_ja: 'ウォータールー',
    name_en: 'WATERLOO',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YKF',
  },
  {
    code: 'ALO',
    name_ja: 'ウォータールー',
    name_en: 'WATERLOO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ALO',
  },
  {
    code: 'USH',
    name_ja: 'ウシュアイア',
    name_en: 'USHUAIA',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'USH',
  },
  {
    code: 'UTH',
    name_ja: 'ウジュンタニ',
    name_en: 'UDON THANI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'UTH',
  },
  {
    code: 'UTP',
    name_ja: 'ウタパオ',
    name_en: 'UTAPAO',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'UTP',
  },
  {
    code: 'UDR',
    name_ja: 'ウダイプール',
    name_en: 'UDAIPUR',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'UDR',
  },
  {
    code: 'UFA',
    name_ja: 'ウファ',
    name_en: 'UFA',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'UFA',
  },
  {
    code: 'UBA',
    name_ja: 'ウベラバ',
    name_en: 'UBERABA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'UBA',
  },
  {
    code: 'UDI',
    name_ja: 'ウベランディア',
    name_en: 'UBERLANDIA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'UDI',
  },
  {
    code: 'UBP',
    name_ja: 'ウボンラチャタニ',
    name_en: 'UBON RATCHATHANI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'UBP',
  },
  {
    code: 'UTT',
    name_ja: 'ウムタタ',
    name_en: 'UMTATA',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'UTT',
  },
  {
    code: 'UME',
    name_ja: 'ウメア',
    name_en: 'UMEA',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'UME',
  },
  {
    code: 'VVO',
    name_ja: 'ウラジオストック',
    name_en: 'VLADIOSTOK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'VVO',
  },
  {
    code: 'ULN',
    name_ja: 'ウランバートル',
    name_en: 'ULAANBAATAR',
    area_code: 'asi',
    country_code: 'MN',
    flag: 1,
    display: null,
    air_city_code: 'ULN',
  },
  {
    code: 'UGC',
    name_ja: 'ウルゲンチ',
    name_en: 'URGENCH',
    area_code: 'asi',
    country_code: 'UZ',
    flag: 1,
    display: null,
    air_city_code: 'UGC',
  },
  {
    code: 'OLF',
    name_ja: 'ウルフポイント',
    name_en: 'WOLT POINT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OLF',
  },
  {
    code: 'URC',
    name_ja: 'ウルムチ（烏魯木斉）',
    name_en: 'URUMQI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'URC',
  },
  {
    code: 'ORH',
    name_ja: 'ウースター',
    name_en: 'WORCESTER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ORH',
  },
  {
    code: 'WUH',
    name_ja: 'ウーハン（武漢）',
    name_en: 'WUHAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'WUH',
  },
  {
    code: 'AYQ',
    name_ja: 'エアーズロック',
    name_en: 'AYERS ROCK',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: 7,
    air_city_code: 'AYQ',
  },
  {
    code: 'SVX',
    name_ja: 'エカテリンブルク',
    name_en: 'EKATERINBURG',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'SVX',
  },
  {
    code: 'EDI',
    name_ja: 'エジンバラ',
    name_en: 'EDINBURGH',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: 3,
    air_city_code: 'EDI',
  },
  {
    code: 'ESC',
    name_ja: 'エスカナーバ',
    name_en: 'ESCANABA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ESC',
  },
  {
    code: 'OSD',
    name_ja: 'エステルスンド',
    name_en: 'OSTERSUND',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'OSD',
  },
  {
    code: 'EBJ',
    name_ja: 'エスビャー',
    name_en: 'ESBJERG',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'EBJ',
  },
  {
    code: 'ESS',
    name_ja: 'エッセン',
    name_en: 'ESSEN',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'DUS',
  },
  {
    code: 'YEA',
    name_ja: 'エドモントン',
    name_en: 'EDMONTON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YEA',
  },
  {
    code: 'ENF',
    name_ja: 'エノンテキオ',
    name_en: 'ENONTEKIO',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'ENF',
  },
  {
    code: 'EPL',
    name_ja: 'エピナル',
    name_en: 'EPINAL',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'EPL',
  },
  {
    code: 'EVV',
    name_ja: 'エブァンスビル',
    name_en: 'EVANSVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EVV',
  },
  {
    code: 'EMD',
    name_ja: 'エメラルド',
    name_en: 'EMERALD',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'EMD',
  },
  {
    code: 'ETH',
    name_ja: 'エラート',
    name_en: 'ELAT',
    area_code: 'afr',
    country_code: 'IL',
    flag: 1,
    display: null,
    air_city_code: 'ETH',
  },
  {
    code: 'YEL',
    name_ja: 'エリオットレイク',
    name_en: 'ELLIOT LAKE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YEL',
  },
  {
    code: 'ERI',
    name_ja: 'エリー',
    name_en: 'ERIE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ERI',
  },
  {
    code: 'LYU',
    name_ja: 'エリー',
    name_en: 'ELY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LYU',
  },
  {
    code: 'FTE',
    name_ja: 'エルカラファテ',
    name_en: 'EL CALAFATE',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'FTE',
  },
  {
    code: 'ECN',
    name_ja: 'エルカン',
    name_en: 'ERCAN',
    area_code: 'eur',
    country_code: 'CY',
    flag: 1,
    display: null,
    air_city_code: 'ECN',
  },
  {
    code: 'EKN',
    name_ja: 'エルキンス',
    name_en: 'ELKINS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EKN',
  },
  {
    code: 'EKI',
    name_ja: 'エルクハート',
    name_en: 'ELKHART',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EKI',
  },
  {
    code: 'EKO',
    name_ja: 'エルコ',
    name_en: 'ELKO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EKO',
  },
  {
    code: 'ERZ',
    name_ja: 'エルズルン',
    name_en: 'ERZURUM',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'ERZ',
  },
  {
    code: 'IPL',
    name_ja: 'エルセントロ',
    name_en: 'EL CENTRO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IPL',
  },
  {
    code: 'ELD',
    name_ja: 'エルドラド',
    name_en: 'EL DORADO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ELD',
  },
  {
    code: 'ELP',
    name_ja: 'エルパソ',
    name_en: 'EL PASO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ELP',
  },
  {
    code: 'EBL',
    name_ja: 'エルビル',
    name_en: 'ERBIL',
    area_code: 'afr',
    country_code: 'IQ',
    flag: 1,
    display: null,
    air_city_code: 'EBL',
  },
  {
    code: 'ERF',
    name_ja: 'エルフルト',
    name_en: 'ERFURT',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'ERF',
  },
  {
    code: 'ELM',
    name_ja: 'エルミラ',
    name_en: 'ELMIRA/CORNING',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ELM',
  },
  {
    code: 'HMO',
    name_ja: 'エルモシヨ',
    name_en: 'HERMOSILLO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'HMO',
  },
  {
    code: 'EVN',
    name_ja: 'エレバン',
    name_en: 'YEREVAN',
    area_code: 'eur',
    country_code: 'AM',
    flag: 1,
    display: null,
    air_city_code: 'EVN',
  },
  {
    code: 'ORB',
    name_ja: 'エレブルー',
    name_en: 'OREBRO',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'ORB',
  },
  {
    code: 'EBB',
    name_ja: 'エンテベ',
    name_en: 'ENTEBBE/KAMPALA',
    area_code: 'afr',
    country_code: 'UG',
    flag: 1,
    display: null,
    air_city_code: 'EBB',
  },
  {
    code: 'OAX',
    name_ja: 'オアハカ',
    name_en: 'OAXACA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'OAX',
  },
  {
    code: 'OUL',
    name_ja: 'オウル',
    name_en: 'OULU',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'OUL',
  },
  {
    code: 'OKC',
    name_ja: 'オクラホマシティ',
    name_en: 'OKLAHOMA CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OKC',
  },
  {
    code: 'OGS',
    name_ja: 'オグデンズバーグ（ニューヨーク州）',
    name_en: 'OGDENSBURG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OGS',
  },
  {
    code: 'OSS',
    name_ja: 'オシ',
    name_en: 'OSH',
    area_code: 'asi',
    country_code: 'KG',
    flag: 1,
    display: null,
    air_city_code: 'OSS',
  },
  {
    code: 'OSH',
    name_ja: 'オシュコシュ（ウイスコンシン州）',
    name_en: 'OSHKOSH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OSH',
  },
  {
    code: 'OSR',
    name_ja: 'オストラバ',
    name_en: 'OSTRAVA',
    area_code: 'eur',
    country_code: 'CZ',
    flag: 1,
    display: null,
    air_city_code: 'OSR',
  },
  {
    code: 'OSL',
    name_ja: 'オスロ',
    name_en: 'OSLO',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: 1,
    air_city_code: 'OSL',
  },
  {
    code: 'OTM',
    name_ja: 'オタムア',
    name_en: 'OTTUMWA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OTM',
  },
  {
    code: 'YOW',
    name_ja: 'オタワ',
    name_en: 'OTTAWA',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YOW',
  },
  {
    code: 'OXR',
    name_ja: 'オックスナード',
    name_en: 'OXNARD/VENTURA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OXR',
  },
  {
    code: 'ODS',
    name_ja: 'オデッサ',
    name_en: 'ODESSA',
    area_code: 'eur',
    country_code: 'UA',
    flag: 1,
    display: null,
    air_city_code: 'ODS',
  },
  {
    code: 'ODE',
    name_ja: 'オデンセ',
    name_en: 'ODENSE',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'ODE',
  },
  {
    code: 'OMA',
    name_ja: 'オマハ',
    name_en: 'OMAHA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OMA',
  },
  {
    code: 'OAM',
    name_ja: 'オマル',
    name_en: 'OAMARU',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'OAM',
  },
  {
    code: 'OLB',
    name_ja: 'オルビア',
    name_en: 'OLBIA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'OLB',
  },
  {
    code: 'OER',
    name_ja: 'オルンスコルドスビーク',
    name_en: 'ORNSKOLDSVIK',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'OER',
  },
  {
    code: 'OMH',
    name_ja: 'オルーミーイェ',
    name_en: 'URMIEH',
    area_code: 'afr',
    country_code: 'IR',
    flag: 1,
    display: null,
    air_city_code: 'OMH',
  },
  {
    code: 'OAG',
    name_ja: 'オレンジ',
    name_en: 'ORANGE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'OAG',
  },
  {
    code: 'ONT',
    name_ja: 'オンタリオ',
    name_en: 'ONTARIO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ONT',
  },
  {
    code: 'OWB',
    name_ja: 'オーエンズボロ',
    name_en: 'OWENSBORO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OWB',
  },
  {
    code: 'AGS',
    name_ja: 'オーガスタ（ジョージア州）',
    name_en: 'AUGUSTA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AGS',
  },
  {
    code: 'AUG',
    name_ja: 'オーガスタ（メイン州）',
    name_en: 'AUGUSTA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AUG',
  },
  {
    code: 'ODW',
    name_ja: 'オークハーバー（ワシントン州）',
    name_en: 'OAK HARBOR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ODW',
  },
  {
    code: 'AKL',
    name_ja: 'オークランド',
    name_en: 'AUCKLAND',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: 1,
    air_city_code: 'AKL',
  },
  {
    code: 'OAK',
    name_ja: 'オークランド（カリフォルニア州）',
    name_en: 'OAKLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OAK',
  },
  {
    code: 'EAU',
    name_ja: 'オークレアー',
    name_en: 'EAU CLAIR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EAU',
  },
  {
    code: 'AUS',
    name_ja: 'オースティン',
    name_en: 'AUSTIN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AUS',
  },
  {
    code: 'ORL',
    name_ja: 'オーランド',
    name_en: 'ORLANDO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ORL',
  },
  {
    code: 'AAR',
    name_ja: 'オールフス',
    name_en: 'AARHUS',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'AAR',
  },
  {
    code: 'ABX',
    name_ja: 'オールベリ',
    name_en: 'ALBURY',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'ABX',
  },
  {
    code: 'AAL',
    name_ja: 'オールボーグ',
    name_en: 'AALBORG',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'AAL',
  },
  {
    code: 'AES',
    name_ja: 'オーレスン',
    name_en: 'AALESUND',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'AES',
  },
  {
    code: 'CAY',
    name_ja: 'カイエンヌ',
    name_en: 'CAYENNE',
    area_code: 'sam',
    country_code: 'GF',
    flag: 1,
    display: null,
    air_city_code: 'CAY',
  },
  {
    code: 'ASR',
    name_ja: 'カイセリ',
    name_en: 'KAYSERI',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'ASR',
  },
  {
    code: 'KAT',
    name_ja: 'カイタイア',
    name_en: 'KAITAIA',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'KAT',
  },
  {
    code: 'CAI',
    name_ja: 'カイロ',
    name_en: 'CAIRO',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: 1,
    air_city_code: 'CAI',
  },
  {
    code: 'KHH',
    name_ja: 'カオシュン（高雄）',
    name_en: 'KAOHSIUNG',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: 2,
    air_city_code: 'KHH',
  },
  {
    code: 'CGY',
    name_ja: 'カガヤンデオロ',
    name_en: 'CAGAYAN DE ORO',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'CGY',
  },
  {
    code: 'BBK',
    name_ja: 'カサネ',
    name_en: 'KASANE',
    area_code: 'afr',
    country_code: 'BW',
    flag: 1,
    display: null,
    air_city_code: 'BBK',
  },
  {
    code: 'CAS',
    name_ja: 'カサブランカ',
    name_en: 'CASABLANCA',
    area_code: 'afr',
    country_code: 'MA',
    flag: 1,
    display: 1,
    air_city_code: 'CAS',
  },
  {
    code: 'KZN',
    name_ja: 'カザン',
    name_en: 'KAZAN',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'KZN',
  },
  {
    code: 'KHG',
    name_ja: 'カシュガル',
    name_en: 'KASHI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'KHG',
  },
  {
    code: 'HJR',
    name_ja: 'カジュラホ',
    name_en: 'KHAJURAHO',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'HJR',
  },
  {
    code: 'CAC',
    name_ja: 'カスカヴェル',
    name_en: 'CASCAVEL',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'CAC',
  },
  {
    code: 'CPR',
    name_ja: 'カスパー',
    name_en: 'CASPER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CPR',
  },
  {
    code: 'YCG',
    name_ja: 'カスルガー',
    name_en: 'CASTLEGAR',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YCG',
  },
  {
    code: 'CTA',
    name_ja: 'カタニア',
    name_en: 'CATANIA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'CTA',
  },
  {
    code: 'KTM',
    name_ja: 'カトマンズ',
    name_en: 'KATHMANDU',
    area_code: 'asi',
    country_code: 'NP',
    flag: 1,
    display: 1,
    air_city_code: 'KTM',
  },
  {
    code: 'KTW',
    name_ja: 'カトヴィーツエ',
    name_en: 'KATOWICE',
    area_code: 'eur',
    country_code: 'PL',
    flag: 1,
    display: null,
    air_city_code: 'KTW',
  },
  {
    code: 'CAJ',
    name_ja: 'カナイマ',
    name_en: 'CANAIMA',
    area_code: 'sam',
    country_code: 'VE',
    flag: 1,
    display: null,
    air_city_code: 'CAJ',
  },
  {
    code: 'JHM',
    name_ja: 'カパルア（マウイ島）',
    name_en: 'KAPALUA',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 3,
    air_city_code: 'JHM',
  },
  {
    code: 'KVG',
    name_ja: 'カビエン',
    name_en: 'KAVIENG',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'KVG',
  },
  {
    code: 'OGG',
    name_ja: 'カフルイ（マウイ島）',
    name_en: 'KAHULUI (MAUI)',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 4,
    air_city_code: 'OGG',
  },
  {
    code: 'KBL',
    name_ja: 'カブール',
    name_en: 'KABUL',
    area_code: 'asi',
    country_code: 'AF',
    flag: 1,
    display: null,
    air_city_code: 'KBL',
  },
  {
    code: 'CAH',
    name_ja: 'カマウ',
    name_en: 'CA MAU',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'CAH',
  },
  {
    code: 'CDH',
    name_ja: 'カムデン',
    name_en: 'CAMDEN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CDH',
  },
  {
    code: 'YKA',
    name_ja: 'カムル－プス',
    name_en: 'KAMLOOPS',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YKA',
  },
  {
    code: 'KAJ',
    name_ja: 'カヤーニ',
    name_en: 'KAJAANI',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'KAJ',
  },
  {
    code: 'CCS',
    name_ja: 'カラカス',
    name_en: 'CARACAS',
    area_code: 'sam',
    country_code: 'VE',
    flag: 1,
    display: null,
    air_city_code: 'CCS',
  },
  {
    code: 'KHI',
    name_ja: 'カラチ',
    name_en: 'KARACHI',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'KHI',
  },
  {
    code: 'KRP',
    name_ja: 'カラップ',
    name_en: 'KARUP',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'KRP',
  },
  {
    code: 'AZO',
    name_ja: 'カラマズー',
    name_en: 'KALAMAZOO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AZO',
  },
  {
    code: 'CLO',
    name_ja: 'カリ',
    name_en: 'CALI',
    area_code: 'sam',
    country_code: 'CO',
    flag: 1,
    display: null,
    air_city_code: 'CLO',
  },
  {
    code: 'CCJ',
    name_ja: 'カリカット',
    name_en: 'CALICUT',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'CCJ',
  },
  {
    code: 'FCA',
    name_ja: 'カリスペル',
    name_en: 'KALISPELL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FCA',
  },
  {
    code: 'KAB',
    name_ja: 'カリバ',
    name_en: 'KARIBA',
    area_code: 'afr',
    country_code: 'ZW',
    flag: 1,
    display: null,
    air_city_code: 'KAB',
  },
  {
    code: 'KLO',
    name_ja: 'カリボ',
    name_en: 'KALIBO',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'KLO',
  },
  {
    code: 'CAG',
    name_ja: 'カルアーリ',
    name_en: 'CAGLIAN',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'CAG',
  },
  {
    code: 'CCU',
    name_ja: 'カルカッタ',
    name_en: 'KOLKATA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'CCU',
  },
  {
    code: 'YYC',
    name_ja: 'カルガリー',
    name_en: 'CALGARY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYC',
  },
  {
    code: 'KGI',
    name_ja: 'カルグーリー',
    name_en: 'KALGOORLIE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'KGI',
  },
  {
    code: 'KSY',
    name_ja: 'カルス',
    name_en: 'KARS',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'KSY',
  },
  {
    code: 'KLR',
    name_ja: 'カルマー',
    name_en: 'KALMAR',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'KLR',
  },
  {
    code: 'KLV',
    name_ja: 'カルロヴィ・ヴァリ',
    name_en: 'KARLOVY VARY',
    area_code: 'eur',
    country_code: 'CZ',
    flag: 1,
    display: null,
    air_city_code: 'KLV',
  },
  {
    code: 'CLY',
    name_ja: 'カルヴィ',
    name_en: 'CALVI',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'CLY',
  },
  {
    code: 'CXL',
    name_ja: 'カレクシコ',
    name_en: 'CALEXICO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CXL',
  },
  {
    code: 'CLL',
    name_ja: 'カレッジステーション',
    name_en: 'COLLEGE STATION',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CLL',
  },
  {
    code: 'CUN',
    name_ja: 'カンクン',
    name_en: 'CANCUN',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CUN',
  },
  {
    code: 'SFJ',
    name_ja: 'カンゲルルススアーク',
    name_en: 'KANGERLUSSAQ',
    area_code: 'eur',
    country_code: 'GL',
    flag: 1,
    display: null,
    air_city_code: 'SFJ',
  },
  {
    code: 'MKC',
    name_ja: 'カンサスシティ（ミズーリ州',
    name_en: 'KANSAS CITY(MO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MKC',
  },
  {
    code: 'VCA',
    name_ja: 'カントー',
    name_en: 'CAN THO',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'VCA',
  },
  {
    code: 'KDR',
    name_ja: 'カンドリアン',
    name_en: 'KANDRIAN',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'KDR',
  },
  {
    code: 'CEQ',
    name_ja: 'カンヌ',
    name_en: 'CANNES',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'CEQ',
  },
  {
    code: 'KAG',
    name_ja: 'カンヌン',
    name_en: 'KANGNUNG',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'KAG',
  },
  {
    code: 'CPE',
    name_ja: 'カンペチェ',
    name_en: 'CAMPECHE',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CPE',
  },
  {
    code: 'UIP',
    name_ja: 'カンペール',
    name_en: 'QUIMPER',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'UIP',
  },
  {
    code: 'CGR',
    name_ja: 'カンポグランデ',
    name_en: 'CAMPO GRANDE',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'CGR',
  },
  {
    code: 'KOW',
    name_ja: 'カン州黄金機場',
    name_en: 'GANZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'KOW',
  },
  {
    code: 'KOI',
    name_ja: 'カークウォール',
    name_en: 'KIRKWALL',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'KOI',
  },
  {
    code: 'IRK',
    name_ja: 'カークスビル',
    name_en: 'KIRKSVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IRK',
  },
  {
    code: 'CTG',
    name_ja: 'カータジェナ',
    name_en: 'CARTAGENA',
    area_code: 'sam',
    country_code: 'CO',
    flag: 1,
    display: null,
    air_city_code: 'CTG',
  },
  {
    code: 'KAN',
    name_ja: 'カーノ',
    name_en: 'KANO',
    area_code: 'afr',
    country_code: 'NG',
    flag: 1,
    display: null,
    air_city_code: 'KAN',
  },
  {
    code: 'MDH',
    name_ja: 'カーボンデール（イリノイ州）',
    name_en: 'CARBONDALE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MDH',
  },
  {
    code: 'CAX',
    name_ja: 'カーライル',
    name_en: 'CARLISLE',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'CAX',
  },
  {
    code: 'KSD',
    name_ja: 'カールスタッド',
    name_en: 'KARLSTAD',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'KSD',
  },
  {
    code: 'CLD',
    name_ja: 'カールスバッド（カリフォルニア州）',
    name_en: 'CARLSBAD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CLD',
  },
  {
    code: 'CNM',
    name_ja: 'カールスバッド（ニューメキシコ州）',
    name_en: 'CARLSBAD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CNM',
  },
  {
    code: 'CWL',
    name_ja: 'カ－ディフ',
    name_en: 'CARDIFF',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'CWL',
  },
  {
    code: 'GAU',
    name_ja: 'ガウハチ',
    name_en: 'GAUHATI',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'GAU',
  },
  {
    code: 'GZT',
    name_ja: 'ガジアンテップ',
    name_en: 'GAZIANTEP',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'GZT',
  },
  {
    code: 'GST',
    name_ja: 'ガステイヴァス',
    name_en: 'GUSTAVUS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GST',
  },
  {
    code: 'YGP',
    name_ja: 'ガスペ',
    name_en: 'GASPE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YGP',
  },
  {
    code: 'ELQ',
    name_ja: 'ガッシム',
    name_en: 'GASSIM',
    area_code: 'afr',
    country_code: 'SA',
    flag: 1,
    display: null,
    air_city_code: 'ELQ',
  },
  {
    code: 'GAD',
    name_ja: 'ガッズデン',
    name_en: 'GADSDEN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GAD',
  },
  {
    code: 'GUC',
    name_ja: 'ガニソン',
    name_en: 'GUNNISON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GUC',
  },
  {
    code: 'GAY',
    name_ja: 'ガヤ',
    name_en: 'GAYA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'GAY',
  },
  {
    code: 'GPS',
    name_ja: 'ガラパゴス島',
    name_en: 'GALAPAGPS ISLAND',
    area_code: 'sam',
    country_code: 'EC',
    flag: 1,
    display: null,
    air_city_code: 'GPS',
  },
  {
    code: 'GPT',
    name_ja: 'ガルフポート',
    name_en: 'GULFPORT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GPT',
  },
  {
    code: 'YQX',
    name_ja: 'ガンダー',
    name_en: 'GANDER',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQX',
  },
  {
    code: 'GCK',
    name_ja: 'ガーデンシティ',
    name_en: 'GARDEN CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GCK',
  },
  {
    code: 'GCI',
    name_ja: 'ガーンジィー',
    name_en: 'GUERNSEY',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'GCI',
  },
  {
    code: 'IEV',
    name_ja: 'キエフ',
    name_en: 'KIEV',
    area_code: 'eur',
    country_code: 'UA',
    flag: 1,
    display: null,
    air_city_code: 'IEV',
  },
  {
    code: 'KGL',
    name_ja: 'キガリ',
    name_en: 'KIGALI',
    area_code: 'afr',
    country_code: 'RW',
    flag: 1,
    display: null,
    air_city_code: 'KGL',
  },
  {
    code: 'KIV',
    name_ja: 'キシニョフ',
    name_en: 'CHISINAU',
    area_code: 'eur',
    country_code: 'MD',
    flag: 1,
    display: null,
    air_city_code: 'KIV',
  },
  {
    code: 'KIH',
    name_ja: 'キッシュアイランド',
    name_en: 'KISH ISLAND',
    area_code: 'afr',
    country_code: 'IR',
    flag: 1,
    display: null,
    air_city_code: 'KIH',
  },
  {
    code: 'KTT',
    name_ja: 'キッティラ',
    name_en: 'KITTILA',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'KTT',
  },
  {
    code: 'UIO',
    name_ja: 'キト',
    name_en: 'QUITO',
    area_code: 'sam',
    country_code: 'EC',
    flag: 1,
    display: null,
    air_city_code: 'UIO',
  },
  {
    code: 'KTR',
    name_ja: 'キャサリン',
    name_en: 'KATHERINE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'KTR',
  },
  {
    code: 'CAD',
    name_ja: 'キャディラック',
    name_en: 'CADILLAC',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CAD',
  },
  {
    code: 'CAM',
    name_ja: 'キャメロンハイランド',
    name_en: 'CAMERON HIGHLANDS',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'KUL',
  },
  {
    code: 'CBR',
    name_ja: 'キャンベラ',
    name_en: 'CANBERRA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'CBR',
  },
  {
    code: 'YBL',
    name_ja: 'キャンベルリバー',
    name_en: 'CAMPBELL RIVER',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YBL',
  },
  {
    code: 'CUR',
    name_ja: 'キュラソー島',
    name_en: 'CURACAO',
    area_code: 'eur',
    country_code: 'NL',
    flag: 1,
    display: null,
    air_city_code: 'CUR',
  },
  {
    code: 'JRO',
    name_ja: 'キリマンジャロ',
    name_en: 'KILIMANJARO',
    area_code: 'afr',
    country_code: 'TZ',
    flag: 1,
    display: null,
    air_city_code: 'JRO',
  },
  {
    code: 'ILE',
    name_ja: 'キリーン',
    name_en: 'KILLEEN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ILE',
  },
  {
    code: 'GRK',
    name_ja: 'キリーン・フォート・フット',
    name_en: 'GRAY AAF',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GRK',
  },
  {
    code: 'KKN',
    name_ja: 'キルケネス',
    name_en: 'KIRKENES',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'KKN',
  },
  {
    code: 'KRN',
    name_ja: 'キルナ',
    name_en: 'KIRUNA',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'KRN',
  },
  {
    code: 'KCK',
    name_ja: 'キレンスク',
    name_en: 'Kirensk',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'KCK',
  },
  {
    code: 'AKN',
    name_ja: 'キングサーモン',
    name_en: 'KING SALMON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'AKN',
  },
  {
    code: 'KGC',
    name_ja: 'キングスコート',
    name_en: 'KINGSCOTE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'KGC',
  },
  {
    code: 'YGK',
    name_ja: 'キングストン',
    name_en: 'KINGSTON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YGK',
  },
  {
    code: 'KIN',
    name_ja: 'キングストン',
    name_en: 'KINGSTON',
    area_code: 'sam',
    country_code: 'JM',
    flag: 1,
    display: 1,
    air_city_code: 'KIN',
  },
  {
    code: 'IGM',
    name_ja: 'キングマン（アリゾナ州）',
    name_en: 'KINGMAN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IGM',
  },
  {
    code: 'FIH',
    name_ja: 'キンシャシャ',
    name_en: 'KINSHASA',
    area_code: 'afr',
    country_code: 'CG',
    flag: 1,
    display: null,
    air_city_code: 'FIH',
  },
  {
    code: 'ISO',
    name_ja: 'キンストン',
    name_en: 'KINSTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ISO',
  },
  {
    code: 'KIM',
    name_ja: 'キンバリー',
    name_en: 'KIMBERLEY',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'KIM',
  },
  {
    code: 'EAR',
    name_ja: 'キーアニー',
    name_en: 'KEARNEY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EAR',
  },
  {
    code: 'EYW',
    name_ja: 'キーウェスト',
    name_en: 'KEY WEST',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EYW',
  },
  {
    code: 'ENA',
    name_ja: 'キーナイ',
    name_en: 'KENAI',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ENA',
  },
  {
    code: 'KEL',
    name_ja: 'キール',
    name_en: 'KIEL',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'KEL',
  },
  {
    code: 'EEN',
    name_ja: 'キーン',
    name_en: 'KEENE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EEN',
  },
  {
    code: 'GIS',
    name_ja: 'ギスボーン',
    name_en: 'GISBORNE',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'GIS',
  },
  {
    code: 'GUP',
    name_ja: 'ギャラップ',
    name_en: 'GALLUP',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GUP',
  },
  {
    code: 'TGG',
    name_ja: 'クアラトレンガヌ',
    name_en: 'KUALA TERENGGANU',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'TGG',
  },
  {
    code: 'KUL',
    name_ja: 'クアラルンプール',
    name_en: 'KUALA LUMPUR',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: 1,
    air_city_code: 'KUL',
  },
  {
    code: 'VN2',
    name_ja: 'クアロー',
    name_en: 'Cua Lo',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'VII',
  },
  {
    code: 'KUA',
    name_ja: 'クアンタン',
    name_en: 'KUANTAN',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'KUA',
  },
  {
    code: 'UEE',
    name_ja: 'クィーンズタウン',
    name_en: 'QUEENSTOWN',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: 6,
    air_city_code: 'UEE',
  },
  {
    code: 'ZQN',
    name_ja: 'クィーンズタウン',
    name_en: 'QUEENSTOWN',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: 3,
    air_city_code: 'ZQN',
  },
  {
    code: 'CGB',
    name_ja: 'クイアバ',
    name_en: 'CUIABA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'CGB',
  },
  {
    code: 'UIH',
    name_ja: 'クイニョン',
    name_en: 'QUI NHON',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'UIH',
  },
  {
    code: 'YQZ',
    name_ja: 'クイネル',
    name_en: 'QUESNEL',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQZ',
  },
  {
    code: 'KWL',
    name_ja: 'クイリン（桂林）',
    name_en: 'GUILIN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'KWL',
  },
  {
    code: 'UIN',
    name_ja: 'クインシー（イリノイ州）',
    name_en: 'QUINCY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'UIN',
  },
  {
    code: 'KWI',
    name_ja: 'クウェート',
    name_en: 'KUWAIT',
    area_code: 'afr',
    country_code: 'KW',
    flag: 1,
    display: null,
    air_city_code: 'KWI',
  },
  {
    code: 'KWA',
    name_ja: 'クェゼリン',
    name_en: 'KWAJALEIN',
    area_code: 'mic',
    country_code: 'MH',
    flag: 1,
    display: null,
    air_city_code: 'KWA',
  },
  {
    code: 'CUE',
    name_ja: 'クエンカ',
    name_en: 'CUENCA',
    area_code: 'sam',
    country_code: 'EC',
    flag: 1,
    display: null,
    air_city_code: 'CUE',
  },
  {
    code: 'KUO',
    name_ja: 'クオピオ',
    name_en: 'KUOPIO',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'KUO',
  },
  {
    code: 'CUZ',
    name_ja: 'クスコ',
    name_en: 'CUSCO',
    area_code: 'sam',
    country_code: 'PE',
    flag: 1,
    display: 3,
    air_city_code: 'CUZ',
  },
  {
    code: 'GDN',
    name_ja: 'クダンスク',
    name_en: 'GDANSK',
    area_code: 'eur',
    country_code: 'PL',
    flag: 1,
    display: null,
    air_city_code: 'GDN',
  },
  {
    code: 'KCH',
    name_ja: 'クチン',
    name_en: 'KUCHING',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'KCH',
  },
  {
    code: 'KNX',
    name_ja: 'クヌヌーラ',
    name_en: 'KUNUNURRA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'KNX',
  },
  {
    code: 'KOE',
    name_ja: 'クパン',
    name_en: 'KAPANG',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'KOE',
  },
  {
    code: 'CGA',
    name_ja: 'クライグ',
    name_en: 'CRAIG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CGA',
  },
  {
    code: 'CHC',
    name_ja: 'クライストチャーチ',
    name_en: 'CHRISTCHURCH',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: 2,
    air_city_code: 'CHC',
  },
  {
    code: 'PLQ',
    name_ja: 'クライペダ',
    name_en: 'KLAIPEDA',
    area_code: 'eur',
    country_code: 'LT',
    flag: 1,
    display: null,
    air_city_code: 'PLQ',
  },
  {
    code: 'KRK',
    name_ja: 'クラクフ',
    name_en: 'KRAKOW',
    area_code: 'eur',
    country_code: 'PL',
    flag: 1,
    display: null,
    air_city_code: 'KRK',
  },
  {
    code: 'KRR',
    name_ja: 'クラスノダール',
    name_en: 'KRASNODAR',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'KRR',
  },
  {
    code: 'KJA',
    name_ja: 'クラスノヤルスク',
    name_en: 'KRASNOJARSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'KJA',
  },
  {
    code: 'CKV',
    name_ja: 'クラックスビル',
    name_en: 'CLACKSVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CKV',
  },
  {
    code: 'KBV',
    name_ja: 'クラビ',
    name_en: 'KRABI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'KBV',
  },
  {
    code: 'LMT',
    name_ja: 'クラマスフォールズ',
    name_en: 'KLAMATH HALLS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LMT',
  },
  {
    code: 'KRF',
    name_ja: 'クラムフォシュ',
    name_en: 'KRAMFORS',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'KRF',
  },
  {
    code: 'YXC',
    name_ja: 'クランブルック',
    name_en: 'CRANBROOK',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YXC',
  },
  {
    code: 'CKB',
    name_ja: 'クラークスバーグ',
    name_en: 'CLARKSBURG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CKB',
  },
  {
    code: 'KLU',
    name_ja: 'クラーゲンフルト',
    name_en: 'KLAGENFURT',
    area_code: 'eur',
    country_code: 'AT',
    flag: 1,
    display: null,
    air_city_code: 'KLU',
  },
  {
    code: 'CUL',
    name_ja: 'クリアカン',
    name_en: 'CULIACAN',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CUL',
  },
  {
    code: 'CFE',
    name_ja: 'クリアモントフェランド',
    name_en: 'CLERMONT FERRAND',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'CFE',
  },
  {
    code: 'KRS',
    name_ja: 'クリスチャンサン',
    name_en: 'KRISTIANSAND',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'KRS',
  },
  {
    code: 'KSU',
    name_ja: 'クリティアンスン',
    name_en: 'KRISTIANSUND',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'KSU',
  },
  {
    code: 'CWB',
    name_ja: 'クリティーバ',
    name_en: 'CURITIBA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'CWB',
  },
  {
    code: 'CWI',
    name_ja: 'クリントン（アイオワ州）',
    name_en: 'CLINTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CWI',
  },
  {
    code: 'CLE',
    name_ja: 'クリーブランド',
    name_en: 'CLEVELAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CLE',
  },
  {
    code: 'CLJ',
    name_ja: 'クルナポカ',
    name_en: 'CLUJ NAPOCA',
    area_code: 'eur',
    country_code: 'RO',
    flag: 1,
    display: null,
    air_city_code: 'CLJ',
  },
  {
    code: 'CEC',
    name_ja: 'クレセントシティ',
    name_en: 'CRESCENT CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CEC',
  },
  {
    code: 'CRI',
    name_ja: 'クロックド島',
    name_en: 'CROOKED ISLAND',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'CRI',
  },
  {
    code: 'CVN',
    name_ja: 'クロビス',
    name_en: 'CLOVIS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CVN',
  },
  {
    code: 'CAN',
    name_ja: 'クワンチョウ（広州）',
    name_en: 'GUANGZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 5,
    air_city_code: 'CAN',
  },
  {
    code: 'KMG',
    name_ja: 'クンミン（昆明）',
    name_en: 'KUNMING',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'KMG',
  },
  {
    code: 'CDA',
    name_ja: 'クーインダ',
    name_en: 'COOINDA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'CDA',
  },
  {
    code: 'KAO',
    name_ja: 'クーサモ',
    name_en: 'KUUSAMO',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'KAO',
  },
  {
    code: 'COJ',
    name_ja: 'クーナバラブラン',
    name_en: 'COONABARABRAN',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'COJ',
  },
  {
    code: 'CUF',
    name_ja: 'クーネオ',
    name_en: 'CUNEO',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'CUF',
  },
  {
    code: 'OOM',
    name_ja: 'クーマ',
    name_en: 'COOMA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'OOM',
  },
  {
    code: 'GDL',
    name_ja: 'グアダラハラ',
    name_en: 'GUADALAJARA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'GDL',
  },
  {
    code: 'GUA',
    name_ja: 'グアテマラシティ',
    name_en: 'GUATEMALA CITY',
    area_code: 'sam',
    country_code: 'GT',
    flag: 1,
    display: null,
    air_city_code: 'GUA',
  },
  {
    code: 'GUM',
    name_ja: 'グアム',
    name_en: 'GUAM',
    area_code: 'mic',
    country_code: 'GU',
    flag: 1,
    display: null,
    air_city_code: 'GUM',
  },
  {
    code: 'GYE',
    name_ja: 'グアヤキル',
    name_en: 'GUAYAQUIL',
    area_code: 'sam',
    country_code: 'EC',
    flag: 1,
    display: null,
    air_city_code: 'GYE',
  },
  {
    code: 'GLD',
    name_ja: 'グッドランド',
    name_en: 'GOODLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GLD',
  },
  {
    code: 'GLA',
    name_ja: 'グラスゴー',
    name_en: 'GLASGOW',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: 5,
    air_city_code: 'GLA',
  },
  {
    code: 'GGW',
    name_ja: 'グラスゴー',
    name_en: 'GLASGOW',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GGW',
  },
  {
    code: 'GLT',
    name_ja: 'グラッドストーン',
    name_en: 'GLADSTONE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'GLT',
  },
  {
    code: 'GMT',
    name_ja: 'グラナイト・マウンテン',
    name_en: 'GRANITE MOUNTAIN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GMT',
  },
  {
    code: 'GRX',
    name_ja: 'グラナダ',
    name_en: 'GRANADA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'GRX',
  },
  {
    code: 'GFN',
    name_ja: 'グラフトン',
    name_en: 'GRAFTON',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'GFN',
  },
  {
    code: 'LPA',
    name_ja: 'グランカナリア島',
    name_en: 'GRAN CANARIA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'LPA',
  },
  {
    code: 'GRI',
    name_ja: 'グランドアイランド',
    name_en: 'GRAND ISLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GRI',
  },
  {
    code: 'GCN',
    name_ja: 'グランドキャニオン',
    name_en: 'GRAND CANYON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GCN',
  },
  {
    code: 'GCM',
    name_ja: 'グランドケイマン',
    name_en: 'GRAND CAYMAN',
    area_code: 'sam',
    country_code: 'KY',
    flag: 1,
    display: null,
    air_city_code: 'GCM',
  },
  {
    code: 'GJT',
    name_ja: 'グランドジャンクション',
    name_en: 'GRAND JUNCTION',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GJT',
  },
  {
    code: 'GDT',
    name_ja: 'グランドターク',
    name_en: 'GRAND TURK',
    area_code: 'sam',
    country_code: 'TC',
    flag: 1,
    display: null,
    air_city_code: 'GDT',
  },
  {
    code: 'GFK',
    name_ja: 'グランドフォークス',
    name_en: 'GRAND FORKS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GFK',
  },
  {
    code: 'YQU',
    name_ja: 'グランドプレーリー',
    name_en: 'GRANDE PRAIRIE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQU',
  },
  {
    code: 'GPZ',
    name_ja: 'グランドラピッズ',
    name_en: 'GRAND RAPIDS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GPZ',
  },
  {
    code: 'GRR',
    name_ja: 'グランドラピッズ',
    name_en: 'GRAND RAPIDS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GRR',
  },
  {
    code: 'GRZ',
    name_ja: 'グラーツ',
    name_en: 'GRAZ',
    area_code: 'eur',
    country_code: 'AT',
    flag: 1,
    display: null,
    air_city_code: 'GRZ',
  },
  {
    code: 'GFF',
    name_ja: 'グリフィス',
    name_en: 'GRIFFITH',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'GFF',
  },
  {
    code: 'GSO',
    name_ja: 'グリーンズボロ',
    name_en: 'GREENSBORO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GSO',
  },
  {
    code: 'GLH',
    name_ja: 'グリーンビル',
    name_en: 'GREENVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GLH',
  },
  {
    code: 'PGV',
    name_ja: 'グリーンビル',
    name_en: 'GREENVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PGV',
  },
  {
    code: 'GSP',
    name_ja: 'グリーンビル',
    name_en: 'GREENVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GSP',
  },
  {
    code: 'GRB',
    name_ja: 'グリーンベイ',
    name_en: 'GREEN BAY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GRB',
  },
  {
    code: 'GNB',
    name_ja: 'グルノーブル',
    name_en: 'GRENOBLE',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'GNB',
  },
  {
    code: 'GND',
    name_ja: 'グレナダ',
    name_en: 'GRENADA',
    area_code: 'sam',
    country_code: 'GD',
    flag: 1,
    display: null,
    air_city_code: 'GND',
  },
  {
    code: 'GDV',
    name_ja: 'グレンダイブ',
    name_en: 'GLENDIVE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GDV',
  },
  {
    code: 'GTF',
    name_ja: 'グレートフォールズ（モンタナ州）',
    name_en: 'GREAT FALLS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GTF',
  },
  {
    code: 'GBD',
    name_ja: 'グレートベンド',
    name_en: 'GREAT BEND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GBD',
  },
  {
    code: 'YYR',
    name_ja: 'グーズベイ',
    name_en: 'GOOSE BAY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYR',
  },
  {
    code: 'CNS',
    name_ja: 'ケアンズ',
    name_en: 'CAIRNS',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: 4,
    air_city_code: 'CNS',
  },
  {
    code: 'CYB',
    name_ja: 'ケイマンブラック',
    name_en: 'CAYMAN BRAC',
    area_code: 'sam',
    country_code: 'KY',
    flag: 1,
    display: null,
    air_city_code: 'CYB',
  },
  {
    code: 'KTN',
    name_ja: 'ケチカン',
    name_en: 'KETCHIKAN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'KTN',
  },
  {
    code: 'KK1',
    name_ja: 'ケップ',
    name_en: '',
    area_code: 'asi',
    country_code: 'KH',
    flag: 1,
    display: null,
    air_city_code: 'PNH',
  },
  {
    code: 'EFL',
    name_ja: 'ケファロニア島',
    name_en: 'KEFALONIA',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'EFL',
  },
  {
    code: 'YQB',
    name_ja: 'ケベックシティ',
    name_en: 'QUEBEC',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: 1,
    air_city_code: 'YQB',
  },
  {
    code: 'KEM',
    name_ja: 'ケミ',
    name_en: 'KEMI',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'KEM',
  },
  {
    code: 'KEJ',
    name_ja: 'ケメロボ',
    name_en: 'KEMEROVO',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'KEJ',
  },
  {
    code: 'KKE',
    name_ja: 'ケリケリ',
    name_en: 'KERIKERI',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'KKE',
  },
  {
    code: 'KIR',
    name_ja: 'ケリーカントリー',
    name_en: 'KERRY COUNTRY',
    area_code: 'eur',
    country_code: 'IE',
    flag: 1,
    display: null,
    air_city_code: 'KIR',
  },
  {
    code: 'KTE',
    name_ja: 'ケルテ',
    name_en: 'KERTEH',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'KTE',
  },
  {
    code: 'CGN',
    name_ja: 'ケルン',
    name_en: 'COLOGNE',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: 5,
    air_city_code: 'CGN',
  },
  {
    code: 'QRO',
    name_ja: 'ケレタロ',
    name_en: 'QUERETARO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'MEX',
  },
  {
    code: 'YLW',
    name_ja: 'ケローナ',
    name_en: 'KELOWNA',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YLW',
  },
  {
    code: 'KDI',
    name_ja: 'ケンダリ',
    name_en: 'KENDARI',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'KDI',
  },
  {
    code: 'YCB',
    name_ja: 'ケンブリッジベイ',
    name_en: 'CAMBRIDGE BAY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YCB',
  },
  {
    code: 'CPT',
    name_ja: 'ケープタウン',
    name_en: 'CAPE TOWN',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: 1,
    air_city_code: 'CPT',
  },
  {
    code: 'GNV',
    name_ja: 'ゲインズビル',
    name_en: 'GAINESVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GNV',
  },
  {
    code: 'GUB',
    name_ja: 'ゲレロネグロ',
    name_en: 'GUERRERO NEGRO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'GUB',
  },
  {
    code: 'GTB',
    name_ja: 'ゲンティン',
    name_en: 'GENTING HIGHLANDS',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'GTB',
  },
  {
    code: 'GBG',
    name_ja: 'ゲールズバーグ（イリノイ州）',
    name_en: 'GALESBURG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GBG',
  },
  {
    code: 'GXQ',
    name_ja: 'コイハイケ',
    name_en: 'COYHAIQUE',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'GXQ',
  },
  {
    code: 'CJB',
    name_ja: 'コインバトーレ',
    name_en: 'COIMBATORE',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'CJB',
  },
  {
    code: 'OKK',
    name_ja: 'ココモ',
    name_en: 'KOKOMO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OKK',
  },
  {
    code: 'CCC',
    name_ja: 'ココ島',
    name_en: 'CAYO COCO',
    area_code: 'sam',
    country_code: 'CU',
    flag: 1,
    display: null,
    air_city_code: 'CCC',
  },
  {
    code: 'KSC',
    name_ja: 'コシツェ',
    name_en: 'KOSIGE',
    area_code: 'eur',
    country_code: 'SK',
    flag: 1,
    display: null,
    air_city_code: 'KSC',
  },
  {
    code: 'KGS',
    name_ja: 'コス',
    name_en: 'KOS',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'KGS',
  },
  {
    code: 'KSA',
    name_ja: 'コスラエ島',
    name_en: 'KOSRAE',
    area_code: 'mic',
    country_code: 'FM',
    flag: 1,
    display: null,
    air_city_code: 'KSA',
  },
  {
    code: 'CZM',
    name_ja: 'コズメル',
    name_en: 'COZUMEL',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CZM',
  },
  {
    code: 'BKI',
    name_ja: 'コタキナバル',
    name_en: 'KOTA KINABALU',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'BKI',
  },
  {
    code: 'CBO',
    name_ja: 'コタバト',
    name_en: 'COTABATO',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'CBO',
  },
  {
    code: 'KBR',
    name_ja: 'コタバル',
    name_en: 'KOTA BHARU',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'KBR',
  },
  {
    code: 'CBB',
    name_ja: 'コチャバンバ',
    name_en: 'COCHABAMBA',
    area_code: 'sam',
    country_code: 'BO',
    flag: 1,
    display: null,
    air_city_code: 'CBB',
  },
  {
    code: 'KOK',
    name_ja: 'コッコラ',
    name_en: 'KOKKOLA PIETARSAA',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'KOK',
  },
  {
    code: 'OTZ',
    name_ja: 'コッツェビュー',
    name_en: 'KOTZEBUE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OTZ',
  },
  {
    code: 'COD',
    name_ja: 'コディ',
    name_en: 'CODY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'COD',
  },
  {
    code: 'ADQ',
    name_ja: 'コディアック',
    name_en: 'KODIAK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ADQ',
  },
  {
    code: 'COO',
    name_ja: 'コトヌ',
    name_en: 'COTONOU',
    area_code: 'afr',
    country_code: 'BJ',
    flag: 1,
    display: null,
    air_city_code: 'COO',
  },
  {
    code: 'CKY',
    name_ja: 'コナクリー',
    name_en: 'CONAKRY',
    area_code: 'afr',
    country_code: 'GN',
    flag: 1,
    display: null,
    air_city_code: 'CKY',
  },
  {
    code: 'KOA',
    name_ja: 'コナ（ハワイ島）',
    name_en: 'KONA (HAWAII)',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 5,
    air_city_code: 'KOA',
  },
  {
    code: 'CAZ',
    name_ja: 'コバー',
    name_en: 'COBAR',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'CAZ',
  },
  {
    code: 'CPO',
    name_ja: 'コピアポ',
    name_en: 'COPIAPO',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'CPO',
  },
  {
    code: 'CFS',
    name_ja: 'コフスハーバー',
    name_en: 'COFFS HARBOUR',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'CFS',
  },
  {
    code: 'CPH',
    name_ja: 'コペンハーゲン',
    name_en: 'COPENHAGEN',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: 1,
    air_city_code: 'CPH',
  },
  {
    code: 'YQQ',
    name_ja: 'コモックス',
    name_en: 'COMOX',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQQ',
  },
  {
    code: 'CLQ',
    name_ja: 'コリマ',
    name_en: 'COLIMA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CLQ',
  },
  {
    code: 'COR',
    name_ja: 'コルドバ',
    name_en: 'CORDOBA',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'COR',
  },
  {
    code: 'CDV',
    name_ja: 'コルドバ',
    name_en: 'CORDOVA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CDV',
  },
  {
    code: 'CFU',
    name_ja: 'コルフ',
    name_en: 'CORFU',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'CFU',
  },
  {
    code: 'COS',
    name_ja: 'コロラドスプリングス',
    name_en: 'COLORADO SPRINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'COS',
  },
  {
    code: 'CMH',
    name_ja: 'コロンバス（オハイオ州）',
    name_en: 'COLUMBUS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CMH',
  },
  {
    code: 'CSG',
    name_ja: 'コロンバス（ジョージア州）',
    name_en: 'COLUMBUS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CSG',
  },
  {
    code: 'OLU',
    name_ja: 'コロンバス（ネブラスカ州）',
    name_en: 'COLUMBUS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OLU',
  },
  {
    code: 'GTR',
    name_ja: 'コロンバス（ミシシッピ州）',
    name_en: 'COLUMBUS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GTR',
  },
  {
    code: 'CAE',
    name_ja: 'コロンビア（サウスカロライナ州）',
    name_en: 'COLUMBIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CAE',
  },
  {
    code: 'COU',
    name_ja: 'コロンビア（ミズーリ州）',
    name_en: 'COLUMBIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'COU',
  },
  {
    code: 'CMB',
    name_ja: 'コロンボ',
    name_en: 'COLOMBO',
    area_code: 'asi',
    country_code: 'LK',
    flag: 1,
    display: null,
    air_city_code: 'CMB',
  },
  {
    code: 'ROR',
    name_ja: 'コロール',
    name_en: 'KOROR',
    area_code: 'mic',
    country_code: 'PW',
    flag: 1,
    display: null,
    air_city_code: 'ROR',
  },
  {
    code: 'KKC',
    name_ja: 'コンカン',
    name_en: 'KHON KAEN',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'KKC',
  },
  {
    code: 'CCR',
    name_ja: 'コンコート',
    name_en: 'CONCORD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CCR',
  },
  {
    code: 'CCP',
    name_ja: 'コンセプシオン',
    name_en: 'CONCEPCION',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'CCP',
  },
  {
    code: 'VCS',
    name_ja: 'コンダオ島',
    name_en: 'CON DAO ISLAND',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'VCS',
  },
  {
    code: 'CBE',
    name_ja: 'コンバーランド',
    name_en: 'CUMBERLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CBE',
  },
  {
    code: 'KYA',
    name_ja: 'コンヤ',
    name_en: 'KONYA',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'KYA',
  },
  {
    code: 'ORK',
    name_ja: 'コーク',
    name_en: 'CORK',
    area_code: 'eur',
    country_code: 'IE',
    flag: 1,
    display: null,
    air_city_code: 'ORK',
  },
  {
    code: 'COK',
    name_ja: 'コーチン',
    name_en: 'COCHIN',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'COK',
  },
  {
    code: 'YCF',
    name_ja: 'コーツアイランド',
    name_en: 'CORTES DAY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YCF',
  },
  {
    code: 'CEZ',
    name_ja: 'コーデス',
    name_en: 'CORTEZ',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CEZ',
  },
  {
    code: 'COE',
    name_ja: 'コードラン',
    name_en: 'COEUR D&rsquo;AIENE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'COE',
  },
  {
    code: 'USM',
    name_ja: 'コ－サムイ（サムイ島）',
    name_en: 'KOH SAMUI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: 4,
    air_city_code: 'USM',
  },
  {
    code: 'CRP',
    name_ja: 'コ－パスクリスティ－',
    name_en: 'CORPUS CHRISTI',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CRP',
  },
  {
    code: 'GOI',
    name_ja: 'ゴア',
    name_en: 'GOA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'GOI',
  },
  {
    code: 'GHB',
    name_ja: 'ゴベルナーズハーバー',
    name_en: 'GOVERNORS HARBOUR',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'GHB',
  },
  {
    code: 'GKA',
    name_ja: 'ゴロカ',
    name_en: 'GOROKA',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'GKA',
  },
  {
    code: 'GYN',
    name_ja: 'ゴーニャ',
    name_en: 'GOIANIA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'GYN',
  },
  {
    code: 'GWY',
    name_ja: 'ゴールウェイ',
    name_en: 'GALWAY',
    area_code: 'eur',
    country_code: 'IE',
    flag: 1,
    display: null,
    air_city_code: 'GWY',
  },
  {
    code: 'OOL',
    name_ja: 'ゴールドコースト',
    name_en: 'GOLD COAST',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: 3,
    air_city_code: 'OOL',
  },
  {
    code: 'SPN',
    name_ja: 'サイパン',
    name_en: 'SAIPAN',
    area_code: 'mic',
    country_code: 'MP',
    flag: 1,
    display: null,
    air_city_code: 'SPN',
  },
  {
    code: 'SOU',
    name_ja: 'サウサンプトン',
    name_en: 'SOUTHAMPTON',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'SOU',
  },
  {
    code: 'TZN',
    name_ja: 'サウスアンドロス',
    name_en: 'SOUTH ANDROS',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'TZN',
  },
  {
    code: 'SBN',
    name_ja: 'サウスベンド',
    name_en: 'SOUTH BEND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SBN',
  },
  {
    code: 'TVL',
    name_ja: 'サウスレイクタホ',
    name_en: 'SOUTH LAKE TAHOE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TVL',
  },
  {
    code: 'ZCL',
    name_ja: 'サカテラス',
    name_en: 'ZACATECAS',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'ZCL',
  },
  {
    code: 'MBS',
    name_ja: 'サギノー',
    name_en: 'SAGINAW',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MBS',
  },
  {
    code: 'SMF',
    name_ja: 'サクラメント',
    name_en: 'SACRAMENTO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SMF',
  },
  {
    code: 'SNO',
    name_ja: 'サコンナコーン',
    name_en: 'SAKON NAKHON',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'SNO',
  },
  {
    code: 'YXE',
    name_ja: 'サスカトゥーン',
    name_en: 'SASKATOON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YXE',
  },
  {
    code: 'YSB',
    name_ja: 'サドバリー',
    name_en: 'SUDBURY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YSB',
  },
  {
    code: 'SAH',
    name_ja: 'サヌア',
    name_en: 'SANAA',
    area_code: 'afr',
    country_code: 'YE',
    flag: 1,
    display: null,
    air_city_code: 'SAH',
  },
  {
    code: 'SAV',
    name_ja: 'サバンナ',
    name_en: 'SAVANNAH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SAV',
  },
  {
    code: 'KUF',
    name_ja: 'サマラ',
    name_en: 'SAMARA',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'KUF',
  },
  {
    code: 'SRI',
    name_ja: 'サマリンダ',
    name_en: 'SAMARINDA',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'SRI',
  },
  {
    code: 'SKD',
    name_ja: 'サマルカンド',
    name_en: 'SAMARKAND',
    area_code: 'asi',
    country_code: 'UZ',
    flag: 1,
    display: null,
    air_city_code: 'SKD',
  },
  {
    code: 'SZF',
    name_ja: 'サムスン',
    name_en: 'SAMSUN',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'SZF',
  },
  {
    code: 'SMI',
    name_ja: 'サモス',
    name_en: 'SAMOS',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'SMI',
  },
  {
    code: 'SJJ',
    name_ja: 'サラエボ',
    name_en: 'SARAJEVO',
    area_code: 'eur',
    country_code: 'BA',
    flag: 1,
    display: null,
    air_city_code: 'SJJ',
  },
  {
    code: 'ZAZ',
    name_ja: 'サラゴーサ',
    name_en: 'ZARAGOZA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'ZAZ',
  },
  {
    code: 'SRQ',
    name_ja: 'サラソタ',
    name_en: 'SARASOTA/BRADENTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SRQ',
  },
  {
    code: 'SLK',
    name_ja: 'サラナク',
    name_en: 'SARANAC LAKE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SLK',
  },
  {
    code: 'SLL',
    name_ja: 'サララ',
    name_en: 'SALALAH',
    area_code: 'afr',
    country_code: 'OM',
    flag: 1,
    display: null,
    air_city_code: 'SLL',
  },
  {
    code: 'SLN',
    name_ja: 'サリナ（カンザス州）',
    name_en: 'SALINA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SLN',
  },
  {
    code: 'SBO',
    name_ja: 'サリーナ',
    name_en: 'SALINA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SBO',
  },
  {
    code: 'SLA',
    name_ja: 'サルタ',
    name_en: 'SALTA',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'SLA',
  },
  {
    code: 'SLW',
    name_ja: 'サルティーヨ',
    name_en: 'SALTILLO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'SLW',
  },
  {
    code: 'YZR',
    name_ja: 'サルニア',
    name_en: 'SARNIA',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YZR',
  },
  {
    code: 'ZVK',
    name_ja: 'サワンナケート',
    name_en: 'SAVANNAKHET',
    area_code: 'asi',
    country_code: 'LA',
    flag: 1,
    display: null,
    air_city_code: 'ZVK',
  },
  {
    code: 'SJT',
    name_ja: 'サンアンジェロ',
    name_en: 'SAN ANGELO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SJT',
  },
  {
    code: 'SAQ',
    name_ja: 'サンアンドロス',
    name_en: 'SAN ANDROS',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'SAQ',
  },
  {
    code: 'BRC',
    name_ja: 'サンカルロス',
    name_en: 'SAN CARLOS',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'BRC',
  },
  {
    code: 'LED',
    name_ja: 'サンクトペテルスブルグ',
    name_en: 'ST PETERSBURG',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'LED',
  },
  {
    code: 'SAL',
    name_ja: 'サンサルバドル',
    name_en: 'SAN SALVADOR',
    area_code: 'sam',
    country_code: 'SV',
    flag: 1,
    display: null,
    air_city_code: 'SAL',
  },
  {
    code: 'ZSA',
    name_ja: 'サンサルバド－ル',
    name_en: 'SAN SALVADOR',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'ZSA',
  },
  {
    code: 'NTY',
    name_ja: 'サンシティ',
    name_en: 'SUN CITY',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'NTY',
  },
  {
    code: 'MCY',
    name_ja: 'サンシャインコ－スト',
    name_en: 'SUNSHINE COAST',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MCY',
  },
  {
    code: 'SJP',
    name_ja: 'サンジョゼ・リオプレット',
    name_en: 'SAO JOSE R PRETO',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'SJP',
  },
  {
    code: 'EAS',
    name_ja: 'サンセバスチアン',
    name_en: 'SAN SEBASTIAN',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'EAS',
  },
  {
    code: 'SNA',
    name_ja: 'サンタアナ',
    name_en: 'SANTA ANA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SNA',
  },
  {
    code: 'SCZ',
    name_ja: 'サンタクルーズ',
    name_en: 'SANTA CRUZ ISLAND',
    area_code: 'oce',
    country_code: 'SB',
    flag: 1,
    display: null,
    air_city_code: 'SCZ',
  },
  {
    code: 'SBA',
    name_ja: 'サンタバーバラ',
    name_en: 'SANTA BARBARA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SBA',
  },
  {
    code: 'SFN',
    name_ja: 'サンタフェ',
    name_en: 'SANTA FE',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: 3,
    air_city_code: 'SFN',
  },
  {
    code: 'SAF',
    name_ja: 'サンタフェ（ニューメキシコ州）',
    name_en: 'SANTA FE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SAF',
  },
  {
    code: 'SMX',
    name_ja: 'サンタマリア',
    name_en: 'SANTA MARIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SMX',
  },
  {
    code: 'SMO',
    name_ja: 'サンタモニカ',
    name_en: 'SANTA MONICA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SMO',
  },
  {
    code: 'STM',
    name_ja: 'サンタレン',
    name_en: 'SANTAREM',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'STM',
  },
  {
    code: 'SDR',
    name_ja: 'サンタンデル',
    name_en: 'SANTANDER',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'SDR',
  },
  {
    code: 'SRZ',
    name_ja: 'サンタ・クルース',
    name_en: 'SANTA CRUZ',
    area_code: 'sam',
    country_code: 'BO',
    flag: 1,
    display: null,
    air_city_code: 'SRZ',
  },
  {
    code: 'STS',
    name_ja: 'サンタ・ローザ（カリフォルニア州）',
    name_en: 'SANTA ROSA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'STS',
  },
  {
    code: 'SDK',
    name_ja: 'サンダカン',
    name_en: 'SANDAKAN',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'SDK',
  },
  {
    code: 'YQT',
    name_ja: 'サンダーベイ',
    name_en: 'THUNDER BAY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQT',
  },
  {
    code: 'STI',
    name_ja: 'サンティアゴ',
    name_en: 'SANTIAGO',
    area_code: 'sam',
    country_code: 'DO',
    flag: 1,
    display: null,
    air_city_code: 'STI',
  },
  {
    code: 'SCL',
    name_ja: 'サンティアゴ',
    name_en: 'SANTIAGO',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: 1,
    air_city_code: 'SCL',
  },
  {
    code: 'SCQ',
    name_ja: 'サンティアゴデコンポステラ',
    name_en: 'SANTIAGO COMPOSTELA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'SCQ',
  },
  {
    code: 'SAN',
    name_ja: 'サンディエゴ（カリフォルニア州）',
    name_en: 'SAN DIEGO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SAN',
  },
  {
    code: 'TMS',
    name_ja: 'サントメ',
    name_en: 'SAO TOME',
    area_code: 'afr',
    country_code: 'ST',
    flag: 1,
    display: null,
    air_city_code: 'TMS',
  },
  {
    code: 'SOM',
    name_ja: 'サントメ',
    name_en: 'SAN TOME',
    area_code: 'sam',
    country_code: 'VE',
    flag: 1,
    display: null,
    air_city_code: 'SOM',
  },
  {
    code: 'SDQ',
    name_ja: 'サント・ドミンゴ',
    name_en: 'SANTO DOMINGO',
    area_code: 'sam',
    country_code: 'DO',
    flag: 1,
    display: null,
    air_city_code: 'SDQ',
  },
  {
    code: 'YZP',
    name_ja: 'サンドスピット',
    name_en: 'SANDSPIT',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YZP',
  },
  {
    code: 'SSA',
    name_ja: 'サンバドル',
    name_en: 'SALVADOR',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'SSA',
  },
  {
    code: 'SUN',
    name_ja: 'サンバレー',
    name_en: 'SUN VALLEY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SUN',
  },
  {
    code: 'SAO',
    name_ja: 'サンパウロ',
    name_en: 'SAO PAULO',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: 1,
    air_city_code: 'SAO',
  },
  {
    code: 'SFO',
    name_ja: 'サンフランシスコ',
    name_en: 'SAN FRANCISCO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SFO',
  },
  {
    code: 'ZAM',
    name_ja: 'サンボアンガ',
    name_en: 'ZAMBOANGA',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'ZAM',
  },
  {
    code: 'SYX',
    name_ja: 'サンヤ（三亜）',
    name_en: 'SANYA',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'SYX',
  },
  {
    code: 'SLZ',
    name_ja: 'サンルイス',
    name_en: 'SAO LUIZ',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'SLZ',
  },
  {
    code: 'SBP',
    name_ja: 'サンルイスオビスポ',
    name_en: 'SAN LUIS OBISPO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SBP',
  },
  {
    code: 'CSL',
    name_ja: 'サンルイスオビスポ',
    name_en: 'SAN LUIS OBISPO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CSL',
  },
  {
    code: 'SLP',
    name_ja: 'サンルイスポトス',
    name_en: 'SAN LUIS POTOSI',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'SLP',
  },
  {
    code: 'SAT',
    name_ja: 'サン・アントニオ',
    name_en: 'SAN ANTONIO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SAT',
  },
  {
    code: 'SJC',
    name_ja: 'サン・ノゼ',
    name_en: 'SAN JOSE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SJC',
  },
  {
    code: 'SJU',
    name_ja: 'サン・ファン',
    name_en: 'SAN JUAN',
    area_code: 'sam',
    country_code: 'PR',
    flag: 1,
    display: null,
    air_city_code: 'SJU',
  },
  {
    code: 'SAP',
    name_ja: 'サン・ベドロスーラ',
    name_en: 'SAN PEDRO SULA',
    area_code: 'sam',
    country_code: 'HN',
    flag: 1,
    display: null,
    air_city_code: 'SAP',
  },
  {
    code: 'SJI',
    name_ja: 'サン・ホセ',
    name_en: 'SAN JOSE',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'SJI',
  },
  {
    code: 'SJO',
    name_ja: 'サン・ホセ',
    name_en: 'SAN JOSE',
    area_code: 'sam',
    country_code: 'CR',
    flag: 1,
    display: null,
    air_city_code: 'SJO',
  },
  {
    code: 'SJD',
    name_ja: 'サン・ホセ・デルカボ＜ロス・カボス＞',
    name_en: 'SAN JOSE CABO<LOS CABOS>',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: 2,
    air_city_code: 'SJD',
  },
  {
    code: 'SVL',
    name_ja: 'サヴォンリンナ',
    name_en: 'SAVONLINNA',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'SVL',
  },
  {
    code: 'TIS',
    name_ja: 'サースディアイランド',
    name_en: 'THURSDAY ISLAND',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'TIS',
  },
  {
    code: 'YQD',
    name_ja: 'ザ パス',
    name_en: 'THE PAS',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQD',
  },
  {
    code: 'ZAG',
    name_ja: 'ザグレブ',
    name_en: 'ZAGREB',
    area_code: 'eur',
    country_code: 'HR',
    flag: 1,
    display: null,
    air_city_code: 'ZAG',
  },
  {
    code: 'ZAD',
    name_ja: 'ザダール',
    name_en: 'ZADAR',
    area_code: 'eur',
    country_code: 'HR',
    flag: 1,
    display: null,
    air_city_code: 'ZAD',
  },
  {
    code: 'SZG',
    name_ja: 'ザルツブルグ',
    name_en: 'SALZBURG',
    area_code: 'eur',
    country_code: 'AT',
    flag: 1,
    display: 2,
    air_city_code: 'SZG',
  },
  {
    code: 'ZNZ',
    name_ja: 'ザンジバル',
    name_en: 'ZANZIBAR',
    area_code: 'afr',
    country_code: 'TZ',
    flag: 1,
    display: null,
    air_city_code: 'ZNZ',
  },
  {
    code: 'SCN',
    name_ja: 'ザールブリュッケン',
    name_en: 'SAARBRUCKEN',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'SCN',
  },
  {
    code: 'SEA',
    name_ja: 'シアトル',
    name_en: 'SEATTLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: 8,
    air_city_code: 'SEA',
  },
  {
    code: 'KOS',
    name_ja: 'シアヌークビル',
    name_en: '',
    area_code: 'asi',
    country_code: 'KH',
    flag: 1,
    display: null,
    air_city_code: 'KOS',
  },
  {
    code: 'SKT',
    name_ja: 'シアールコート',
    name_en: 'SIALKOT',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'SKT',
  },
  {
    code: 'CJS',
    name_ja: 'シウダーフレアス',
    name_en: 'CIUDAD',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CJS',
  },
  {
    code: 'CME',
    name_ja: 'シウダー・フアレス',
    name_en: 'CIUDAD',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CME',
  },
  {
    code: 'SDZ',
    name_ja: 'シェットランド',
    name_en: 'SHETLAND ISLAND',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'SDZ',
  },
  {
    code: 'REP',
    name_ja: 'シェムリアップ',
    name_en: 'SIEM REAP',
    area_code: 'asi',
    country_code: 'KH',
    flag: 1,
    display: 1,
    air_city_code: 'REP',
  },
  {
    code: 'SHR',
    name_ja: 'シェリダン',
    name_en: 'SHERIDAN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SHR',
  },
  {
    code: 'SFT',
    name_ja: 'シェレフテオ',
    name_en: 'SKELLEFTEA',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'SFT',
  },
  {
    code: 'CHI',
    name_ja: 'シカゴ',
    name_en: 'CHICAGO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: 4,
    air_city_code: 'CHI',
  },
  {
    code: 'SIT',
    name_ja: 'シトカ',
    name_en: 'SITKA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SIT',
  },
  {
    code: 'CJL',
    name_ja: 'シトラル',
    name_en: 'CHITRAL',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'CJL',
  },
  {
    code: 'SYD',
    name_ja: 'シドニー',
    name_en: 'SYDNEY',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: 1,
    air_city_code: 'SYD',
  },
  {
    code: 'YQY',
    name_ja: 'シドニー',
    name_en: 'SYDNEY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQY',
  },
  {
    code: 'SDY',
    name_ja: 'シドニー',
    name_en: 'SIDNEY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SDY',
  },
  {
    code: 'SNY',
    name_ja: 'シドニー（ネブラスカ州）',
    name_en: 'SIDNEY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SNY',
  },
  {
    code: 'SBZ',
    name_ja: 'シビウ',
    name_en: 'SIBIU',
    area_code: 'eur',
    country_code: 'RO',
    flag: 1,
    display: null,
    air_city_code: 'SBZ',
  },
  {
    code: 'SBW',
    name_ja: 'シブ',
    name_en: 'SIBU',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'SBW',
  },
  {
    code: 'CYS',
    name_ja: 'シャイアン',
    name_en: 'CHEYENNE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CYS',
  },
  {
    code: 'SNN',
    name_ja: 'シャノン',
    name_en: 'SHANNON',
    area_code: 'eur',
    country_code: 'IE',
    flag: 1,
    display: null,
    air_city_code: 'SNN',
  },
  {
    code: 'SHJ',
    name_ja: 'シャルジャ',
    name_en: 'SHARJAH',
    area_code: 'afr',
    country_code: 'AE',
    flag: 1,
    display: null,
    air_city_code: 'SHJ',
  },
  {
    code: 'SSH',
    name_ja: 'シャルムエルシエイク',
    name_en: 'SHARM EL SHEIKH',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: null,
    air_city_code: 'SSH',
  },
  {
    code: 'SHA',
    name_ja: 'シャンハイ（上海）',
    name_en: 'SHANGHAI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 2,
    air_city_code: 'SHA',
  },
  {
    code: 'CMF',
    name_ja: 'シャンベリー',
    name_en: 'SHAMBERY',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'CMF',
  },
  {
    code: 'CMI',
    name_ja: 'シャンペイン',
    name_en: 'CHAMPAIGN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CMI',
  },
  {
    code: 'XMN',
    name_ja: 'シャーメン（厦門）',
    name_en: 'XIAMEN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'XMN',
  },
  {
    code: 'CHO',
    name_ja: 'シャーロッツビル（ヴァージニア）',
    name_en: 'CHARLOTTESVILLE(VIRGINIA)',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CHO',
  },
  {
    code: 'YHG',
    name_ja: 'シャーロットタウン',
    name_en: 'CHARLOTTETOWN',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YHG',
  },
  {
    code: 'YYG',
    name_ja: 'シャーロットタウン（プリンスエドワード島）',
    name_en: 'CHARLOTTETOWN',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: '',
  },
  {
    code: 'CLT',
    name_ja: 'シャーロット（ノースキャロライナ）',
    name_en: 'CHARLOTTE(NORTH CAROLINA)',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CLT',
  },
  {
    code: 'SZZ',
    name_ja: 'シュチェチン',
    name_en: 'SZCZECIN',
    area_code: 'eur',
    country_code: 'PL',
    flag: 1,
    display: null,
    air_city_code: 'SZZ',
  },
  {
    code: 'STR',
    name_ja: 'シュトゥットガルト',
    name_en: 'STUTTGART',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'STR',
  },
  {
    code: 'SHV',
    name_ja: 'シュリーブポート',
    name_en: 'SHREVEPORT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SHV',
  },
  {
    code: 'SYR',
    name_ja: 'シラキュース',
    name_en: 'SYRACUSE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SYR',
  },
  {
    code: 'SVC',
    name_ja: 'シルバーシティ',
    name_en: 'SILVER CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SVC',
  },
  {
    code: 'ZYL',
    name_ja: 'シレット',
    name_en: 'SYLHET',
    area_code: 'asi',
    country_code: 'BD',
    flag: 1,
    display: null,
    air_city_code: 'ZYL',
  },
  {
    code: 'ZIH',
    name_ja: 'シワタネホ',
    name_en: 'ZIHUATANEJO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'ZIH',
  },
  {
    code: 'SIN',
    name_ja: 'シンガポール',
    name_en: 'SINGAPORE',
    area_code: 'asi',
    country_code: 'SG',
    flag: 1,
    display: 1,
    air_city_code: 'SIN',
  },
  {
    code: 'CVG',
    name_ja: 'シンシナティ',
    name_en: 'CINCINNATI',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CVG',
  },
  {
    code: 'SZX',
    name_ja: 'シンセン（深セン）',
    name_en: 'SHENZHEN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 6,
    air_city_code: 'SZX',
  },
  {
    code: 'SIP',
    name_ja: 'シンフェローポリ',
    name_en: 'SIMFEROPOL',
    area_code: 'eur',
    country_code: 'UA',
    flag: 1,
    display: null,
    air_city_code: 'SIP',
  },
  {
    code: 'SHE',
    name_ja: 'シンヨウ（瀋陽）',
    name_en: 'SHENYANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'SHE',
  },
  {
    code: 'AGT',
    name_ja: 'シーダッドデルエステ',
    name_en: 'CIUDAD DEL ESTE',
    area_code: 'sam',
    country_code: 'PY',
    flag: 1,
    display: null,
    air_city_code: 'AGT',
  },
  {
    code: 'CDC',
    name_ja: 'シーダーシティ',
    name_en: 'CEDAR CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CDC',
  },
  {
    code: 'CID',
    name_ja: 'シーダーラピッズ',
    name_en: 'CEDAR RAPIDS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CID',
  },
  {
    code: 'XNN',
    name_ja: 'シーニン（西寧）',
    name_en: 'XINING',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'XNN',
  },
  {
    code: 'TVF',
    name_ja: 'シーフリバーフォールズ',
    name_en: 'THIEF RIVER FALLS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TVF',
  },
  {
    code: 'SYZ',
    name_ja: 'シーラーズ',
    name_en: 'SHIRAZ',
    area_code: 'afr',
    country_code: 'IR',
    flag: 1,
    display: null,
    air_city_code: 'SYZ',
  },
  {
    code: 'GOA',
    name_ja: 'ジェノア',
    name_en: 'GENOA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'GOA',
  },
  {
    code: 'GET',
    name_ja: 'ジェラルトン',
    name_en: 'GERALDTON',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'GET',
  },
  {
    code: 'YGQ',
    name_ja: 'ジェラルドトン',
    name_en: 'GERALDTON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YGQ',
  },
  {
    code: 'DJE',
    name_ja: 'ジェルバ',
    name_en: 'DJERBA',
    area_code: 'afr',
    country_code: 'TN',
    flag: 1,
    display: null,
    air_city_code: 'DJE',
  },
  {
    code: 'RZE',
    name_ja: 'ジェンシュフ',
    name_en: 'RZESZOW',
    area_code: 'eur',
    country_code: 'PL',
    flag: 1,
    display: null,
    air_city_code: 'RZE',
  },
  {
    code: 'JHW',
    name_ja: 'ジェームスタウン（ニューヨーク州）',
    name_en: 'JAMESTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JHW',
  },
  {
    code: 'JMS',
    name_ja: 'ジェームスタウン（ノースダコタ州）',
    name_en: 'JAMESTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JMS',
  },
  {
    code: 'JED',
    name_ja: 'ジッダ',
    name_en: 'JEDDAH',
    area_code: 'afr',
    country_code: 'SA',
    flag: 1,
    display: null,
    air_city_code: 'JED',
  },
  {
    code: 'JIB',
    name_ja: 'ジブチ',
    name_en: 'DJIBOUTI',
    area_code: 'afr',
    country_code: 'DJ',
    flag: 1,
    display: null,
    air_city_code: 'JIB',
  },
  {
    code: 'GIB',
    name_ja: 'ジブラルタル',
    name_en: 'GIBRALTAR',
    area_code: 'eur',
    country_code: 'GI',
    flag: 1,
    display: null,
    air_city_code: 'GIB',
  },
  {
    code: 'JAI',
    name_ja: 'ジャイブール',
    name_en: 'JAIPUR',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: 3,
    air_city_code: 'JAI',
  },
  {
    code: 'JKT',
    name_ja: 'ジャカルタ',
    name_en: 'JAKARTA',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: 2,
    air_city_code: 'JKT',
  },
  {
    code: 'JAX',
    name_ja: 'ジャクソンビル',
    name_en: 'JACKSONVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JAX',
  },
  {
    code: 'OAJ',
    name_ja: 'ジャクソンビル',
    name_en: 'JACKSONVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OAJ',
  },
  {
    code: 'MKL',
    name_ja: 'ジャクソン（テネシー州）',
    name_en: 'JACKSON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MKL',
  },
  {
    code: 'JXN',
    name_ja: 'ジャクソン（ミシガン州）',
    name_en: 'JACKSON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JXN',
  },
  {
    code: 'JAN',
    name_ja: 'ジャクソン（ミシシッピ州）',
    name_en: 'JACKSON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JAN',
  },
  {
    code: 'JAC',
    name_ja: 'ジャクソン（ワイオミング州）',
    name_en: 'JACKSON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JAC',
  },
  {
    code: 'YJA',
    name_ja: 'ジャスパー',
    name_en: 'JASPER',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YJA',
  },
  {
    code: 'JVL',
    name_ja: 'ジャネスビル',
    name_en: 'JANESVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JVL',
  },
  {
    code: 'JER',
    name_ja: 'ジャージー',
    name_en: 'JERSEY',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'JER',
  },
  {
    code: 'GVA',
    name_ja: 'ジュネーブ',
    name_en: 'GENEVA',
    area_code: 'eur',
    country_code: 'CH',
    flag: 1,
    display: 1,
    air_city_code: 'GVA',
  },
  {
    code: 'JNU',
    name_ja: 'ジューノー',
    name_en: 'JUNESU',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JNU',
  },
  {
    code: 'JUB',
    name_ja: 'ジューバ',
    name_en: 'JUBA',
    area_code: 'afr',
    country_code: 'SD',
    flag: 1,
    display: null,
    air_city_code: 'JUB',
  },
  {
    code: 'JPA',
    name_ja: 'ジョアンペソア',
    name_en: 'JOAO PESSOA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'JPA',
  },
  {
    code: 'JOI',
    name_ja: 'ジョインビル',
    name_en: 'JOINVILLE',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'JOI',
  },
  {
    code: 'JOG',
    name_ja: 'ジョグ・ジャカルタ',
    name_en: 'YOGYAKARTA',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: 3,
    air_city_code: 'JOG',
  },
  {
    code: 'JDH',
    name_ja: 'ジョドプール',
    name_en: 'JODHPUR',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'JDH',
  },
  {
    code: 'JLN',
    name_ja: 'ジョプリン',
    name_en: 'JOPLIN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JLN',
  },
  {
    code: 'JHB',
    name_ja: 'ジョホ－ルバ－ル',
    name_en: 'JOHOR BAHRU',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'JHB',
  },
  {
    code: 'JMO',
    name_ja: 'ジョムソン',
    name_en: 'JOMSON',
    area_code: 'asi',
    country_code: 'NP',
    flag: 1,
    display: null,
    air_city_code: 'JMO',
  },
  {
    code: 'JST',
    name_ja: 'ジョンズタウン（ペンシルベニア州）',
    name_en: 'JOHNSTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JST',
  },
  {
    code: 'GRJ',
    name_ja: 'ジョージ',
    name_en: 'GEORGE',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'GRJ',
  },
  {
    code: 'GGT',
    name_ja: 'ジョージタウン',
    name_en: 'GEORGE TOWN',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'GGT',
  },
  {
    code: 'GEO',
    name_ja: 'ジョージタウン',
    name_en: 'GEORGETOWN',
    area_code: 'sam',
    country_code: 'GY',
    flag: 1,
    display: null,
    air_city_code: 'GEO',
  },
  {
    code: 'JBR',
    name_ja: 'ジョーンズバロ（アーカンソー州）',
    name_en: 'JONESBORO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'JBR',
  },
  {
    code: 'YGX',
    name_ja: 'ジラン',
    name_en: 'GILLAM',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YGX',
  },
  {
    code: 'GCC',
    name_ja: 'ジレット',
    name_en: 'GILLETTE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GCC',
  },
  {
    code: 'SZK',
    name_ja: 'スククザ',
    name_en: 'SKUKUZA',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'SZK',
  },
  {
    code: 'SRE',
    name_ja: 'スクレ',
    name_en: 'SUCRE',
    area_code: 'sam',
    country_code: 'BO',
    flag: 1,
    display: null,
    air_city_code: 'SRE',
  },
  {
    code: 'BFF',
    name_ja: 'スコッツブルフ',
    name_en: 'SCOTTSBLUFF',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BFF',
  },
  {
    code: 'SKP',
    name_ja: 'スコピエ',
    name_en: 'SKOPJE',
    area_code: 'eur',
    country_code: 'MK',
    flag: 1,
    display: null,
    air_city_code: 'SKP',
  },
  {
    code: 'THS',
    name_ja: 'スコ－タイ',
    name_en: 'SUKHOTHAI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'THS',
  },
  {
    code: 'SHD',
    name_ja: 'スタントン',
    name_en: 'STAUNTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SHD',
  },
  {
    code: 'SVG',
    name_ja: 'スタヴァンゲル',
    name_en: 'STAVANGER',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'SVG',
  },
  {
    code: 'SCV',
    name_ja: 'スチャバ',
    name_en: 'SUCEAVA',
    area_code: 'eur',
    country_code: 'RO',
    flag: 1,
    display: null,
    air_city_code: 'SCV',
  },
  {
    code: 'SQI',
    name_ja: 'ステアリング',
    name_en: 'STERLING',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SQI',
  },
  {
    code: 'SBS',
    name_ja: 'スティームボートスプリングス',
    name_en: 'STEAMBOAT SPRINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SBS',
  },
  {
    code: 'HDN',
    name_ja: 'スティ－ムボ－トスプリングス',
    name_en: 'STEAMBOAT SPRINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HDN',
  },
  {
    code: 'YJT',
    name_ja: 'ステファンビル',
    name_en: 'STEPHENVILLE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YJT',
  },
  {
    code: 'SCE',
    name_ja: 'ステートカレッジ',
    name_en: 'STATE COLLEGE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SCE',
  },
  {
    code: 'SML',
    name_ja: 'ステーラマリス',
    name_en: 'STELLA MARIS',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'SML',
  },
  {
    code: 'SCK',
    name_ja: 'ストックトン',
    name_en: 'STOCKTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SCK',
  },
  {
    code: 'STO',
    name_ja: 'ストックホルム',
    name_en: 'STOCKHOLM',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: 1,
    air_city_code: 'STO',
  },
  {
    code: 'SXB',
    name_ja: 'ストラスブール',
    name_en: 'STRASBOURG',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'SXB',
  },
  {
    code: 'SRN',
    name_ja: 'ストラーアン',
    name_en: 'STRAHAN',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'SRN',
  },
  {
    code: 'SUV',
    name_ja: 'スバ',
    name_en: 'SUVA',
    area_code: 'oce',
    country_code: 'FJ',
    flag: 1,
    display: null,
    air_city_code: 'SUV',
  },
  {
    code: 'SPU',
    name_ja: 'スプリト',
    name_en: 'SPLIT',
    area_code: 'eur',
    country_code: 'HR',
    flag: 1,
    display: null,
    air_city_code: 'SPU',
  },
  {
    code: 'SPI',
    name_ja: 'スプリングフィールド（イリノイ州）',
    name_en: 'SPRINGFIELD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SPI',
  },
  {
    code: 'SGF',
    name_ja: 'スプリングフィールド（ミズーリ州）',
    name_en: 'SPRINGFIELD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SGF',
  },
  {
    code: 'AXP',
    name_ja: 'スプリングポイント',
    name_en: 'SPRING POINT',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'AXP',
  },
  {
    code: 'SPW',
    name_ja: 'スペンサー（アイオワ州）',
    name_en: 'SPENCER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SPW',
  },
  {
    code: 'GEG',
    name_ja: 'スポーケン',
    name_en: 'SPOKANE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GEG',
  },
  {
    code: 'SRG',
    name_ja: 'スマラン',
    name_en: 'SEMARANG',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'SRG',
  },
  {
    code: 'YYD',
    name_ja: 'スミサーズ',
    name_en: 'SMITHERS',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYD',
  },
  {
    code: 'SXL',
    name_ja: 'スライゴー',
    name_en: 'SLIGO',
    area_code: 'eur',
    country_code: 'IE',
    flag: 1,
    display: null,
    air_city_code: 'SXL',
  },
  {
    code: 'URT',
    name_ja: 'スラタニ',
    name_en: 'SURAT THANI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'URT',
  },
  {
    code: 'SUB',
    name_ja: 'スラバヤ',
    name_en: 'SURABAYA',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'SUB',
  },
  {
    code: 'ISU',
    name_ja: 'スレイマニヤ',
    name_en: 'SULAYMANIYAH',
    area_code: 'afr',
    country_code: 'IQ',
    flag: 1,
    display: null,
    air_city_code: 'ISU',
  },
  {
    code: 'SDL',
    name_ja: 'スンズヴァル',
    name_en: 'SUNDSVALL',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'SDL',
  },
  {
    code: 'SWQ',
    name_ja: 'スンバワ島',
    name_en: 'SUMBAWA',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'SWQ',
  },
  {
    code: 'YAM',
    name_ja: 'スー セント マリー',
    name_en: 'SAULT SAINTE MARIE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YAM',
  },
  {
    code: 'SUX',
    name_ja: 'スーシティ',
    name_en: 'SIOUX CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SUX',
  },
  {
    code: 'SSM',
    name_ja: 'スーセントマリー',
    name_en: 'SAULT SAINTE MARIE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SSM',
  },
  {
    code: 'CEN',
    name_ja: 'スーダットオビリガン',
    name_en: 'CIUDAD OBREGON',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CEN',
  },
  {
    code: 'FSD',
    name_ja: 'スーフォールズ',
    name_en: 'SIOUX FALLS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FSD',
  },
  {
    code: 'SFS',
    name_ja: 'ス－ビック',
    name_en: 'SUBIC BAY INTNL',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'SFS',
  },
  {
    code: 'SJY',
    name_ja: 'セイナヨキ',
    name_en: 'SEINAJOKI',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'SJY',
  },
  {
    code: 'YST',
    name_ja: 'セイントテレーズ',
    name_en: 'SAINTE THERESE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YST',
  },
  {
    code: 'QSF',
    name_ja: 'セティク',
    name_en: 'SETIF',
    area_code: 'afr',
    country_code: 'DZ',
    flag: 1,
    display: null,
    air_city_code: 'QSF',
  },
  {
    code: 'SDX',
    name_ja: 'セドナ',
    name_en: 'SEDONA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FLG',
  },
  {
    code: 'SVQ',
    name_ja: 'セビリア',
    name_en: 'SEVILLE',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'SVQ',
  },
  {
    code: 'CEB',
    name_ja: 'セブ',
    name_en: 'CEBU',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: 2,
    air_city_code: 'CEB',
  },
  {
    code: 'YZV',
    name_ja: 'セプトイリス',
    name_en: 'SEPT ILES',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YZV',
  },
  {
    code: 'SKB',
    name_ja: 'セントキッツ',
    name_en: 'ST KITTS',
    area_code: 'sam',
    country_code: 'KN',
    flag: 1,
    display: null,
    air_city_code: 'SKB',
  },
  {
    code: 'STX',
    name_ja: 'セントクロイ島',
    name_en: 'SAINT CROIX',
    area_code: 'sam',
    country_code: 'VI',
    flag: 1,
    display: null,
    air_city_code: 'STX',
  },
  {
    code: 'STC',
    name_ja: 'セントクロード',
    name_en: 'SAINT CLOUD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'STC',
  },
  {
    code: 'YYT',
    name_ja: 'セントションズ',
    name_en: 'SAINT JOHN&rsquo;S',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYT',
  },
  {
    code: 'YSJ',
    name_ja: 'セントジョン',
    name_en: 'ST JOHN',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YSJ',
  },
  {
    code: 'ST1',
    name_ja: 'セントジョン島',
    name_en: 'St. John',
    area_code: 'sam',
    country_code: 'VI',
    flag: 1,
    display: null,
    air_city_code: 'STT',
  },
  {
    code: 'STT',
    name_ja: 'セントトーマスアイランド',
    name_en: 'ST. THOMAS',
    area_code: 'sam',
    country_code: 'VI',
    flag: 1,
    display: null,
    air_city_code: 'STT',
  },
  {
    code: 'SVD',
    name_ja: 'セントビンセント',
    name_en: 'SAINT VINCENT',
    area_code: 'sam',
    country_code: 'VC',
    flag: 1,
    display: null,
    air_city_code: 'SVD',
  },
  {
    code: 'SNP',
    name_ja: 'セントポールアイランド',
    name_en: 'SAINT PAUL ISLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SNP',
  },
  {
    code: 'SXM',
    name_ja: 'セントマーチン島',
    name_en: 'SAINT MAARTEN',
    area_code: 'sam',
    country_code: 'SX',
    flag: 1,
    display: null,
    air_city_code: 'SXM',
  },
  {
    code: 'KSM',
    name_ja: 'セントメリーズ',
    name_en: 'ST MARYS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'KSM',
  },
  {
    code: 'STL',
    name_ja: 'セントルイス',
    name_en: 'SAINT LOUIS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'STL',
  },
  {
    code: 'SLU',
    name_ja: 'セントルシア',
    name_en: 'SAINT LUCIA',
    area_code: 'sam',
    country_code: 'LC',
    flag: 1,
    display: null,
    air_city_code: 'SLU',
  },
  {
    code: 'YSL',
    name_ja: 'セントレオナルド',
    name_en: 'ST LEONARD',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YSL',
  },
  {
    code: 'SGU',
    name_ja: 'センドジョージ',
    name_en: 'SAINT GEORGE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SGU',
  },
  {
    code: 'SLE',
    name_ja: 'セーレム',
    name_en: 'SALEM',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SLE',
  },
  {
    code: 'GES',
    name_ja: 'ゼネラルサントス',
    name_en: 'GENERAL SANTOS',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'GES',
  },
  {
    code: 'SEL',
    name_ja: 'ソウル',
    name_en: 'SEOUL',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: 1,
    air_city_code: 'SEL',
  },
  {
    code: 'AER',
    name_ja: 'ソチ',
    name_en: 'SOCHI',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'AER',
  },
  {
    code: 'SOF',
    name_ja: 'ソフィア',
    name_en: 'SOFIA',
    area_code: 'eur',
    country_code: 'BG',
    flag: 1,
    display: 1,
    air_city_code: 'SOF',
  },
  {
    code: 'SLC',
    name_ja: 'ソルトレイクシティ',
    name_en: 'SALT LAKE CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SLC',
  },
  {
    code: 'SOC',
    name_ja: 'ソロ・シティー',
    name_en: 'SOLO CITY',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'SOC',
  },
  {
    code: 'SGD',
    name_ja: 'ソンダーボルグ',
    name_en: 'SONDERBORG',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'SGD',
  },
  {
    code: 'SQH',
    name_ja: 'ソンラ',
    name_en: 'SON LA',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'SQH',
  },
  {
    code: 'LJG',
    name_ja: 'ソーチアン（麗江）',
    name_en: 'LIJIANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LJG',
  },
  {
    code: 'SBY',
    name_ja: 'ソールズベリー',
    name_en: 'SALISBURY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SBY',
  },
  {
    code: 'TYN',
    name_ja: 'タイユワン（太原）',
    name_en: 'TAIYUAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'TYN',
  },
  {
    code: 'TYR',
    name_ja: 'タイラー（テキサス州）',
    name_en: 'TYLER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TYR',
  },
  {
    code: 'THD',
    name_ja: 'タインホア',
    name_en: 'THANH HOA',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'THD',
  },
  {
    code: 'TUO',
    name_ja: 'タウポ',
    name_en: 'TAUPO',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'TUO',
  },
  {
    code: 'TRG',
    name_ja: 'タウランガ',
    name_en: 'TAURANGA',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'TRG',
  },
  {
    code: 'TSV',
    name_ja: 'タウンズビル',
    name_en: 'TOWNSVILLE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'TSV',
  },
  {
    code: 'TSM',
    name_ja: 'タオス',
    name_en: 'TAOS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TSM',
  },
  {
    code: 'TCQ',
    name_ja: 'タクナ',
    name_en: 'TACNA',
    area_code: 'sam',
    country_code: 'PE',
    flag: 1,
    display: null,
    air_city_code: 'TCQ',
  },
  {
    code: 'TAC',
    name_ja: 'タクロバン',
    name_en: 'TACLOBAN',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'TAC',
  },
  {
    code: 'TAG',
    name_ja: 'タグビララン',
    name_en: 'TAGBILARAN',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'TAG',
  },
  {
    code: 'TAS',
    name_ja: 'タシケント',
    name_en: 'TASHKENT',
    area_code: 'asi',
    country_code: 'UZ',
    flag: 1,
    display: null,
    air_city_code: 'TAS',
  },
  {
    code: 'TCL',
    name_ja: 'タスカルーサ',
    name_en: 'TUSCALOOSA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TCL',
  },
  {
    code: 'TTR',
    name_ja: 'タナトラジャ',
    name_en: 'TANATORAJA',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'TTR',
  },
  {
    code: 'TAP',
    name_ja: 'タパチュラ',
    name_en: 'TAPACHULA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'TAP',
  },
  {
    code: 'TVU',
    name_ja: 'タベウニ',
    name_en: 'TAVEUNI',
    area_code: 'oce',
    country_code: 'FJ',
    flag: 1,
    display: null,
    air_city_code: 'TVU',
  },
  {
    code: 'TMW',
    name_ja: 'タムワース',
    name_en: 'TAMWORTH',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'TMW',
  },
  {
    code: 'TLH',
    name_ja: 'タラハシー',
    name_en: 'TALLAHASSEE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TLH',
  },
  {
    code: 'TRW',
    name_ja: 'タラワ',
    name_en: 'TARAWA',
    area_code: 'oce',
    country_code: 'KI',
    flag: 1,
    display: null,
    air_city_code: 'TRW',
  },
  {
    code: 'TIZ',
    name_ja: 'タリ',
    name_en: 'TARI',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'TIZ',
  },
  {
    code: 'TJA',
    name_ja: 'タリハ',
    name_en: 'TARIJA',
    area_code: 'sam',
    country_code: 'BO',
    flag: 1,
    display: null,
    air_city_code: 'TJA',
  },
  {
    code: 'TLL',
    name_ja: 'タリン',
    name_en: 'TALLINN',
    area_code: 'eur',
    country_code: 'EE',
    flag: 1,
    display: null,
    air_city_code: 'TLL',
  },
  {
    code: 'TRO',
    name_ja: 'タリー',
    name_en: 'TAREE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'TRO',
  },
  {
    code: 'TUL',
    name_ja: 'タルサ',
    name_en: 'TULSA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TUL',
  },
  {
    code: 'TAY',
    name_ja: 'タルト',
    name_en: 'TARTU',
    area_code: 'eur',
    country_code: 'EE',
    flag: 1,
    display: null,
    air_city_code: 'TAY',
  },
  {
    code: 'TWU',
    name_ja: 'タワウ',
    name_en: 'TAWAU',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'TWU',
  },
  {
    code: 'TNG',
    name_ja: 'タンジール',
    name_en: 'TANGIER',
    area_code: 'afr',
    country_code: 'MA',
    flag: 1,
    display: null,
    air_city_code: 'TNG',
  },
  {
    code: 'TPA',
    name_ja: 'タンパ',
    name_en: 'TAMPA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TPA',
  },
  {
    code: 'TAM',
    name_ja: 'タンピコ',
    name_en: 'TAMPICO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'TAM',
  },
  {
    code: 'TMP',
    name_ja: 'タンペレ',
    name_en: 'TAMPERE',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'TMP',
  },
  {
    code: 'DKR',
    name_ja: 'ダカール',
    name_en: 'DAKAR',
    area_code: 'afr',
    country_code: 'SN',
    flag: 1,
    display: null,
    air_city_code: 'DSS',
  },
  {
    code: 'VIL',
    name_ja: 'ダクラ',
    name_en: 'DAKHLA',
    area_code: 'afr',
    country_code: 'MA',
    flag: 1,
    display: null,
    air_city_code: 'VIL',
  },
  {
    code: 'DAC',
    name_ja: 'ダッカ',
    name_en: 'DHAKA',
    area_code: 'asi',
    country_code: 'BD',
    flag: 1,
    display: null,
    air_city_code: 'DAC',
  },
  {
    code: 'DDC',
    name_ja: 'ダッジシティ',
    name_en: 'DODGE CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DDC',
  },
  {
    code: 'DUT',
    name_ja: 'ダッチハーバー',
    name_en: 'DYTCH HABBOR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DUT',
  },
  {
    code: 'DAD',
    name_ja: 'ダナン',
    name_en: 'DA NANG',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'DAD',
  },
  {
    code: 'DUD',
    name_ja: 'ダニーデン',
    name_en: 'DUNEDIN',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'DUD',
  },
  {
    code: 'DVO',
    name_ja: 'ダバオ',
    name_en: 'DAVAO',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'DVO',
  },
  {
    code: 'DBQ',
    name_ja: 'ダビューク',
    name_en: 'DUBUQUE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DBQ',
  },
  {
    code: 'DUB',
    name_ja: 'ダブリン',
    name_en: 'DUBLIN',
    area_code: 'eur',
    country_code: 'IE',
    flag: 1,
    display: null,
    air_city_code: 'DUB',
  },
  {
    code: 'DAM',
    name_ja: 'ダマスカス',
    name_en: 'DAMASCUS',
    area_code: 'afr',
    country_code: 'SY',
    flag: 1,
    display: null,
    air_city_code: 'DAM',
  },
  {
    code: 'DFW',
    name_ja: 'ダラスフォートワース',
    name_en: 'DALLAS/FORT WORTH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DFW',
  },
  {
    code: 'DLI',
    name_ja: 'ダラッド',
    name_en: 'DALAT',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'DLI',
  },
  {
    code: 'DLM',
    name_ja: 'ダラマン',
    name_en: 'DALMAN',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'DLM',
  },
  {
    code: 'MME',
    name_ja: 'ダラム',
    name_en: 'DURHAM',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'MME',
  },
  {
    code: 'DLG',
    name_ja: 'ダリングハム',
    name_en: 'DILLINGHAM',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DLG',
  },
  {
    code: 'DAR',
    name_ja: 'ダルエスサラーム',
    name_en: 'DAR-ES-SALAAM',
    area_code: 'afr',
    country_code: 'TZ',
    flag: 1,
    display: null,
    air_city_code: 'DAR',
  },
  {
    code: 'DLH',
    name_ja: 'ダルース',
    name_en: 'DULUTH/SUPERIOR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DLH',
  },
  {
    code: 'DKI',
    name_ja: 'ダンクアイランド',
    name_en: 'DUNK ISLAND',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'DKI',
  },
  {
    code: 'DNV',
    name_ja: 'ダンビル（イリノイ州）',
    name_en: 'DANVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DNV',
  },
  {
    code: 'DAN',
    name_ja: 'ダンビル（バージニア州）',
    name_en: 'DANVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DAN',
  },
  {
    code: 'DMM',
    name_ja: 'ダンマン',
    name_en: 'DAMMAM',
    area_code: 'afr',
    country_code: 'SA',
    flag: 1,
    display: null,
    air_city_code: 'DMM',
  },
  {
    code: 'DRW',
    name_ja: 'ダーウィン',
    name_en: 'DARWIN',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'DRW',
  },
  {
    code: 'DUR',
    name_ja: 'ダーバン',
    name_en: 'DURBAN',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'DUR',
  },
  {
    code: 'DHA',
    name_ja: 'ダーラン',
    name_en: 'DHAHRAN',
    area_code: 'afr',
    country_code: 'SA',
    flag: 1,
    display: null,
    air_city_code: 'DHA',
  },
  {
    code: 'DLC',
    name_ja: 'ダーレン（大連）',
    name_en: 'DALIAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 4,
    air_city_code: 'DLC',
  },
  {
    code: 'CJU',
    name_ja: 'チェジュ（済州島）',
    name_en: 'JEJU',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: 3,
    air_city_code: 'CJU',
  },
  {
    code: 'CTM',
    name_ja: 'チェトゥマル',
    name_en: 'CHETUMAL',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CTM',
  },
  {
    code: 'CEK',
    name_ja: 'チェリャビンスク',
    name_en: 'CHELYABINSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'CEK',
  },
  {
    code: 'MAA',
    name_ja: 'チェンナイ',
    name_en: 'MADRAS',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'MAA',
  },
  {
    code: 'CNX',
    name_ja: 'チェンマイ',
    name_en: 'CHIANG MAI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: 2,
    air_city_code: 'CNX',
  },
  {
    code: 'CEI',
    name_ja: 'チェンライ',
    name_en: 'CHIANG RAI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'CEI',
  },
  {
    code: 'CIC',
    name_ja: 'チコ',
    name_en: 'CHICO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CIC',
  },
  {
    code: 'CGP',
    name_ja: 'チッタゴン',
    name_en: 'CHITTAGONG',
    area_code: 'asi',
    country_code: 'BD',
    flag: 1,
    display: null,
    air_city_code: 'CGP',
  },
  {
    code: 'CHA',
    name_ja: 'チャタヌーガ',
    name_en: 'CHATTANOOGA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CHA',
  },
  {
    code: 'CDR',
    name_ja: 'チャドロン',
    name_en: 'CHADRON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CDR',
  },
  {
    code: 'CSX',
    name_ja: 'チャンシャ（長沙）',
    name_en: 'CHANGSHA',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CSX',
  },
  {
    code: 'ZHA',
    name_ja: 'チャンチィアン（湛江）',
    name_en: 'ZHANJIANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'ZHA',
  },
  {
    code: 'IXC',
    name_ja: 'チャンディガール',
    name_en: 'CHANDIGARH',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IXC',
  },
  {
    code: 'YYQ',
    name_ja: 'チャーチル',
    name_en: 'CHURCHILL',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYQ',
  },
  {
    code: 'CRW',
    name_ja: 'チャールストン',
    name_en: 'CHARLESTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CRW',
  },
  {
    code: 'CHS',
    name_ja: 'チャールストン',
    name_en: 'CHARLESTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CHS',
  },
  {
    code: 'YCL',
    name_ja: 'チャーロ',
    name_en: 'CHARLO',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YCL',
  },
  {
    code: 'TUN',
    name_ja: 'チュニス',
    name_en: 'TUNIS',
    area_code: 'afr',
    country_code: 'TN',
    flag: 1,
    display: null,
    air_city_code: 'TUN',
  },
  {
    code: 'CJM',
    name_ja: 'チュムポーン',
    name_en: '',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'CJM',
  },
  {
    code: 'ZRH',
    name_ja: 'チューリッヒ',
    name_en: 'ZURICH',
    area_code: 'eur',
    country_code: 'CH',
    flag: 1,
    display: 2,
    air_city_code: 'ZRH',
  },
  {
    code: 'VCL',
    name_ja: 'チューレイ',
    name_en: 'TAMKY',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'VCL',
  },
  {
    code: 'CGQ',
    name_ja: 'チョウシュン（長春）',
    name_en: 'CHANGCHUN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CGQ',
  },
  {
    code: 'CKG',
    name_ja: 'チョンチン（重慶）',
    name_en: 'CHONGQING',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 3,
    air_city_code: 'CKG',
  },
  {
    code: 'CTU',
    name_ja: 'チョントゥ（成都）',
    name_en: 'CHENGDU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CTU',
  },
  {
    code: 'CUU',
    name_ja: 'チワワ',
    name_en: 'CHIHUAHUA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'CUU',
  },
  {
    code: 'TAO',
    name_ja: 'チンタオ（青島）',
    name_en: 'QINGDAO',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 9,
    air_city_code: 'TAO',
  },
  {
    code: 'TNA',
    name_ja: 'チーナン（済南）',
    name_en: 'JINAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'TNA',
  },
  {
    code: 'TWF',
    name_ja: 'ツインフォールズ',
    name_en: 'TWIN FALLS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TWF',
  },
  {
    code: 'TWB',
    name_ja: 'ツーウンバ',
    name_en: 'TOOWOOMBA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'TWB',
  },
  {
    code: 'TUF',
    name_ja: 'ツール',
    name_en: 'TOURS',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'TUF',
  },
  {
    code: 'TUS',
    name_ja: 'ツ－ソン',
    name_en: 'TUCSON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TUS',
  },
  {
    code: 'TEU',
    name_ja: 'テアナウ',
    name_en: 'TE ANAU',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'TEU',
  },
  {
    code: 'TOD',
    name_ja: 'ティオマン',
    name_en: 'TIOMAN',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'TOD',
  },
  {
    code: 'TIJ',
    name_ja: 'ティファナ',
    name_en: 'TIJUANA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'TIJ',
  },
  {
    code: 'TIU',
    name_ja: 'ティマル',
    name_en: 'TIMARU',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'TIU',
  },
  {
    code: 'TSR',
    name_ja: 'ティミショアラ',
    name_en: 'TIMISOARA',
    area_code: 'eur',
    country_code: 'RO',
    flag: 1,
    display: null,
    air_city_code: 'TSR',
  },
  {
    code: 'YTS',
    name_ja: 'ティミンズ',
    name_en: 'TIMMINS',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YTS',
  },
  {
    code: 'TIA',
    name_ja: 'ティラナ',
    name_en: 'TIRANA',
    area_code: 'eur',
    country_code: 'AL',
    flag: 1,
    display: null,
    air_city_code: 'TIA',
  },
  {
    code: 'JTR',
    name_ja: 'ティラ（サントリーニ）',
    name_en: 'THIRA(SANTORINI)',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'JTR',
  },
  {
    code: 'TRZ',
    name_ja: 'ティルチラーパッリ',
    name_en: 'TIRUCHIRAPALLY',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'TRZ',
  },
  {
    code: 'TIV',
    name_ja: 'ティヴァト',
    name_en: 'TIVAT',
    area_code: 'eur',
    country_code: 'ME',
    flag: 1,
    display: null,
    air_city_code: 'TIV',
  },
  {
    code: 'TXK',
    name_ja: 'テクサーカナ（アーカンソー州）',
    name_en: 'TEXARKANA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TXK',
  },
  {
    code: 'TAE',
    name_ja: 'テグ',
    name_en: 'DAEGU',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'TAE',
  },
  {
    code: 'TGU',
    name_ja: 'テグシガルパ',
    name_en: 'TEGUCIGALPA',
    area_code: 'sam',
    country_code: 'HN',
    flag: 1,
    display: null,
    air_city_code: 'TGU',
  },
  {
    code: 'SKG',
    name_ja: 'テッサロニーキ',
    name_en: 'THESSALONIKI',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'SKG',
  },
  {
    code: 'TET',
    name_ja: 'テテ',
    name_en: 'TETE',
    area_code: 'afr',
    country_code: 'MZ',
    flag: 1,
    display: null,
    air_city_code: 'TET',
  },
  {
    code: 'TCI',
    name_ja: 'テネリフェ',
    name_en: 'TENERIFE',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'TCI',
  },
  {
    code: 'THR',
    name_ja: 'テヘラン',
    name_en: 'TEHRAN',
    area_code: 'afr',
    country_code: 'IR',
    flag: 1,
    display: null,
    air_city_code: 'THR',
  },
  {
    code: 'ZCO',
    name_ja: 'テムコ',
    name_en: 'TEMUCO',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'ZCO',
  },
  {
    code: 'TUP',
    name_ja: 'テューペロ',
    name_en: 'TUPELO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TUP',
  },
  {
    code: 'YXT',
    name_ja: 'テラス',
    name_en: 'TERRACE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YXT',
  },
  {
    code: 'TLV',
    name_ja: 'テルアビブ',
    name_en: 'TEL AVIV',
    area_code: 'afr',
    country_code: 'IL',
    flag: 1,
    display: null,
    air_city_code: 'TLV',
  },
  {
    code: 'TEX',
    name_ja: 'テルユライド',
    name_en: 'TELLURIDE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TEX',
  },
  {
    code: 'THE',
    name_ja: 'テレジーナ',
    name_en: 'TERESINA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'THE',
  },
  {
    code: 'HUF',
    name_ja: 'テレホート',
    name_en: 'TERRE HAUTE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HUF',
  },
  {
    code: 'TSN',
    name_ja: 'テンシン（天津）',
    name_en: 'TIANJIN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 7,
    air_city_code: 'TSN',
  },
  {
    code: 'TPL',
    name_ja: 'テンプル',
    name_en: 'TEMPLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TPL',
  },
  {
    code: 'YDF',
    name_ja: 'ディアレイク',
    name_en: 'DEER LAKE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YDF',
  },
  {
    code: 'DIN',
    name_ja: 'ディエンビエンフー',
    name_en: 'DIEN BIEN PHU',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'DIN',
  },
  {
    code: 'DIK',
    name_ja: 'ディクソン',
    name_en: 'DICKINSON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DIK',
  },
  {
    code: 'DEC',
    name_ja: 'ディケーター（イリノイ州）',
    name_en: 'DECATUR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DEC',
  },
  {
    code: 'DPL',
    name_ja: 'ディポログ',
    name_en: 'DIPOLOG',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'DPL',
  },
  {
    code: 'DIL',
    name_ja: 'ディリ',
    name_en: 'DILI',
    area_code: 'asi',
    country_code: 'TL',
    flag: 1,
    display: null,
    air_city_code: 'DIL',
  },
  {
    code: 'DAB',
    name_ja: 'デイトナビーチ',
    name_en: 'DAYTONA BEACH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DAB',
  },
  {
    code: 'DAY',
    name_ja: 'デイトン',
    name_en: 'DAYTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DAY',
  },
  {
    code: 'DIG',
    name_ja: 'デチェン・シャングリラ',
    name_en: 'ZHONGDIAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DIG',
  },
  {
    code: 'SCC',
    name_ja: 'デットホース',
    name_en: 'DEADHORSE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SCC',
  },
  {
    code: 'LGI',
    name_ja: 'デッドマンズカイ',
    name_en: 'DEADMANS CAY',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'LGI',
  },
  {
    code: 'DTT',
    name_ja: 'デトロイト',
    name_en: 'DETROIT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DTT',
  },
  {
    code: 'DNZ',
    name_ja: 'デニズリ',
    name_en: 'DENIZLI',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'DNZ',
  },
  {
    code: 'DVL',
    name_ja: 'デビルスレーク',
    name_en: 'DEVILS LAKE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DVL',
  },
  {
    code: 'DED',
    name_ja: 'デヘラードゥーン',
    name_en: 'DEHRADUN',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'DED',
  },
  {
    code: 'DPO',
    name_ja: 'デボンポート',
    name_en: 'DEVONPORT',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'DPO',
  },
  {
    code: 'DSM',
    name_ja: 'デモイン（アイオワ州）',
    name_en: 'DES MOINES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DSM',
  },
  {
    code: 'DUS',
    name_ja: 'デュッセルドルフ',
    name_en: 'DUSSELDORT',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'DUS',
  },
  {
    code: 'DUJ',
    name_ja: 'デュボア',
    name_en: 'DUBOIS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DUJ',
  },
  {
    code: 'DEL',
    name_ja: 'デリー',
    name_en: 'DELHI',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: 1,
    air_city_code: 'DEL',
  },
  {
    code: 'DTA',
    name_ja: 'デルタ',
    name_en: 'DELTA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DTA',
  },
  {
    code: 'DRB',
    name_ja: 'デルビー',
    name_en: 'DERBY',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'DRB',
  },
  {
    code: 'DEN',
    name_ja: 'デンバー',
    name_en: 'DENVER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DEN',
  },
  {
    code: 'DPS',
    name_ja: 'デンパサール',
    name_en: 'DENPASAR-BALI',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: 1,
    air_city_code: 'DPS',
  },
  {
    code: 'TBB',
    name_ja: 'トゥイホア',
    name_en: 'TUY HOA',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'TBB',
  },
  {
    code: 'TNP',
    name_ja: 'トゥエンティーナインパームス',
    name_en: 'TWENTY NINE PARMS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TNP',
  },
  {
    code: 'TGZ',
    name_ja: 'トゥクストラグティエレース',
    name_en: 'TUXTLA GUTIERREZ',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'TGZ',
  },
  {
    code: 'TKU',
    name_ja: 'トゥルク',
    name_en: 'TURKU',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'TKU',
  },
  {
    code: 'TLS',
    name_ja: 'トゥールーズ',
    name_en: 'TOULOUSE',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'TLS',
  },
  {
    code: 'TLN',
    name_ja: 'トゥーロン',
    name_en: 'TOULON',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'TLN',
  },
  {
    code: 'TOE',
    name_ja: 'トズール',
    name_en: 'TOZEUR',
    area_code: 'afr',
    country_code: 'TN',
    flag: 1,
    display: null,
    air_city_code: 'TOE',
  },
  {
    code: 'TAB',
    name_ja: 'トバコ',
    name_en: 'TOBAGO',
    area_code: 'sam',
    country_code: 'TT',
    flag: 1,
    display: null,
    air_city_code: 'TAB',
  },
  {
    code: 'TBS',
    name_ja: 'トビリシ',
    name_en: 'TBILISI',
    area_code: 'eur',
    country_code: 'GE',
    flag: 1,
    display: null,
    air_city_code: 'TBS',
  },
  {
    code: 'TOP',
    name_ja: 'トピーカ',
    name_en: 'TOPEKA（カンザス州）',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TOP',
  },
  {
    code: 'TKK',
    name_ja: 'トラック',
    name_en: 'TRUK',
    area_code: 'mic',
    country_code: 'FM',
    flag: 1,
    display: null,
    air_city_code: 'TKK',
  },
  {
    code: 'TVC',
    name_ja: 'トラバース',
    name_en: 'TRAVERSE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TVC',
  },
  {
    code: 'TPS',
    name_ja: 'トラパニ',
    name_en: 'TRAPANI',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'TPS',
  },
  {
    code: 'TZX',
    name_ja: 'トラブゾン',
    name_en: 'TRABZON',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'TZX',
  },
  {
    code: 'TGN',
    name_ja: 'トララルゴン',
    name_en: 'TRARALGON',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'TGN',
  },
  {
    code: 'TST',
    name_ja: 'トラン',
    name_en: 'TRANG',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'TST',
  },
  {
    code: 'TDX',
    name_ja: 'トラート',
    name_en: 'TRAT',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'TDX',
  },
  {
    code: 'TRS',
    name_ja: 'トリエステ',
    name_en: 'TRIESTE',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'TRS',
  },
  {
    code: 'TDD',
    name_ja: 'トリニダ',
    name_en: 'TRINIDAD',
    area_code: 'sam',
    country_code: 'BO',
    flag: 1,
    display: null,
    air_city_code: 'TDD',
  },
  {
    code: 'TRN',
    name_ja: 'トリノ',
    name_en: 'TURIN',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: 5,
    air_city_code: 'TRN',
  },
  {
    code: 'TRV',
    name_ja: 'トリバンドラム',
    name_en: 'TRIVANDRUM',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'TRV',
  },
  {
    code: 'TIP',
    name_ja: 'トリポリ',
    name_en: 'TRIPOLI',
    area_code: 'afr',
    country_code: 'LY',
    flag: 1,
    display: null,
    air_city_code: 'TIP',
  },
  {
    code: 'TRU',
    name_ja: 'トルヒーリョ',
    name_en: 'TRUJILLO',
    area_code: 'sam',
    country_code: 'PE',
    flag: 1,
    display: null,
    air_city_code: 'TRU',
  },
  {
    code: 'TRC',
    name_ja: 'トレオン',
    name_en: 'TORREON',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'TRC',
  },
  {
    code: 'TCB',
    name_ja: 'トレジャーカイ',
    name_en: 'TREASURE CAY',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'TCB',
  },
  {
    code: 'TOL',
    name_ja: 'トレド',
    name_en: 'TOREDO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TOL',
  },
  {
    code: 'TTN',
    name_ja: 'トレントン',
    name_en: 'TRENTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TTN',
  },
  {
    code: 'TOS',
    name_ja: 'トロムソ',
    name_en: 'TROMSO',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'TOS',
  },
  {
    code: 'YTO',
    name_ja: 'トロント',
    name_en: 'TORONTO',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: 2,
    air_city_code: 'YTO',
  },
  {
    code: 'TRD',
    name_ja: 'トロンヘイム',
    name_en: 'TRONDHEIM',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'TRD',
  },
  {
    code: 'THN',
    name_ja: 'トロールハッタン',
    name_en: 'TROLLHATTAN',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'THN',
  },
  {
    code: 'TBU',
    name_ja: 'トンガタプ',
    name_en: 'TONGATAPU',
    area_code: 'oce',
    country_code: 'TO',
    flag: 1,
    display: null,
    air_city_code: 'TBU',
  },
  {
    code: 'YTH',
    name_ja: 'トンプソン',
    name_en: 'THOMPSON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YTH',
  },
  {
    code: 'DYU',
    name_ja: 'ドゥシャンベ',
    name_en: 'DUSHANBE',
    area_code: 'asi',
    country_code: 'TJ',
    flag: 1,
    display: null,
    air_city_code: 'DYU',
  },
  {
    code: 'DBV',
    name_ja: 'ドゥブロブニク',
    name_en: 'DUBROVNIK',
    area_code: 'eur',
    country_code: 'HR',
    flag: 1,
    display: null,
    air_city_code: 'DBV',
  },
  {
    code: 'DRO',
    name_ja: 'ドゥランゴ',
    name_en: 'DURANGO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DRO',
  },
  {
    code: 'DLA',
    name_ja: 'ドゥーアラ',
    name_en: 'DOUALA',
    area_code: 'afr',
    country_code: 'CM',
    flag: 1,
    display: null,
    air_city_code: 'DLA',
  },
  {
    code: 'DNK',
    name_ja: 'ドニエペトロフスク',
    name_en: 'DNEPROPETROVSK',
    area_code: 'eur',
    country_code: 'UA',
    flag: 1,
    display: null,
    air_city_code: 'DNK',
  },
  {
    code: 'DOK',
    name_ja: 'ドネツク',
    name_en: 'DONETSK',
    area_code: 'eur',
    country_code: 'UA',
    flag: 1,
    display: null,
    air_city_code: 'DOK',
  },
  {
    code: 'DXB',
    name_ja: 'ドバイ',
    name_en: 'DUBAI',
    area_code: 'afr',
    country_code: 'AE',
    flag: 1,
    display: 1,
    air_city_code: 'DXB',
  },
  {
    code: 'DBO',
    name_ja: 'ドボ',
    name_en: 'DUBBO',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'DBO',
  },
  {
    code: 'DGT',
    name_ja: 'ドマゲテ',
    name_en: 'DUMAGUETE',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'DGT',
  },
  {
    code: 'DOM',
    name_ja: 'ドミニカ',
    name_en: 'DOMINICA',
    area_code: 'sam',
    country_code: 'DM',
    flag: 1,
    display: null,
    air_city_code: 'DOM',
  },
  {
    code: 'YHD',
    name_ja: 'ドライデン',
    name_en: 'FRYDEN',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YHD',
  },
  {
    code: 'DTM',
    name_ja: 'ドルトムント',
    name_en: 'DORTMUND',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'DTM',
  },
  {
    code: 'DRS',
    name_ja: 'ドレスデン',
    name_en: 'DRESDEN',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: 4,
    air_city_code: 'DRS',
  },
  {
    code: 'VDH',
    name_ja: 'ドンホイ',
    name_en: 'DONG HOI',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'VDH',
  },
  {
    code: 'DHN',
    name_ja: 'ドーサン',
    name_en: 'DOTHAN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'DHN',
  },
  {
    code: 'YDQ',
    name_ja: 'ドーソンクリーク',
    name_en: 'DAWSON CREEK',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YDQ',
  },
  {
    code: 'DOH',
    name_ja: 'ドーハ',
    name_en: 'DOHA',
    area_code: 'afr',
    country_code: 'QA',
    flag: 1,
    display: null,
    air_city_code: 'DOH',
  },
  {
    code: 'XLV',
    name_ja: 'ナイアガラフォールズ（カナダ）',
    name_en: 'NIAGARA FALLS(CANADA',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YTO',
  },
  {
    code: 'IAG',
    name_ja: 'ナイアガラフォールズ（ニューヨーク州',
    name_en: 'NIAGARA FALLS(NY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'IAG',
  },
  {
    code: 'NBO',
    name_ja: 'ナイロビ',
    name_en: 'NAIROBI',
    area_code: 'afr',
    country_code: 'KE',
    flag: 1,
    display: 1,
    air_city_code: 'NBO',
  },
  {
    code: 'INU',
    name_ja: 'ナウル',
    name_en: 'NAURU',
    area_code: 'oce',
    country_code: 'NR',
    flag: 1,
    display: null,
    air_city_code: 'INU',
  },
  {
    code: 'WNP',
    name_ja: 'ナガ',
    name_en: 'NAGA',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'WNP',
  },
  {
    code: 'NAG',
    name_ja: 'ナグプール',
    name_en: 'NAGPUR',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'NAG',
  },
  {
    code: 'KOP',
    name_ja: 'ナコンパノム',
    name_en: 'NAKHON PHANOM',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'KOP',
  },
  {
    code: 'NAK',
    name_ja: 'ナコンラチャシマ',
    name_en: 'NAKHON RATCHASIMA',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'NAK',
  },
  {
    code: 'NST',
    name_ja: 'ナコン・シータマラート',
    name_en: 'NAKHON SITHAMMARAT',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'NST',
  },
  {
    code: 'NJF',
    name_ja: 'ナジャフ',
    name_en: 'AL NAJAF',
    area_code: 'afr',
    country_code: 'IQ',
    flag: 1,
    display: null,
    air_city_code: 'NJF',
  },
  {
    code: 'BNA',
    name_ja: 'ナッシュビル',
    name_en: 'NASHVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BNA',
  },
  {
    code: 'NAS',
    name_ja: 'ナッソー',
    name_en: 'NASSAU',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: 1,
    air_city_code: 'NAS',
  },
  {
    code: 'YCD',
    name_ja: 'ナナイモ',
    name_en: 'NANAIMO',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YCD',
  },
  {
    code: 'APF',
    name_ja: 'ナプルズ',
    name_en: 'NAPLES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'APF',
  },
  {
    code: 'NVT',
    name_ja: 'ナベガンテス',
    name_en: 'NAVEGANTES',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'NVT',
  },
  {
    code: 'NAP',
    name_ja: 'ナポリ',
    name_en: 'NAPLES',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: 6,
    air_city_code: 'NAP',
  },
  {
    code: 'NAW',
    name_ja: 'ナラティワート',
    name_en: 'NARATHIWAT',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'NAW',
  },
  {
    code: 'NAA',
    name_ja: 'ナラブライ',
    name_en: 'NARRABRI',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'NAA',
  },
  {
    code: 'NRA',
    name_ja: 'ナランデラ',
    name_en: 'NARANDERA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'NRA',
  },
  {
    code: 'NKG',
    name_ja: 'ナンキン（南京）',
    name_en: 'NANJING',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 8,
    air_city_code: 'NKG',
  },
  {
    code: 'ACK',
    name_ja: 'ナンタッケット',
    name_en: 'NANTUCKET',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ACK',
  },
  {
    code: 'NAN',
    name_ja: 'ナンディ',
    name_en: 'NADI',
    area_code: 'oce',
    country_code: 'FJ',
    flag: 1,
    display: null,
    air_city_code: 'NAN',
  },
  {
    code: 'NTE',
    name_ja: 'ナント',
    name_en: 'NANTES',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'NTE',
  },
  {
    code: 'NNG',
    name_ja: 'ナンニン（南寧）',
    name_en: 'NANNING',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'NNG',
  },
  {
    code: 'APL',
    name_ja: 'ナンプラ',
    name_en: 'NAMPULA',
    area_code: 'afr',
    country_code: 'MZ',
    flag: 1,
    display: null,
    air_city_code: 'APL',
  },
  {
    code: 'NIM',
    name_ja: 'ニアメー',
    name_en: 'NIAMEY',
    area_code: 'afr',
    country_code: 'NE',
    flag: 1,
    display: null,
    air_city_code: 'NIM',
  },
  {
    code: 'GOJ',
    name_ja: 'ニジニ・ノブゴロド',
    name_en: 'NIZHNIY NOVGOROD',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'GOJ',
  },
  {
    code: 'NBC',
    name_ja: 'ニジネカムスク',
    name_en: 'NIZHNEKAMSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'NBC',
  },
  {
    code: 'NHA',
    name_ja: 'ニャチャン',
    name_en: 'NHA TRANG',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'NHA',
  },
  {
    code: 'NUE',
    name_ja: 'ニュルンベルグ',
    name_en: 'NUREMBERG',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'NUE',
  },
  {
    code: 'MSY',
    name_ja: 'ニューオーリンズ',
    name_en: 'NEW ORLEANS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MSY',
  },
  {
    code: 'NCL',
    name_ja: 'ニューキャッスル',
    name_en: 'NEWCASTLE',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'NCL',
  },
  {
    code: 'NTL',
    name_ja: 'ニューキャッスル',
    name_en: 'NEWCASTLE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'NTL',
  },
  {
    code: 'NQY',
    name_ja: 'ニューキー',
    name_en: 'NEWQUAY',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'NQY',
  },
  {
    code: 'SWF',
    name_ja: 'ニューバーグ',
    name_en: 'NEWBURGH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SWF',
  },
  {
    code: 'EWN',
    name_ja: 'ニューバーン',
    name_en: 'NEW BERN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EWN',
  },
  {
    code: 'NPL',
    name_ja: 'ニュープリマス',
    name_en: 'NEW PLYMOUTH',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'NPL',
  },
  {
    code: 'HVN',
    name_ja: 'ニューヘブン',
    name_en: 'NEW HAVEN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HVN',
  },
  {
    code: 'EWB',
    name_ja: 'ニューベッドフォード',
    name_en: 'NEW BEDFORD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EWB',
  },
  {
    code: 'PHF',
    name_ja: 'ニューポートニューズ',
    name_en: 'NEWPORT NEWS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PHF',
  },
  {
    code: 'NYC',
    name_ja: 'ニューヨーク',
    name_en: 'NEW YORK CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: 1,
    air_city_code: 'NYC',
  },
  {
    code: 'GON',
    name_ja: 'ニューロンドンロートン',
    name_en: 'NEW LONDON GROTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GON',
  },
  {
    code: 'NCE',
    name_ja: 'ニース',
    name_en: 'NICE',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: 2,
    air_city_code: 'NCE',
  },
  {
    code: 'FNI',
    name_ja: 'ニーム',
    name_en: 'NIMES',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'FNI',
  },
  {
    code: 'NKC',
    name_ja: 'ヌアクショット',
    name_en: 'NOUAKCHOTT',
    area_code: 'afr',
    country_code: 'MR',
    flag: 1,
    display: null,
    air_city_code: 'NKC',
  },
  {
    code: 'NLD',
    name_ja: 'ヌエボ ラレド',
    name_en: 'NUEVO LAREDO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'NLD',
  },
  {
    code: 'NLA',
    name_ja: 'ヌドラ',
    name_en: 'NDOLA',
    area_code: 'afr',
    country_code: 'ZM',
    flag: 1,
    display: null,
    air_city_code: 'NLA',
  },
  {
    code: 'NOU',
    name_ja: 'ヌーメア',
    name_en: 'NOUMEA',
    area_code: 'oce',
    country_code: 'NC',
    flag: 1,
    display: 1,
    air_city_code: 'NOU',
  },
  {
    code: 'NQN',
    name_ja: 'ネウケン',
    name_en: 'NEUQUEN',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'NQN',
  },
  {
    code: 'NPH',
    name_ja: 'ネフィ',
    name_en: 'NEPHI',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'NPH',
  },
  {
    code: 'MQP',
    name_ja: 'ネルスポロイト',
    name_en: 'NELSPRUIT',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'MQP',
  },
  {
    code: 'NSN',
    name_ja: 'ネルソン',
    name_en: 'NELSON',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'NSN',
  },
  {
    code: 'NAV',
    name_ja: 'ネヴシェヒール',
    name_en: 'NEVSEHIR',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'NAV',
  },
  {
    code: 'NAT',
    name_ja: 'ネーテル',
    name_en: 'NATAL',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'NAT',
  },
  {
    code: 'NPE',
    name_ja: 'ネ－ピア－',
    name_en: 'NAPIER',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'NPE',
  },
  {
    code: 'TYS',
    name_ja: 'ノックスビル',
    name_en: 'KNOXVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TYS',
  },
  {
    code: 'OVB',
    name_ja: 'ノボシビルスク',
    name_en: 'NOVOSIBIRSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'OVB',
  },
  {
    code: 'NRK',
    name_ja: 'ノルチェピング',
    name_en: 'NORRKOPING',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'NRK',
  },
  {
    code: 'NWI',
    name_ja: 'ノーウィッチ',
    name_en: 'NORWICH',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'NWI',
  },
  {
    code: 'OIC',
    name_ja: 'ノーウィッチ',
    name_en: 'NORWICH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OIC',
  },
  {
    code: 'ELH',
    name_ja: 'ノースエルーセラ',
    name_en: 'NORTH ELEUTHERA',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'ELH',
  },
  {
    code: 'LBF',
    name_ja: 'ノースプラット',
    name_en: 'NORTH PLATTE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LBF',
  },
  {
    code: 'YYB',
    name_ja: 'ノースベイ',
    name_en: 'NORTH BAY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYB',
  },
  {
    code: 'OTH',
    name_ja: 'ノースベンド（オレゴン州）',
    name_en: 'NORTH BEND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OTH',
  },
  {
    code: 'NLK',
    name_ja: 'ノーフォーク',
    name_en: 'NORFOLK ISLAND',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'NLK',
  },
  {
    code: 'OFK',
    name_ja: 'ノーフォーク（ネブラスカ州）',
    name_en: 'NORFOLK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OFK',
  },
  {
    code: 'ORF',
    name_ja: 'ノーフォーク（バージニア州）',
    name_en: 'NORFOLK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ORF',
  },
  {
    code: 'OME',
    name_ja: 'ノーマ',
    name_en: 'NOME',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'OME',
  },
  {
    code: 'HYA',
    name_ja: 'ハイアニス（マサチューセッツ州）',
    name_en: 'HYANNIS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HYA',
  },
  {
    code: 'HAK',
    name_ja: 'ハイコウ（海口）',
    name_en: 'HAIKOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HAK',
  },
  {
    code: 'HYD',
    name_ja: 'ハイデラバード',
    name_en: 'HYDERABAD',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'HYD',
  },
  {
    code: 'HDB',
    name_ja: 'ハイデルベルグ',
    name_en: 'HEIDELBERG',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'HDB',
  },
  {
    code: 'HPH',
    name_ja: 'ハイフォン',
    name_en: 'HAIPHONG',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'HPH',
  },
  {
    code: 'YOJ',
    name_ja: 'ハイレベル',
    name_en: 'HIGH LEVEL',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YOJ',
  },
  {
    code: 'HNS',
    name_ja: 'ハインズ（アラスカ州）',
    name_en: 'HAINES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HNS',
  },
  {
    code: 'HAU',
    name_ja: 'ハウゲスン',
    name_en: 'HAUGESUND',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'HAU',
  },
  {
    code: 'HDY',
    name_ja: 'ハジャイ',
    name_en: 'HAT YAI',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'HDY',
  },
  {
    code: 'HSI',
    name_ja: 'ハスティングス',
    name_en: 'HASTINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HSI',
  },
  {
    code: 'VN1',
    name_ja: 'ハティン',
    name_en: 'Ha Tinh',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'VII',
  },
  {
    code: 'HNM',
    name_ja: 'ハナ（マウイ島）',
    name_en: 'HANA (MAUI)',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 2,
    air_city_code: 'HNM',
  },
  {
    code: 'CHQ',
    name_ja: 'ハニア',
    name_en: 'CHANIA',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'CHQ',
  },
  {
    code: 'HAN',
    name_ja: 'ハノイ',
    name_en: 'HANOI',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: 2,
    air_city_code: 'HAN',
  },
  {
    code: 'HAJ',
    name_ja: 'ハノーバー',
    name_en: 'HANOVER',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'HAJ',
  },
  {
    code: 'HAE',
    name_ja: 'ハバスパイ',
    name_en: 'HAVASUPAI',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HAE',
  },
  {
    code: 'HAV',
    name_ja: 'ハバナ',
    name_en: 'HAVANA',
    area_code: 'sam',
    country_code: 'CU',
    flag: 1,
    display: 1,
    air_city_code: 'HAV',
  },
  {
    code: 'KHV',
    name_ja: 'ハバロフスク',
    name_en: 'KHABAROVSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'KHV',
  },
  {
    code: 'HVR',
    name_ja: 'ハバー',
    name_en: 'HAVRE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HVR',
  },
  {
    code: 'GBE',
    name_ja: 'ハボローネ',
    name_en: 'GABORONE',
    area_code: 'afr',
    country_code: 'BW',
    flag: 1,
    display: null,
    air_city_code: 'GBE',
  },
  {
    code: 'HLZ',
    name_ja: 'ハミルトン',
    name_en: 'HAMILTON',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'HLZ',
  },
  {
    code: 'YHM',
    name_ja: 'ハミルトン',
    name_en: 'HAMILTON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YTO',
  },
  {
    code: 'HTI',
    name_ja: 'ハミルトン島',
    name_en: 'HAMILTON ISLAND',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'HTI',
  },
  {
    code: 'HRE',
    name_ja: 'ハラーレ',
    name_en: 'HARARE',
    area_code: 'afr',
    country_code: 'ZW',
    flag: 1,
    display: null,
    air_city_code: 'HRE',
  },
  {
    code: 'HRK',
    name_ja: 'ハリコフ',
    name_en: 'KHARKOV',
    area_code: 'eur',
    country_code: 'UA',
    flag: 1,
    display: null,
    air_city_code: 'HRK',
  },
  {
    code: 'HAR',
    name_ja: 'ハリスバーグ',
    name_en: 'HARRISBURG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HAR',
  },
  {
    code: 'HRO',
    name_ja: 'ハリスン',
    name_en: 'HARRISON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HRO',
  },
  {
    code: 'YHZ',
    name_ja: 'ハリファクス',
    name_en: 'HALIFAX',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YHZ',
  },
  {
    code: 'KRT',
    name_ja: 'ハルツーム',
    name_en: 'KHARTOUM',
    area_code: 'afr',
    country_code: 'SD',
    flag: 1,
    display: null,
    air_city_code: 'KRT',
  },
  {
    code: 'HAD',
    name_ja: 'ハルムスタード',
    name_en: 'HALMSTAD',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'HAD',
  },
  {
    code: 'HLO',
    name_ja: 'ハロン',
    name_en: 'HALONG',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'HAN',
  },
  {
    code: 'CMX',
    name_ja: 'ハンクック',
    name_en: 'HANCOCK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CMX',
  },
  {
    code: 'HGH',
    name_ja: 'ハンチョウ（杭州）',
    name_en: 'HANGZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HGH',
  },
  {
    code: 'HSV',
    name_ja: 'ハンツビル',
    name_en: 'HUNTSVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HSV',
  },
  {
    code: 'HTS',
    name_ja: 'ハンティントン',
    name_en: 'HUNTINGTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HTS',
  },
  {
    code: 'HMA',
    name_ja: 'ハンティ・マンシースク',
    name_en: 'KHANTY-MANSIYSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'HMA',
  },
  {
    code: 'HRI',
    name_ja: 'ハンバントタ',
    name_en: 'HAMBANTOTA',
    area_code: 'asi',
    country_code: 'LK',
    flag: 1,
    display: null,
    air_city_code: 'HRI',
  },
  {
    code: 'HUY',
    name_ja: 'ハンバーサイド',
    name_en: 'HUMBERSIDE',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'HUY',
  },
  {
    code: 'HAM',
    name_ja: 'ハンブルグ',
    name_en: 'HAMBURG',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'HAM',
  },
  {
    code: 'EVE',
    name_ja: 'ハーシュタ・ナルヴィク',
    name_en: 'HARSTAD NARVIK',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'EVE',
  },
  {
    code: 'BDL',
    name_ja: 'ハートフォード',
    name_en: 'HARTFORD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BDL',
  },
  {
    code: 'HFD',
    name_ja: 'ハートフォード',
    name_en: 'HARTFORD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HFD',
  },
  {
    code: 'HVB',
    name_ja: 'ハービーベイ',
    name_en: 'HERVEY BAY',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'HVB',
  },
  {
    code: 'HRL',
    name_ja: 'ハーリンゲン',
    name_en: 'HARLINGEN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HRL',
  },
  {
    code: 'VIS',
    name_ja: 'バイセリア',
    name_en: 'VISALIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'VIS',
  },
  {
    code: 'BYU',
    name_ja: 'バイロイト',
    name_en: 'BAYREUTH',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'BYU',
  },
  {
    code: 'BAG',
    name_ja: 'バギオ',
    name_en: 'BAGUIO',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'BAG',
  },
  {
    code: 'BAK',
    name_ja: 'バクー',
    name_en: 'BAKU',
    area_code: 'asi',
    country_code: 'AZ',
    flag: 1,
    display: null,
    air_city_code: 'BAK',
  },
  {
    code: 'BGW',
    name_ja: 'バグダッド',
    name_en: 'BAGHDAD',
    area_code: 'afr',
    country_code: 'IQ',
    flag: 1,
    display: null,
    air_city_code: 'BGW',
  },
  {
    code: 'IXB',
    name_ja: 'バグドグラ',
    name_en: 'BAGDOGRA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IXB',
  },
  {
    code: 'BGL',
    name_ja: 'バグラン',
    name_en: 'ＢＡＧＬＵＮＧ',
    area_code: 'asi',
    country_code: 'NP',
    flag: 1,
    display: null,
    air_city_code: 'BGL',
  },
  {
    code: 'BCD',
    name_ja: 'バコロド',
    name_en: 'BACOLOD',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'BCD',
  },
  {
    code: 'YBG',
    name_ja: 'バゴトビル',
    name_en: 'BAGOTVILLE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YBG',
  },
  {
    code: 'BIA',
    name_ja: 'バスティア',
    name_en: 'BASTIA',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'BIA',
  },
  {
    code: 'BSR',
    name_ja: 'バスラ',
    name_en: 'BASRAH',
    area_code: 'afr',
    country_code: 'IQ',
    flag: 1,
    display: null,
    air_city_code: 'BSR',
  },
  {
    code: 'BTH',
    name_ja: 'バタンバツバサール',
    name_en: 'BATAM BATU BESAR',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'BTH',
  },
  {
    code: 'BJZ',
    name_ja: 'バダホス',
    name_en: 'BADAJOZ',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'BJZ',
  },
  {
    code: 'LB1',
    name_ja: 'バダンガス',
    name_en: '',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'PPS',
  },
  {
    code: 'BUF',
    name_ja: 'バッファロー',
    name_en: 'BUFFALO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BUF',
  },
  {
    code: 'VAI',
    name_ja: 'バニモ',
    name_en: 'VANIMO',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'VAI',
  },
  {
    code: 'VAV',
    name_ja: 'ババウ',
    name_en: 'VAVAU',
    area_code: 'oce',
    country_code: 'TO',
    flag: 1,
    display: null,
    air_city_code: 'VAV',
  },
  {
    code: 'ABM',
    name_ja: 'バマガ',
    name_en: 'BAMAGA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'ABM',
  },
  {
    code: 'BKO',
    name_ja: 'バマコ',
    name_en: 'BAMAKO',
    area_code: 'afr',
    country_code: 'ML',
    flag: 1,
    display: null,
    air_city_code: 'BKO',
  },
  {
    code: 'BDA',
    name_ja: 'バミュ－ダ',
    name_en: 'BERMUDA',
    area_code: 'sam',
    country_code: 'BM',
    flag: 1,
    display: null,
    air_city_code: 'BDA',
  },
  {
    code: 'BAY',
    name_ja: 'バヤ・マーレ',
    name_en: 'BAIA MARE',
    area_code: 'eur',
    country_code: 'RO',
    flag: 1,
    display: null,
    air_city_code: 'BAY',
  },
  {
    code: 'VNS',
    name_ja: 'バラナシ',
    name_en: 'VARANASI',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'VNS',
  },
  {
    code: 'BAQ',
    name_ja: 'バランチャ',
    name_en: 'BARRANQUILLA',
    area_code: 'sam',
    country_code: 'CO',
    flag: 1,
    display: null,
    air_city_code: 'BAQ',
  },
  {
    code: 'BRI',
    name_ja: 'バリ',
    name_en: 'BARI',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'BRI',
  },
  {
    code: 'BAL',
    name_ja: 'バリ',
    name_en: 'BALI',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: 4,
    air_city_code: 'DPS',
  },
  {
    code: 'BPN',
    name_ja: 'バリクパパン',
    name_en: 'BALIKPAPAN',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'BPN',
  },
  {
    code: 'BNK',
    name_ja: 'バリナ',
    name_en: 'BALLINA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'BNK',
  },
  {
    code: 'VLL',
    name_ja: 'バリャドリー',
    name_en: 'VALLADOLID',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'VLL',
  },
  {
    code: 'BCN',
    name_ja: 'バルセロナ',
    name_en: 'BARCELONA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: 2,
    air_city_code: 'BCN',
  },
  {
    code: 'BLA',
    name_ja: 'バルセロナ',
    name_en: 'BARCELONA',
    area_code: 'sam',
    country_code: 'VE',
    flag: 1,
    display: null,
    air_city_code: 'BLA',
  },
  {
    code: 'VDZ',
    name_ja: 'バルディーズ',
    name_en: 'VALDEZ',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'VDZ',
  },
  {
    code: 'VLD',
    name_ja: 'バルドスタ',
    name_en: 'VALDOSTA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'VLD',
  },
  {
    code: 'YVO',
    name_ja: 'バルドール',
    name_en: 'VAL D&rsquo;OR',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YVO',
  },
  {
    code: 'VAR',
    name_ja: 'バルナ',
    name_en: 'VARNA',
    area_code: 'eur',
    country_code: 'BG',
    flag: 1,
    display: null,
    air_city_code: 'VAR',
  },
  {
    code: 'BGI',
    name_ja: 'バルバドス',
    name_en: 'BARBADOS',
    area_code: 'sam',
    country_code: 'BB',
    flag: 1,
    display: null,
    air_city_code: 'BGI',
  },
  {
    code: 'VLC',
    name_ja: 'バレンシア',
    name_en: 'VALENCIA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: 3,
    air_city_code: 'VLC',
  },
  {
    code: 'VLN',
    name_ja: 'バレンシア',
    name_en: 'VALENCIA',
    area_code: 'sam',
    country_code: 'VE',
    flag: 1,
    display: null,
    air_city_code: 'VLN',
  },
  {
    code: 'BRW',
    name_ja: 'バロー',
    name_en: 'BARROW',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BRW',
  },
  {
    code: 'VAN',
    name_ja: 'バン',
    name_en: 'VAN',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'VAN',
  },
  {
    code: 'BLR',
    name_ja: 'バンガロール',
    name_en: 'BANGALORE',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'BLR',
  },
  {
    code: 'BGR',
    name_ja: 'バンガー',
    name_en: 'BANGOR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BGR',
  },
  {
    code: 'YVR',
    name_ja: 'バンクーバー',
    name_en: 'VANCOUVER',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: 3,
    air_city_code: 'YVR',
  },
  {
    code: 'BKK',
    name_ja: 'バンコク',
    name_en: 'BANGKOK',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: 1,
    air_city_code: 'BKK',
  },
  {
    code: 'BDJ',
    name_ja: 'バンジャルマシン',
    name_en: 'BANJARMASIN',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'BDJ',
  },
  {
    code: 'BTJ',
    name_ja: 'バンダアチェ',
    name_en: 'BANDA ACEH',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'BTJ',
  },
  {
    code: 'BND',
    name_ja: 'バンダルアバス',
    name_en: 'BANDAR ABBAS',
    area_code: 'afr',
    country_code: 'IR',
    flag: 1,
    display: null,
    air_city_code: 'BND',
  },
  {
    code: 'BWN',
    name_ja: 'バンダルスリベガワン',
    name_en: 'BANDAR SERI BEGAWAN',
    area_code: 'asi',
    country_code: 'BN',
    flag: 1,
    display: null,
    air_city_code: 'BWN',
  },
  {
    code: 'TKG',
    name_ja: 'バンダ－ランプ－ン',
    name_en: 'BANDAR LAMPUNG',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'TKG',
  },
  {
    code: 'BDO',
    name_ja: 'バンドウン',
    name_en: 'BANDUNG',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'BDO',
  },
  {
    code: 'YBA',
    name_ja: 'バンフ',
    name_en: 'BANFF',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: 4,
    air_city_code: 'YBA',
  },
  {
    code: 'BMV',
    name_ja: 'バンメトート',
    name_en: 'BANMETHUOT',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'BMV',
  },
  {
    code: 'ZBF',
    name_ja: 'バースルスト',
    name_en: 'BATHURST',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'ZBF',
  },
  {
    code: 'BSL',
    name_ja: 'バーゼル',
    name_en: 'BASEL',
    area_code: 'eur',
    country_code: 'CH',
    flag: 1,
    display: null,
    air_city_code: 'BSL',
  },
  {
    code: 'BTR',
    name_ja: 'バートンルージュ',
    name_en: 'BATON ROUGE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BTR',
  },
  {
    code: 'VEL',
    name_ja: 'バーナル',
    name_en: 'VERNAL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'VEL',
  },
  {
    code: 'BWT',
    name_ja: 'バーニー',
    name_en: 'BURNIE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'BWT',
  },
  {
    code: 'BHB',
    name_ja: 'バーハーバー',
    name_en: 'BAR HARBOUR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BHB',
  },
  {
    code: 'BUR',
    name_ja: 'バーバンク',
    name_en: 'BURBANK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BUR',
  },
  {
    code: 'BHM',
    name_ja: 'バーミンガム',
    name_en: 'BIRMINGHAM',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BHM',
  },
  {
    code: 'BHX',
    name_ja: 'バーミンガム',
    name_en: 'BIRMINGHAM',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'BHX',
  },
  {
    code: 'BRL',
    name_ja: 'バーリントン（アイオワ州）',
    name_en: 'BURLINGTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BRL',
  },
  {
    code: 'BTV',
    name_ja: 'バーリントン（バーモント州）',
    name_en: 'BURLINGTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BTV',
  },
  {
    code: 'BAH',
    name_ja: 'バーレーン',
    name_en: 'BAHRAIN',
    area_code: 'afr',
    country_code: 'BH',
    flag: 1,
    display: null,
    air_city_code: 'BAH',
  },
  {
    code: 'PKU',
    name_ja: 'パカンバル',
    name_en: 'PEKANBARU',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'PKU',
  },
  {
    code: 'PPG',
    name_ja: 'パゴパゴ',
    name_en: 'PAGO PAGO',
    area_code: 'oce',
    country_code: 'AS',
    flag: 1,
    display: null,
    air_city_code: 'PPG',
  },
  {
    code: 'PSC',
    name_ja: 'パスコ',
    name_en: 'PASCO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PSC',
  },
  {
    code: 'PYX',
    name_ja: 'パタヤ',
    name_en: 'PATTAYA',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'PYX',
  },
  {
    code: 'PDG',
    name_ja: 'パダン',
    name_en: 'PADANG',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'PDG',
  },
  {
    code: 'PAH',
    name_ja: 'パデュカ',
    name_en: 'PASUCAH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PAH',
  },
  {
    code: 'PAT',
    name_ja: 'パトナ',
    name_en: 'PATNA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'PAT',
  },
  {
    code: 'PTY',
    name_ja: 'パナマシティ',
    name_en: 'PANAMA CITY',
    area_code: 'sam',
    country_code: 'PA',
    flag: 1,
    display: null,
    air_city_code: 'PTY',
  },
  {
    code: 'PFO',
    name_ja: 'パフォス',
    name_en: 'PAPHOS',
    area_code: 'eur',
    country_code: 'CY',
    flag: 1,
    display: null,
    air_city_code: 'PFO',
  },
  {
    code: 'PPT',
    name_ja: 'パペーテ',
    name_en: 'PAPEETE',
    area_code: 'oce',
    country_code: 'PF',
    flag: 1,
    display: null,
    air_city_code: 'PPT',
  },
  {
    code: 'PBM',
    name_ja: 'パラマリボ',
    name_en: 'PARAMARIBO',
    area_code: 'sam',
    country_code: 'SR',
    flag: 1,
    display: null,
    air_city_code: 'PBM',
  },
  {
    code: 'PI1',
    name_ja: 'パラワン島',
    name_en: '',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'PPS',
  },
  {
    code: 'PAR',
    name_ja: 'パリ',
    name_en: 'PARIS',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: 1,
    air_city_code: 'PAR',
  },
  {
    code: 'PRX',
    name_ja: 'パリ（テキサス州）',
    name_en: 'PARIS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PRX',
  },
  {
    code: 'PLW',
    name_ja: 'パル',
    name_en: 'PALU',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'PLW',
  },
  {
    code: 'PMF',
    name_ja: 'パルマ',
    name_en: 'PARMA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'PMF',
  },
  {
    code: 'PMI',
    name_ja: 'パルマ デ マヨルカ',
    name_en: 'PALMA DE MALLORCA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'PMI',
  },
  {
    code: 'PMD',
    name_ja: 'パルンダレー',
    name_en: 'PALMDALE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PMD',
  },
  {
    code: 'PMO',
    name_ja: 'パレルモ',
    name_en: 'PALERMO',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'PMO',
  },
  {
    code: 'PLM',
    name_ja: 'パレンバン',
    name_en: 'PALENBANG',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'PLM',
  },
  {
    code: 'PBH',
    name_ja: 'パロ',
    name_en: 'PARO',
    area_code: 'asi',
    country_code: 'BT',
    flag: 1,
    display: null,
    air_city_code: 'PBH',
  },
  {
    code: 'PG1',
    name_ja: 'パンガー',
    name_en: '',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'HKT',
  },
  {
    code: 'PKG',
    name_ja: 'パンコール',
    name_en: 'PANGKOR',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'PKG',
  },
  {
    code: 'PNL',
    name_ja: 'パンテッレリーア',
    name_en: 'PANTELLERIA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'PNL',
  },
  {
    code: 'PNA',
    name_ja: 'パンプロ－ナ',
    name_en: 'PAMPLONA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'PNA',
  },
  {
    code: 'PKB',
    name_ja: 'パーカーズバーグ',
    name_en: 'PARKERSBURG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PKB',
  },
  {
    code: 'PKE',
    name_ja: 'パークス',
    name_en: 'PARKES',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'PKE',
  },
  {
    code: 'PKZ',
    name_ja: 'パークセー',
    name_en: 'PAKSE',
    area_code: 'asi',
    country_code: 'LA',
    flag: 1,
    display: null,
    air_city_code: 'PKZ',
  },
  {
    code: 'PER',
    name_ja: 'パース',
    name_en: 'PERTH',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'PER',
  },
  {
    code: 'PPF',
    name_ja: 'パーソンズ',
    name_en: 'PARSONS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PPF',
  },
  {
    code: 'PAD',
    name_ja: 'パーデンボルン',
    name_en: 'PADERBORN',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'PAD',
  },
  {
    code: 'PMR',
    name_ja: 'パーマストンノース',
    name_en: 'PALMERSTON NORTH',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'PMR',
  },
  {
    code: 'PSP',
    name_ja: 'パームスプリングス',
    name_en: 'PALM SPRINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PSP',
  },
  {
    code: 'HKY',
    name_ja: 'ヒッコリー',
    name_en: 'HICKORY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HKY',
  },
  {
    code: 'HIB',
    name_ja: 'ヒビング',
    name_en: 'HIBBING/CHISHOLM',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HIB',
  },
  {
    code: 'HOU',
    name_ja: 'ヒューストン',
    name_en: 'HOUSTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HOU',
  },
  {
    code: 'HON',
    name_ja: 'ヒューロン',
    name_en: 'HURON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HON',
  },
  {
    code: 'HHH',
    name_ja: 'ヒルトンヘッド島',
    name_en: 'HILTON HEAD ISLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HHH',
  },
  {
    code: 'ITO',
    name_ja: 'ヒロ（ハワイ島）',
    name_en: 'HILO (HAWAII)',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 6,
    air_city_code: 'ITO',
  },
  {
    code: 'BIK',
    name_ja: 'ビアク島',
    name_en: 'BIAK',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'BIK',
  },
  {
    code: 'BIQ',
    name_ja: 'ビアリーツ',
    name_en: 'BIARRITZ',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'BIQ',
  },
  {
    code: 'VGO',
    name_ja: 'ビィーゴ',
    name_en: 'VIGO',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'VGO',
  },
  {
    code: 'VTE',
    name_ja: 'ビエンチャン',
    name_en: 'VIENTIANE',
    area_code: 'asi',
    country_code: 'LA',
    flag: 1,
    display: null,
    air_city_code: 'VTE',
  },
  {
    code: 'YYJ',
    name_ja: 'ビクトリア',
    name_en: 'VICTORIA',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: 5,
    air_city_code: 'YYJ',
  },
  {
    code: 'VCT',
    name_ja: 'ビクトリア',
    name_en: 'VICTORIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'VCT',
  },
  {
    code: 'FRU',
    name_ja: 'ビシュケク',
    name_en: 'BISHKEK',
    area_code: 'asi',
    country_code: 'KG',
    flag: 1,
    display: null,
    air_city_code: 'FRU',
  },
  {
    code: 'BIH',
    name_ja: 'ビショップ',
    name_en: 'BISIOP',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BIH',
  },
  {
    code: 'VSA',
    name_ja: 'ビジャエルモッサ',
    name_en: 'VILLAHERMOSA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'VSA',
  },
  {
    code: 'VBY',
    name_ja: 'ビスビー',
    name_en: 'VISBY',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'VBY',
  },
  {
    code: 'BIS',
    name_ja: 'ビスマーク',
    name_en: 'BISMARCK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BIS',
  },
  {
    code: 'VIX',
    name_ja: 'ビトリア',
    name_en: 'VITORIA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'VIX',
  },
  {
    code: 'BIM',
    name_ja: 'ビミニ',
    name_en: 'BIMINI',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'BIM',
  },
  {
    code: 'BTM',
    name_ja: 'ビュッテ',
    name_en: 'BUTTE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BTM',
  },
  {
    code: 'VNO',
    name_ja: 'ビリニュス',
    name_en: 'VILNIUS',
    area_code: 'eur',
    country_code: 'LT',
    flag: 1,
    display: null,
    air_city_code: 'VNO',
  },
  {
    code: 'BIL',
    name_ja: 'ビリングス',
    name_en: 'BILLINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BIL',
  },
  {
    code: 'BIO',
    name_ja: 'ビルバオ',
    name_en: 'BILBAO',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'BIO',
  },
  {
    code: 'BLL',
    name_ja: 'ビルン',
    name_en: 'BILLUND',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'BLL',
  },
  {
    code: 'BGM',
    name_ja: 'ビンガムトン',
    name_en: 'BINGHAMTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BGM',
  },
  {
    code: 'BTU',
    name_ja: 'ビントゥール',
    name_en: 'BINTULU',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'BTU',
  },
  {
    code: 'KNA',
    name_ja: 'ビーニャ デル マル',
    name_en: 'VINA DEL MAR',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'SCL',
  },
  {
    code: 'EIS',
    name_ja: 'ビーフアイランド',
    name_en: 'BEEF ISLAND',
    area_code: 'sam',
    country_code: 'VG',
    flag: 1,
    display: null,
    air_city_code: 'EIS',
  },
  {
    code: 'PIR',
    name_ja: 'ピア',
    name_en: 'PIERRE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PIR',
  },
  {
    code: 'PDS',
    name_ja: 'ピエドラスネグラス',
    name_en: 'PIEDRAS NEGRAS',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'PDS',
  },
  {
    code: 'PSA',
    name_ja: 'ピサ',
    name_en: 'PISA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'PSA',
  },
  {
    code: 'PHS',
    name_ja: 'ピサノローク',
    name_en: 'PHITSANULOK',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'PHS',
  },
  {
    code: 'PIT',
    name_ja: 'ピッツバーグ',
    name_en: 'PITTSBURGH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PIT',
  },
  {
    code: 'PSF',
    name_ja: 'ピッツフィールド（マサチューセッツ州）',
    name_en: 'PITTSFIELD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PSF',
  },
  {
    code: 'YPE',
    name_ja: 'ピースリバー',
    name_en: 'PEACE RIVER',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YPE',
  },
  {
    code: 'PSG',
    name_ja: 'ピーターズバーグ',
    name_en: 'PETERSBURG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PSG',
  },
  {
    code: 'PZB',
    name_ja: 'ピーターマリッツバーグ',
    name_en: 'PIETERMARITZBURG',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'PZB',
  },
  {
    code: 'FAY',
    name_ja: 'ファイヤットビル',
    name_en: 'FAYETTEVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FAY',
  },
  {
    code: 'FYV',
    name_ja: 'ファイヤットビル',
    name_en: 'FAYETTEVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FYV',
  },
  {
    code: 'XNA',
    name_ja: 'ファイヤットビル（アーカンソー州）',
    name_en: 'FAYETTEVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'XNA',
  },
  {
    code: 'PHW',
    name_ja: 'ファラボルワ',
    name_en: 'PHALABORWA',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'PHW',
  },
  {
    code: 'FAO',
    name_ja: 'ファロ',
    name_en: 'FARO',
    area_code: 'eur',
    country_code: 'PT',
    flag: 1,
    display: null,
    air_city_code: 'FAO',
  },
  {
    code: 'FAR',
    name_ja: 'ファーゴ（ノースダコタ州）',
    name_en: 'FARGO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FAR',
  },
  {
    code: 'FMN',
    name_ja: 'ファーミントン（ニューメキシコ州）',
    name_en: 'FARMINGTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FMN',
  },
  {
    code: 'HUX',
    name_ja: 'フアツルコ',
    name_en: 'HUATULCO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'HUX',
  },
  {
    code: 'FSC',
    name_ja: 'フィガリ',
    name_en: 'FIGARI',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'FSC',
  },
  {
    code: 'PHL',
    name_ja: 'フィラデルフィア',
    name_en: 'PHILADELPHIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PHL',
  },
  {
    code: 'FLR',
    name_ja: 'フィレンツェ',
    name_en: 'FLORENCE',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: 3,
    air_city_code: 'FLR',
  },
  {
    code: 'FOC',
    name_ja: 'フウチョウ（福州）',
    name_en: 'FUZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'FOC',
  },
  {
    code: 'HUI',
    name_ja: 'フェ',
    name_en: 'HUE',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'HUI',
  },
  {
    code: 'FAI',
    name_ja: 'フェアバンクス',
    name_en: 'FAIRBANKS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FAI',
  },
  {
    code: 'FEZ',
    name_ja: 'フェズ',
    name_en: 'FEZ',
    area_code: 'afr',
    country_code: 'MA',
    flag: 1,
    display: null,
    air_city_code: 'FEZ',
  },
  {
    code: 'PHX',
    name_ja: 'フェニックス',
    name_en: 'PHOENIX',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PHX',
  },
  {
    code: 'FEG',
    name_ja: 'フェルガナ',
    name_en: 'FERGANA',
    area_code: 'asi',
    country_code: 'UZ',
    flag: 1,
    display: null,
    air_city_code: 'FEG',
  },
  {
    code: 'FUE',
    name_ja: 'フェルテベントゥーラ',
    name_en: 'FUERTEVENTURA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'FUE',
  },
  {
    code: 'FOR',
    name_ja: 'フォルタレーザ',
    name_en: 'FORTALEZA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'FOR',
  },
  {
    code: 'FMA',
    name_ja: 'フォルモサ',
    name_en: 'FORMOSA',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'FMA',
  },
  {
    code: 'FWA',
    name_ja: 'フォートウェイン',
    name_en: 'FORT WAYNE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FWA',
  },
  {
    code: 'VPS',
    name_ja: 'フォートウォルトンビーチ',
    name_en: 'VALPARAISO FORT WALTON BEACH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'VPS',
  },
  {
    code: 'FNL',
    name_ja: 'フォートコリンズ',
    name_en: 'FORT COLLINS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FNL',
  },
  {
    code: 'YSM',
    name_ja: 'フォートスミス',
    name_en: 'FORT SMITH',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YSM',
  },
  {
    code: 'FSM',
    name_ja: 'フォートスミス（アーカンソー州）',
    name_en: 'FORT SMITH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FSM',
  },
  {
    code: 'YXJ',
    name_ja: 'フォートセントジョージ',
    name_en: 'FORT SAINTE JOHN',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YXJ',
  },
  {
    code: 'FOD',
    name_ja: 'フォートダッジ',
    name_en: 'FORT DODGE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FOD',
  },
  {
    code: 'YYE',
    name_ja: 'フォートネルソン',
    name_en: 'FORT NELSON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYE',
  },
  {
    code: 'FPR',
    name_ja: 'フォートピアース',
    name_en: 'FORT PIERCE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FPR',
  },
  {
    code: 'FMY',
    name_ja: 'フォートマイヤーズ',
    name_en: 'FORT MYERS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FMY',
  },
  {
    code: 'YMM',
    name_ja: 'フォートマクマレー',
    name_en: 'FORT MCMURRAY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YMM',
  },
  {
    code: 'TBN',
    name_ja: 'フォートレオナードウッド',
    name_en: 'FORT LEONARD WOOD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TBN',
  },
  {
    code: 'FLL',
    name_ja: 'フォートローダーデール',
    name_en: 'FORT LAUDERDALE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FLL',
  },
  {
    code: 'FHU',
    name_ja: 'フォードフーチュカ',
    name_en: 'FORT HUACHUCA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FHU',
  },
  {
    code: 'FDF',
    name_ja: 'フォールトドフランス',
    name_en: 'FORT DE FRANCE',
    area_code: 'sam',
    country_code: 'MQ',
    flag: 1,
    display: null,
    air_city_code: 'FDF',
  },
  {
    code: 'FUN',
    name_ja: 'フナフティアトル',
    name_en: 'FUNAFUTI ATOL',
    area_code: 'oce',
    country_code: 'TV',
    flag: 1,
    display: null,
    air_city_code: 'FUN',
  },
  {
    code: 'FRD',
    name_ja: 'フライデイハーバー',
    name_en: 'FRIDAY HARBOR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FRD',
  },
  {
    code: 'FRA',
    name_ja: 'フランクフルト',
    name_en: 'FRANKFURT',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: 1,
    air_city_code: 'FRA',
  },
  {
    code: 'FKL',
    name_ja: 'フランクリン',
    name_en: 'FRANKLIN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FKL',
  },
  {
    code: 'JUL',
    name_ja: 'フリアカ',
    name_en: 'JULIACA',
    area_code: 'sam',
    country_code: 'PE',
    flag: 1,
    display: null,
    air_city_code: 'JUL',
  },
  {
    code: 'FNT',
    name_ja: 'フリント',
    name_en: 'FLINT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FNT',
  },
  {
    code: 'YFO',
    name_ja: 'フリンフロン',
    name_en: 'FLIN FLON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YFO',
  },
  {
    code: 'FNA',
    name_ja: 'フリータウン',
    name_en: 'FREETOWN',
    area_code: 'afr',
    country_code: 'SL',
    flag: 1,
    display: null,
    air_city_code: 'FNA',
  },
  {
    code: 'FDH',
    name_ja: 'フリードリッヒハーフェン',
    name_en: 'FRIEDRICHSHAFEN',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'FDH',
  },
  {
    code: 'FPO',
    name_ja: 'フリーポート',
    name_en: 'FREEPORT',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'FPO',
  },
  {
    code: 'HRG',
    name_ja: 'フルガダ',
    name_en: 'HURGHADA',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: null,
    air_city_code: 'HRG',
  },
  {
    code: 'FAT',
    name_ja: 'フレスノ',
    name_en: 'FRESNO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FAT',
  },
  {
    code: 'YFC',
    name_ja: 'フレデリクトン',
    name_en: 'FREDERICTON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YFC',
  },
  {
    code: 'WFK',
    name_ja: 'フレンチビル',
    name_en: 'FRENCHVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'WFK',
  },
  {
    code: 'FLN',
    name_ja: 'フロリアノポリス',
    name_en: 'FLORIANOPOLIS',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'FLN',
  },
  {
    code: 'FRS',
    name_ja: 'フローレス',
    name_en: 'FLORES',
    area_code: 'sam',
    country_code: 'GT',
    flag: 1,
    display: null,
    air_city_code: 'FRS',
  },
  {
    code: 'FLO',
    name_ja: 'フローレンス（サウスカロライナ州）',
    name_en: 'FLORENCE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'FLO',
  },
  {
    code: 'GRQ',
    name_ja: 'フロ－ニンゲン',
    name_en: 'GRONINGEN',
    area_code: 'eur',
    country_code: 'NL',
    flag: 1,
    display: null,
    air_city_code: 'GRQ',
  },
  {
    code: 'FNC',
    name_ja: 'フンシャール',
    name_en: 'FUNCHAL',
    area_code: 'eur',
    country_code: 'PT',
    flag: 1,
    display: null,
    air_city_code: 'FNC',
  },
  {
    code: 'PQC',
    name_ja: 'フーコック',
    name_en: 'PHU QUOC',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'PQC',
  },
  {
    code: 'HDS',
    name_ja: 'フートスプレイト',
    name_en: 'HOEDSPRUIT',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'HDS',
  },
  {
    code: 'HNH',
    name_ja: 'フーナ',
    name_en: 'HOONAH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HNH',
  },
  {
    code: 'BUE',
    name_ja: 'ブエノスアイレス',
    name_en: 'BUENOS AIRES',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: 1,
    air_city_code: 'BUE',
  },
  {
    code: 'BUH',
    name_ja: 'ブカレスト',
    name_en: 'BUCHAREST',
    area_code: 'eur',
    country_code: 'RO',
    flag: 1,
    display: null,
    air_city_code: 'BUH',
  },
  {
    code: 'BUZ',
    name_ja: 'ブシェール',
    name_en: 'BUSHEHR',
    area_code: 'afr',
    country_code: 'IR',
    flag: 1,
    display: null,
    air_city_code: 'BUZ',
  },
  {
    code: 'BJM',
    name_ja: 'ブジュンブラ',
    name_en: 'BUJUMBURA',
    area_code: 'afr',
    country_code: 'BI',
    flag: 1,
    display: null,
    air_city_code: 'BJM',
  },
  {
    code: 'BXU',
    name_ja: 'ブターン',
    name_en: 'BUTUAN',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'BXU',
  },
  {
    code: 'BUD',
    name_ja: 'ブダペスト',
    name_en: 'BUDAPEST',
    area_code: 'eur',
    country_code: 'HU',
    flag: 1,
    display: null,
    air_city_code: 'BUD',
  },
  {
    code: 'BHK',
    name_ja: 'ブハラ',
    name_en: 'BUKHARA',
    area_code: 'asi',
    country_code: 'UZ',
    flag: 1,
    display: null,
    air_city_code: 'BHK',
  },
  {
    code: 'BBI',
    name_ja: 'ブバネーシュワル',
    name_en: 'BHUBANESWAR',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'BBI',
  },
  {
    code: 'BCE',
    name_ja: 'ブライズキャニオン（国立公園）',
    name_en: 'BRYCE CANYON NATIONAL PARK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BCE',
  },
  {
    code: 'BWD',
    name_ja: 'ブラウンウッド',
    name_en: 'BROWNWOOD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BWD',
  },
  {
    code: 'BRO',
    name_ja: 'ブラウンズビル',
    name_en: 'BROWNSVILL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BRO',
  },
  {
    code: 'BZV',
    name_ja: 'ブラザビル',
    name_en: 'BRAZZAVILLE',
    area_code: 'afr',
    country_code: 'CG',
    flag: 1,
    display: null,
    air_city_code: 'BZV',
  },
  {
    code: 'BSB',
    name_ja: 'ブラジリア',
    name_en: 'BRASILIA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'BSB',
  },
  {
    code: 'BTS',
    name_ja: 'ブラチスラバ',
    name_en: 'BRATISLAVA',
    area_code: 'eur',
    country_code: 'SK',
    flag: 1,
    display: null,
    air_city_code: 'BTS',
  },
  {
    code: 'BFD',
    name_ja: 'ブラッドフォード',
    name_en: 'BARDFORD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BFD',
  },
  {
    code: 'BUQ',
    name_ja: 'ブラワヨ',
    name_en: 'BULAWAYO',
    area_code: 'afr',
    country_code: 'ZW',
    flag: 1,
    display: null,
    air_city_code: 'BUQ',
  },
  {
    code: 'SSI',
    name_ja: 'ブランズウィック（ジョージア州）',
    name_en: 'BRUNSWICK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SSI',
  },
  {
    code: 'BLZ',
    name_ja: 'ブランタイル',
    name_en: 'BLANTYRE',
    area_code: 'afr',
    country_code: 'MW',
    flag: 1,
    display: null,
    air_city_code: 'BLZ',
  },
  {
    code: 'BLH',
    name_ja: 'ブリス',
    name_en: 'BLYTHE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BLH',
  },
  {
    code: 'BRS',
    name_ja: 'ブリストル',
    name_en: 'BRISTOL',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'BRS',
  },
  {
    code: 'TRI',
    name_ja: 'ブリストル',
    name_en: 'BRISTOL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'TRI',
  },
  {
    code: 'BNE',
    name_ja: 'ブリスベーン',
    name_en: 'BRISBANE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: 2,
    air_city_code: 'BNE',
  },
  {
    code: 'BDR',
    name_ja: 'ブリッジポート',
    name_en: 'BRIDGEPORT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BDR',
  },
  {
    code: 'BRU',
    name_ja: 'ブリュッセル',
    name_en: 'BRUSSELS',
    area_code: 'eur',
    country_code: 'BE',
    flag: 1,
    display: 1,
    air_city_code: 'BRU',
  },
  {
    code: 'BDS',
    name_ja: 'ブリンディジ',
    name_en: 'BRINDISI',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'BDS',
  },
  {
    code: 'BOJ',
    name_ja: 'ブルガス',
    name_en: 'BOURGAS',
    area_code: 'eur',
    country_code: 'BG',
    flag: 1,
    display: null,
    air_city_code: 'BOJ',
  },
  {
    code: 'YEI',
    name_ja: 'ブルサ',
    name_en: 'BURSA',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'YEI',
  },
  {
    code: 'BKX',
    name_ja: 'ブルッキングス',
    name_en: 'BROOKINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BKX',
  },
  {
    code: 'BRQ',
    name_ja: 'ブルノ',
    name_en: 'BRNO',
    area_code: 'eur',
    country_code: 'CZ',
    flag: 1,
    display: null,
    air_city_code: 'BRQ',
  },
  {
    code: 'BHC',
    name_ja: 'ブルバンヘリポート',
    name_en: 'BHURBAN HELIPORT',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'BHC',
  },
  {
    code: 'BLE',
    name_ja: 'ブルレンイエ',
    name_en: 'BORLANGE',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'BLE',
  },
  {
    code: 'BLF',
    name_ja: 'ブルーフィールド',
    name_en: 'BLUEFIELD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BLF',
  },
  {
    code: 'BMI',
    name_ja: 'ブルーミントン（イリノイ州）',
    name_en: 'BLOOMINGTON-NORMAL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BMI',
  },
  {
    code: 'BMG',
    name_ja: 'ブルーミントン（インディアナ州）',
    name_en: 'BLOOMINGTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BMG',
  },
  {
    code: 'BME',
    name_ja: 'ブルーム',
    name_en: 'BROOME',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'BME',
  },
  {
    code: 'BFN',
    name_ja: 'ブルームフォンテーン',
    name_en: 'BLOEMFONTEIN',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'BFN',
  },
  {
    code: 'BES',
    name_ja: 'ブレスト',
    name_en: 'BREST',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'BES',
  },
  {
    code: 'BHE',
    name_ja: 'ブレーナム',
    name_en: 'BLENHEIM',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'BHE',
  },
  {
    code: 'BRD',
    name_ja: 'ブレーナード',
    name_en: 'BRAINERD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BRD',
  },
  {
    code: 'BRE',
    name_ja: 'ブレーメン',
    name_en: 'BREMEN',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'BRE',
  },
  {
    code: 'BID',
    name_ja: 'ブロックアイランド',
    name_en: 'BLOCK ISIAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BID',
  },
  {
    code: 'VN3',
    name_ja: 'ブンタウ',
    name_en: 'Vung Tau',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'SGN',
  },
  {
    code: 'BDB',
    name_ja: 'ブンダバーグ',
    name_en: 'BUNDABERG',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'BDB',
  },
  {
    code: 'PBC',
    name_ja: 'プエブラ',
    name_en: 'PUEBLA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'MEX',
  },
  {
    code: 'PUB',
    name_ja: 'プエブロ',
    name_en: 'PUEBLO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PUB',
  },
  {
    code: 'PXM',
    name_ja: 'プエルトエスコンディード',
    name_en: 'PUERTO ESCONDIDO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'PXM',
  },
  {
    code: 'PVR',
    name_ja: 'プエルトバジャルタ',
    name_en: 'PUERTO VALLARTA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'PVR',
  },
  {
    code: 'POP',
    name_ja: 'プエルトプラタ',
    name_en: 'PUERTO PLATA',
    area_code: 'sam',
    country_code: 'DO',
    flag: 1,
    display: null,
    air_city_code: 'POP',
  },
  {
    code: 'PPS',
    name_ja: 'プエルトプリンセサ',
    name_en: 'PUERTO PRINCESA',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'PPS',
  },
  {
    code: 'PMC',
    name_ja: 'プエルトモント',
    name_en: 'PUERTO MONTT',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'PMC',
  },
  {
    code: 'PUS',
    name_ja: 'プサン（釜山）',
    name_en: 'BUSAN',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: 2,
    air_city_code: 'PUS',
  },
  {
    code: 'PNH',
    name_ja: 'プノンペン',
    name_en: 'PHNON PENH',
    area_code: 'asi',
    country_code: 'KH',
    flag: 1,
    display: 2,
    air_city_code: 'PNH',
  },
  {
    code: 'RAI',
    name_ja: 'プライア',
    name_en: 'PRAIA',
    area_code: 'afr',
    country_code: 'CV',
    flag: 1,
    display: null,
    air_city_code: 'RAI',
  },
  {
    code: 'PUC',
    name_ja: 'プライス',
    name_en: 'PRICE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PUC',
  },
  {
    code: 'PRG',
    name_ja: 'プラハ',
    name_en: 'PRAGUE',
    area_code: 'eur',
    country_code: 'CZ',
    flag: 1,
    display: 1,
    air_city_code: 'PRG',
  },
  {
    code: 'LOP',
    name_ja: 'プラヤ',
    name_en: 'PLAYA',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'LOP',
  },
  {
    code: 'PRI',
    name_ja: 'プラリン島',
    name_en: 'PRASLIN ISLAND',
    area_code: 'afr',
    country_code: 'SC',
    flag: 1,
    display: null,
    air_city_code: 'PRI',
  },
  {
    code: 'PRN',
    name_ja: 'プリシュチナ',
    name_en: 'PRISTINA',
    area_code: 'eur',
    country_code: 'RS',
    flag: 1,
    display: null,
    air_city_code: 'PRN',
  },
  {
    code: 'PLH',
    name_ja: 'プリマス',
    name_en: 'PLYMOUTH',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'PLH',
  },
  {
    code: 'YXS',
    name_ja: 'プリンスジョージ',
    name_en: 'PRINCE GEORGE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YXS',
  },
  {
    code: 'PCT',
    name_ja: 'プリンストン',
    name_en: 'PRINCETON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PCT',
  },
  {
    code: 'YPR',
    name_ja: 'プリンスルパート',
    name_en: 'PRINCE RUPERT',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YPR',
  },
  {
    code: 'PUW',
    name_ja: 'プルマン（ワシントン州）',
    name_en: 'PULLMAN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PUW',
  },
  {
    code: 'PXU',
    name_ja: 'プレイク',
    name_en: 'PLEIKU',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'PXU',
  },
  {
    code: 'PPB',
    name_ja: 'プレジデンテ・プルデンテ',
    name_en: 'PRESIDENTE PRUDENTE',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'PPB',
  },
  {
    code: 'PQI',
    name_ja: 'プレスク アイル（メイン州）',
    name_en: 'PRESQUE ISLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PQI',
  },
  {
    code: 'PRC',
    name_ja: 'プレスコット（アリゾナ州）',
    name_en: 'PRESCOTT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PRC',
  },
  {
    code: 'PRH',
    name_ja: 'プレー',
    name_en: 'PHRAE',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'PRH',
  },
  {
    code: 'PLS',
    name_ja: 'プロビデンシアルズ',
    name_en: 'PROVIDENCIALES',
    area_code: 'sam',
    country_code: 'TC',
    flag: 1,
    display: null,
    air_city_code: 'PLS',
  },
  {
    code: 'PVD',
    name_ja: 'プロビデンス',
    name_en: 'PROVIDENCE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PVD',
  },
  {
    code: 'PVU',
    name_ja: 'プロボ',
    name_en: 'PROVO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PVU',
  },
  {
    code: 'PPP',
    name_ja: 'プローザパイン',
    name_en: 'PROSERPINE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'PPP',
  },
  {
    code: 'PUQ',
    name_ja: 'プンタアレナス',
    name_en: 'PUNTA ARENAS',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'PUQ',
  },
  {
    code: 'PUJ',
    name_ja: 'プンタカナ',
    name_en: 'PUNTA CANA',
    area_code: 'sam',
    country_code: 'DO',
    flag: 1,
    display: null,
    air_city_code: 'PUJ',
  },
  {
    code: 'HKT',
    name_ja: 'プーケット',
    name_en: 'PHUKET',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: 3,
    air_city_code: 'HKT',
  },
  {
    code: 'PNQ',
    name_ja: 'プーナ',
    name_en: 'POONA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'PNQ',
  },
  {
    code: 'HYS',
    name_ja: 'ヘイズ',
    name_en: 'HAYS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HYS',
  },
  {
    code: 'HIS',
    name_ja: 'ヘイマン島',
    name_en: 'HAYMAN',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'HIS',
  },
  {
    code: 'HER',
    name_ja: 'ヘラクリオン',
    name_en: 'HERAKLION',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'HER',
  },
  {
    code: 'HEL',
    name_ja: 'ヘルシンキ',
    name_en: 'HELSINKI',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: 1,
    air_city_code: 'HEL',
  },
  {
    code: 'XRY',
    name_ja: 'ヘレスフロンテラ',
    name_en: 'JEREZ FRONTERA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'XRY',
  },
  {
    code: 'HLN',
    name_ja: 'ヘレナ',
    name_en: 'HELENA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HLN',
  },
  {
    code: 'HGR',
    name_ja: 'ヘーガーズタウン',
    name_en: 'HAGERSTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HGR',
  },
  {
    code: 'BCC',
    name_ja: 'ベアクリーク',
    name_en: 'BEAR CREEK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BCC',
  },
  {
    code: 'YBC',
    name_ja: 'ベイ コモー',
    name_en: 'BAIE COMEAU',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YBC',
  },
  {
    code: 'PEK',
    name_ja: 'ベイジン（北京）',
    name_en: 'BEIJING',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: 1,
    air_city_code: 'PEK',
  },
  {
    code: 'BEW',
    name_ja: 'ベイラ',
    name_en: 'BEIRA',
    area_code: 'afr',
    country_code: 'MZ',
    flag: 1,
    display: null,
    air_city_code: 'BEW',
  },
  {
    code: 'EGE',
    name_ja: 'ベイルイーグル',
    name_en: 'VAIL EAGLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EGE',
  },
  {
    code: 'BEY',
    name_ja: 'ベイルート',
    name_en: 'BEIRUT',
    area_code: 'afr',
    country_code: 'LB',
    flag: 1,
    display: null,
    air_city_code: 'BEY',
  },
  {
    code: 'BEG',
    name_ja: 'ベオグラード',
    name_en: 'BEIGRADE',
    area_code: 'eur',
    country_code: 'RS',
    flag: 1,
    display: null,
    air_city_code: 'BEG',
  },
  {
    code: 'VXO',
    name_ja: 'ベクショー',
    name_en: 'VAXJO',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'VXO',
  },
  {
    code: 'VST',
    name_ja: 'ベステロス',
    name_en: 'VASTERAS',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'VST',
  },
  {
    code: 'BET',
    name_ja: 'ベセル（アラスカ州）',
    name_en: 'BETHEL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BET',
  },
  {
    code: 'BKW',
    name_ja: 'ベックリー',
    name_en: 'BECKLEY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BKW',
  },
  {
    code: 'BTT',
    name_ja: 'ベテルス',
    name_en: 'BETTLES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BTT',
  },
  {
    code: 'VCE',
    name_ja: 'ベニス（ベネチア）',
    name_en: 'VENICE',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: 4,
    air_city_code: 'VCE',
  },
  {
    code: 'BJI',
    name_ja: 'ベミジー',
    name_en: 'BEMIDJI',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BJI',
  },
  {
    code: 'VER',
    name_ja: 'ベラクルス',
    name_en: 'VERACRUZ',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'VER',
  },
  {
    code: 'BZE',
    name_ja: 'ベリセシティ',
    name_en: 'BELIZE CITY',
    area_code: 'sam',
    country_code: 'BZ',
    flag: 1,
    display: null,
    air_city_code: 'BZE',
  },
  {
    code: 'BLI',
    name_ja: 'ベリンナム',
    name_en: 'BELLINGHAM',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BLI',
  },
  {
    code: 'BGO',
    name_ja: 'ベルゲン',
    name_en: 'BERGEN',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'BGO',
  },
  {
    code: 'EGC',
    name_ja: 'ベルジュラック',
    name_en: 'BERGERAC',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'EGC',
  },
  {
    code: 'BFS',
    name_ja: 'ベルファースト',
    name_en: 'BELFAST',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'BFS',
  },
  {
    code: 'BER',
    name_ja: 'ベルリン',
    name_en: 'BERLIN',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: 3,
    air_city_code: 'BER',
  },
  {
    code: 'BRN',
    name_ja: 'ベルン',
    name_en: 'BERNE',
    area_code: 'eur',
    country_code: 'CH',
    flag: 1,
    display: null,
    air_city_code: 'BRN',
  },
  {
    code: 'BEL',
    name_ja: 'ベレン',
    name_en: 'BELEM',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'BEL',
  },
  {
    code: 'BHZ',
    name_ja: 'ベロオリゾンテ',
    name_en: 'BELO HORIZONTE',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'BHZ',
  },
  {
    code: 'VRB',
    name_ja: 'ベロビーチ',
    name_en: 'VERO BEACH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'VRB',
  },
  {
    code: 'VRN',
    name_ja: 'ベローナ',
    name_en: 'VERONA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'VRN',
  },
  {
    code: 'BEN',
    name_ja: 'ベンガジ',
    name_en: 'BENGHAZI',
    area_code: 'afr',
    country_code: 'LY',
    flag: 1,
    display: null,
    air_city_code: 'BEN',
  },
  {
    code: 'BEH',
    name_ja: 'ベントンハーバー',
    name_en: 'BENTON HARBOUR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BEH',
  },
  {
    code: 'BFL',
    name_ja: 'ベーカースフィールド',
    name_en: 'BAKERSFIELD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BFL',
  },
  {
    code: 'PIA',
    name_ja: 'ペオリア',
    name_en: 'PEORIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PIA',
  },
  {
    code: 'PEW',
    name_ja: 'ペシャワール',
    name_en: 'PESHAWAR',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'PEW',
  },
  {
    code: 'PSR',
    name_ja: 'ペスカラ',
    name_en: 'PESCARA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'PSR',
  },
  {
    code: 'PKC',
    name_ja: 'ペトロパブロフスク',
    name_en: 'PETROPAVLOVSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'PKC',
  },
  {
    code: 'PNZ',
    name_ja: 'ペトロリーナ',
    name_en: 'PETROLINA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'PNZ',
  },
  {
    code: 'PEN',
    name_ja: 'ペナン',
    name_en: 'PENANG',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: 2,
    air_city_code: 'PEN',
  },
  {
    code: 'PLN',
    name_ja: 'ペルストン',
    name_en: 'PELLSTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PLN',
  },
  {
    code: 'PGF',
    name_ja: 'ペルピニャン',
    name_en: 'PERPIGNAN',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'PGF',
  },
  {
    code: 'PEE',
    name_ja: 'ペルミ',
    name_en: 'PERM',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'PEE',
  },
  {
    code: 'VYS',
    name_ja: 'ペルー',
    name_en: 'PERU',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'VYS',
  },
  {
    code: 'PEG',
    name_ja: 'ペルージャ',
    name_en: 'PERUGIA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'PEG',
  },
  {
    code: 'PEI',
    name_ja: 'ペレイラ',
    name_en: 'PEREIRA',
    area_code: 'sam',
    country_code: 'CO',
    flag: 1,
    display: null,
    air_city_code: 'PEI',
  },
  {
    code: 'PNS',
    name_ja: 'ペンサコラ',
    name_en: 'PENSACOLA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PNS',
  },
  {
    code: 'YYF',
    name_ja: 'ペンチクトン',
    name_en: 'PENTICTON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYF',
  },
  {
    code: 'PDT',
    name_ja: 'ペンドルトン',
    name_en: 'PENDLETON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PDT',
  },
  {
    code: 'POL',
    name_ja: 'ペンバ',
    name_en: 'PEMBA',
    area_code: 'afr',
    country_code: 'MZ',
    flag: 1,
    display: null,
    air_city_code: 'POL',
  },
  {
    code: 'PGA',
    name_ja: 'ページ（アリゾナ州）',
    name_en: 'PAGE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PGA',
  },
  {
    code: 'HHQ',
    name_ja: 'ホアヒン',
    name_en: 'HUA HIN',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'BKK',
  },
  {
    code: 'QAN',
    name_ja: 'ホイアン',
    name_en: 'HOI AN',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'DAD',
  },
  {
    code: 'HKK',
    name_ja: 'ホキティカ',
    name_en: 'HOKITIKA',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'HKK',
  },
  {
    code: 'HKN',
    name_ja: 'ホスキンス',
    name_en: 'HOSKINS',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'HKN',
  },
  {
    code: 'HOB',
    name_ja: 'ホッブス',
    name_en: 'HOBBS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HOB',
  },
  {
    code: 'HIR',
    name_ja: 'ホニアラ',
    name_en: 'HONIARA',
    area_code: 'oce',
    country_code: 'SB',
    flag: 1,
    display: null,
    air_city_code: 'HIR',
  },
  {
    code: 'HNL',
    name_ja: 'ホノルル(オアフ島）',
    name_en: 'HONOLULU (OAHU)',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 1,
    air_city_code: 'HNL',
  },
  {
    code: 'HBA',
    name_ja: 'ホバート',
    name_en: 'HOBART',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'HBA',
  },
  {
    code: 'HOQ',
    name_ja: 'ホフ',
    name_en: 'HOF',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'HOQ',
  },
  {
    code: 'YXY',
    name_ja: 'ホワイトホース',
    name_en: 'WHITE HORSE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YXY',
  },
  {
    code: 'HWN',
    name_ja: 'ホワンゲ',
    name_en: 'HWANGE',
    area_code: 'afr',
    country_code: 'ZW',
    flag: 1,
    display: null,
    air_city_code: 'HWN',
  },
  {
    code: 'HKG',
    name_ja: 'ホンコン（香港）',
    name_en: 'HONG KONG',
    area_code: 'asi',
    country_code: 'HK',
    flag: 1,
    display: 1,
    air_city_code: 'HKG',
  },
  {
    code: 'SGN',
    name_ja: 'ホーチミン',
    name_en: 'HO CHI MINH CITY',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: 1,
    air_city_code: 'SGN',
  },
  {
    code: 'HOM',
    name_ja: 'ホーマー',
    name_en: 'HOMER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HOM',
  },
  {
    code: 'HST',
    name_ja: 'ホームステッド',
    name_en: 'HOMESTEAD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'HST',
  },
  {
    code: 'BVB',
    name_ja: 'ボア ヴィスタ',
    name_en: 'BOA VISTA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'BVB',
  },
  {
    code: 'BOI',
    name_ja: 'ボイシ',
    name_en: 'BOISE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BOI',
  },
  {
    code: 'BOG',
    name_ja: 'ボゴタ',
    name_en: 'BOGOTA',
    area_code: 'sam',
    country_code: 'CO',
    flag: 1,
    display: null,
    air_city_code: 'BOG',
  },
  {
    code: 'SKS',
    name_ja: 'ボジェン',
    name_en: 'VOJENS',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'SKS',
  },
  {
    code: 'BOS',
    name_ja: 'ボストン',
    name_en: 'BOSTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: 3,
    air_city_code: 'BOS',
  },
  {
    code: 'BOO',
    name_ja: 'ボデ',
    name_en: 'BODO',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'BOO',
  },
  {
    code: 'BJV',
    name_ja: 'ボドルム',
    name_en: 'BODRUM',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'BJV',
  },
  {
    code: 'BON',
    name_ja: 'ボネール',
    name_en: 'BONAIRE',
    area_code: 'sam',
    country_code: 'AN',
    flag: 1,
    display: null,
    air_city_code: 'BON',
  },
  {
    code: 'BHO',
    name_ja: 'ボパール',
    name_en: 'BHOPAL',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'BHO',
  },
  {
    code: 'BO1',
    name_ja: 'ボラカイ島',
    name_en: 'BORACAY ISLAND',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'KLO',
  },
  {
    code: 'BOB',
    name_ja: 'ボラボラ',
    name_en: 'BORA BORA',
    area_code: 'oce',
    country_code: 'PF',
    flag: 1,
    display: null,
    air_city_code: 'BOB',
  },
  {
    code: 'BZO',
    name_ja: 'ボルツァーノ',
    name_en: 'BOLZANO',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'BZO',
  },
  {
    code: 'BWI',
    name_ja: 'ボルティモア',
    name_en: 'BALTIMORE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BWI',
  },
  {
    code: 'BOD',
    name_ja: 'ボルドー',
    name_en: 'BORDEAUX',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'BOD',
  },
  {
    code: 'BLQ',
    name_ja: 'ボローニャ',
    name_en: 'BOLOGNA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'BLQ',
  },
  {
    code: 'BZN',
    name_ja: 'ボースマン',
    name_en: 'BOZEMAN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BZN',
  },
  {
    code: 'BPT',
    name_ja: 'ボーモント',
    name_en: 'BEAUMONT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BPT',
  },
  {
    code: 'BXS',
    name_ja: 'ボーレグスプリングス',
    name_en: 'BORREGO SPRINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'BXS',
  },
  {
    code: 'RNN',
    name_ja: 'ボーンホルム',
    name_en: 'BORNHOLM',
    area_code: 'eur',
    country_code: 'DK',
    flag: 1,
    display: null,
    air_city_code: 'RNN',
  },
  {
    code: 'PIS',
    name_ja: 'ポアティエ',
    name_en: 'POITIERS',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'PIS',
  },
  {
    code: 'PTP',
    name_ja: 'ポインテアピートル',
    name_en: 'POINTE-A-PITRE',
    area_code: 'sam',
    country_code: 'GP',
    flag: 1,
    display: null,
    air_city_code: 'PTP',
  },
  {
    code: 'PNR',
    name_ja: 'ポイントノワール',
    name_en: 'POINTE NOIRE',
    area_code: 'afr',
    country_code: 'CG',
    flag: 1,
    display: null,
    air_city_code: 'PNR',
  },
  {
    code: 'PIH',
    name_ja: 'ポカテッロ',
    name_en: 'POCATELLO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PIH',
  },
  {
    code: 'PKR',
    name_ja: 'ポカラ',
    name_en: 'POKHARA',
    area_code: 'asi',
    country_code: 'NP',
    flag: 1,
    display: null,
    air_city_code: 'PKR',
  },
  {
    code: 'POZ',
    name_ja: 'ポツナム',
    name_en: 'POZNAM',
    area_code: 'eur',
    country_code: 'PL',
    flag: 1,
    display: null,
    air_city_code: 'POZ',
  },
  {
    code: 'TGD',
    name_ja: 'ポトゴリカ',
    name_en: 'PODGORICA',
    area_code: 'eur',
    country_code: 'ME',
    flag: 1,
    display: null,
    air_city_code: 'TGD',
  },
  {
    code: 'PNI',
    name_ja: 'ポナペ',
    name_en: 'POHNPEI(CAROLINE IS.)',
    area_code: 'mic',
    country_code: 'FM',
    flag: 1,
    display: null,
    air_city_code: 'PNI',
  },
  {
    code: 'POR',
    name_ja: 'ポリ',
    name_en: 'PORI',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'POR',
  },
  {
    code: 'OPO',
    name_ja: 'ポルト',
    name_en: 'PORTO',
    area_code: 'eur',
    country_code: 'PT',
    flag: 1,
    display: 2,
    air_city_code: 'OPO',
  },
  {
    code: 'POA',
    name_ja: 'ポルトアレグレ',
    name_en: 'PORTO ALEGRE',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'POA',
  },
  {
    code: 'PVH',
    name_ja: 'ポルトベリョー',
    name_en: 'PORTO VELHO',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'PVH',
  },
  {
    code: 'PAP',
    name_ja: 'ポルトープランス',
    name_en: 'PORT AU PRINCE',
    area_code: 'sam',
    country_code: 'HT',
    flag: 1,
    display: null,
    air_city_code: 'PAP',
  },
  {
    code: 'PTG',
    name_ja: 'ポロクワネ',
    name_en: 'POLOKWANE',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'PTG',
  },
  {
    code: 'PNC',
    name_ja: 'ポンカシティ',
    name_en: 'PONCA CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PNC',
  },
  {
    code: 'PSE',
    name_ja: 'ポンセ',
    name_en: 'PONCE',
    area_code: 'sam',
    country_code: 'PR',
    flag: 1,
    display: null,
    air_city_code: 'PSE',
  },
  {
    code: 'PNK',
    name_ja: 'ポンティアナク',
    name_en: 'PONTIANAK',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'PNK',
  },
  {
    code: 'PUF',
    name_ja: 'ポー',
    name_en: 'PAU',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'PUF',
  },
  {
    code: 'POU',
    name_ja: 'ポーキープシ',
    name_en: 'POUGHKEEPSIE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'POU',
  },
  {
    code: 'PSM',
    name_ja: 'ポーツマス',
    name_en: 'PORTSMUTH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PSM',
  },
  {
    code: 'PLZ',
    name_ja: 'ポートエリザベス',
    name_en: 'PORT ELIZABETH',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'PLZ',
  },
  {
    code: 'CLM',
    name_ja: 'ポートエンジェルズ',
    name_en: 'PORT ANGELES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CLM',
  },
  {
    code: 'POS',
    name_ja: 'ポートオブスペイン',
    name_en: 'PORT OF SPAIN',
    area_code: 'sam',
    country_code: 'TT',
    flag: 1,
    display: null,
    air_city_code: 'POS',
  },
  {
    code: 'BPS',
    name_ja: 'ポートセグロ',
    name_en: 'PORTO SEGURO',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'BPS',
  },
  {
    code: 'PHC',
    name_ja: 'ポートハーコート',
    name_en: 'PORT HARCOURT',
    area_code: 'afr',
    country_code: 'NG',
    flag: 1,
    display: null,
    air_city_code: 'PHC',
  },
  {
    code: 'YZT',
    name_ja: 'ポートハーディー',
    name_en: 'PORT HARDY',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YZT',
  },
  {
    code: 'VLI',
    name_ja: 'ポートビラ',
    name_en: 'PORT VILA',
    area_code: 'oce',
    country_code: 'VU',
    flag: 1,
    display: null,
    air_city_code: 'VLI',
  },
  {
    code: 'PQQ',
    name_ja: 'ポートマクオリー',
    name_en: 'PORT MACQUARIE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'PQQ',
  },
  {
    code: 'POM',
    name_ja: 'ポートモレスビー',
    name_en: 'PORT MORESBY',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'POM',
  },
  {
    code: 'PDX',
    name_ja: 'ポートランド（オレゴン州）',
    name_en: 'PORTLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PDX',
  },
  {
    code: 'PWM',
    name_ja: 'ポートランド（メイン州）',
    name_en: 'PORTLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'PWM',
  },
  {
    code: 'PLO',
    name_ja: 'ポートリンカン',
    name_en: 'PORT LINCOLN',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'PLO',
  },
  {
    code: 'MIA',
    name_ja: 'マイアミ',
    name_en: 'MIAMI',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: 7,
    air_city_code: 'MIA',
  },
  {
    code: 'MOT',
    name_ja: 'マイノット',
    name_en: 'MINOT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MOT',
  },
  {
    code: 'MLS',
    name_ja: 'マイルズシティ',
    name_en: 'MILES CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MLS',
  },
  {
    code: 'MAU',
    name_ja: 'マウピチ',
    name_en: 'MAUPITI',
    area_code: 'oce',
    country_code: 'PF',
    flag: 1,
    display: null,
    air_city_code: 'MAU',
  },
  {
    code: 'MUB',
    name_ja: 'マウン',
    name_en: 'MAUN',
    area_code: 'afr',
    country_code: 'BW',
    flag: 1,
    display: null,
    air_city_code: 'MUB',
  },
  {
    code: 'HGU',
    name_ja: 'マウンテンハーゲン',
    name_en: 'MOUNT HAGEN',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'HGU',
  },
  {
    code: 'ISA',
    name_ja: 'マウントイサ',
    name_en: 'MOUNT ISA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'ISA',
  },
  {
    code: 'MGB',
    name_ja: 'マウントガンビア',
    name_en: 'MT GAMBIER',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MGB',
  },
  {
    code: 'MON',
    name_ja: 'マウントクック',
    name_en: 'MOUNT COOK',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'MON',
  },
  {
    code: 'MVN',
    name_ja: 'マウントバーノン（イリノイ州）',
    name_en: 'MOUNT VERNON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MVN',
  },
  {
    code: 'MSD',
    name_ja: 'マウントプレサント',
    name_en: 'MOUNT PLEASANT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MSD',
  },
  {
    code: 'MKY',
    name_ja: 'マカイ',
    name_en: 'MACKAY',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MKY',
  },
  {
    code: 'MFM',
    name_ja: 'マカオ',
    name_en: 'MACAO',
    area_code: 'asi',
    country_code: 'HK',
    flag: 1,
    display: 2,
    air_city_code: 'MFM',
  },
  {
    code: 'UPG',
    name_ja: 'マカッサル（ウジュンパンダン）',
    name_en: 'MAKASSAR',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'UPG',
  },
  {
    code: 'MCP',
    name_ja: 'マカパ',
    name_en: 'MACAPA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'MCP',
  },
  {
    code: 'MLC',
    name_ja: 'マカレスター',
    name_en: 'MCALESTER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MLC',
  },
  {
    code: 'MCD',
    name_ja: 'マキナック',
    name_en: 'MACKINAC ISLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MCD',
  },
  {
    code: 'MFE',
    name_ja: 'マクアーレン',
    name_en: 'MCALLEN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MFE',
  },
  {
    code: 'MZT',
    name_ja: 'マサトラン',
    name_en: 'MAZATLAN',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'MZT',
  },
  {
    code: 'MHD',
    name_ja: 'マシュハド',
    name_en: 'MASHAD',
    area_code: 'afr',
    country_code: 'IR',
    flag: 1,
    display: null,
    air_city_code: 'MHD',
  },
  {
    code: 'MAJ',
    name_ja: 'マジュロ',
    name_en: 'MAJURO',
    area_code: 'mic',
    country_code: 'MH',
    flag: 1,
    display: null,
    air_city_code: 'MAJ',
  },
  {
    code: 'MCT',
    name_ja: 'マスカット',
    name_en: 'MUSCAT',
    area_code: 'afr',
    country_code: 'OM',
    flag: 1,
    display: null,
    air_city_code: 'MCT',
  },
  {
    code: 'MKG',
    name_ja: 'マスキーゴン',
    name_en: 'MUSKEGON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MKG',
  },
  {
    code: 'MRO',
    name_ja: 'マスタートン',
    name_en: 'MASTERTON',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'MRO',
  },
  {
    code: 'MSL',
    name_ja: 'マスルショールス',
    name_en: 'MASCLE SHOALS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MSL',
  },
  {
    code: 'MCZ',
    name_ja: 'マセイオ',
    name_en: 'MACEIO',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'MCZ',
  },
  {
    code: 'MSU',
    name_ja: 'マセル',
    name_en: 'MASERU',
    area_code: 'afr',
    country_code: 'LS',
    flag: 1,
    display: null,
    air_city_code: 'MSU',
  },
  {
    code: 'MSS',
    name_ja: 'マセーナ',
    name_en: 'MASSENA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MSS',
  },
  {
    code: 'AMI',
    name_ja: 'マタラム（ロンボクアイランド）',
    name_en: 'MATARAM(LOMBOK)',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'AMI',
  },
  {
    code: 'MP1',
    name_ja: 'マチュピチュ',
    name_en: 'MACHU PICCHU',
    area_code: 'sam',
    country_code: 'PE',
    flag: 1,
    display: 2,
    air_city_code: 'CUZ',
  },
  {
    code: 'MCK',
    name_ja: 'マックック',
    name_en: 'MCCOOK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MCK',
  },
  {
    code: 'MSN',
    name_ja: 'マディソン',
    name_en: 'MADISON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MSN',
  },
  {
    code: 'MTO',
    name_ja: 'マトゥーン',
    name_en: 'MATTOON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MTO',
  },
  {
    code: 'IXM',
    name_ja: 'マドゥライ',
    name_en: 'MADURAI',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IXM',
  },
  {
    code: 'MDJ',
    name_ja: 'マドラス',
    name_en: 'MADRAS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MDJ',
  },
  {
    code: 'MAD',
    name_ja: 'マドリッド',
    name_en: 'MADRID',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: 1,
    air_city_code: 'MAD',
  },
  {
    code: 'YGR',
    name_ja: 'マドレーヌ諸島',
    name_en: 'ILES DE MADELEINE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YGR',
  },
  {
    code: 'MAO',
    name_ja: 'マナウス',
    name_en: 'MANAUS',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'MAO',
  },
  {
    code: 'MGA',
    name_ja: 'マナグア',
    name_en: 'MANAGUA',
    area_code: 'sam',
    country_code: 'NI',
    flag: 1,
    display: null,
    air_city_code: 'MGA',
  },
  {
    code: 'MDC',
    name_ja: 'マナド',
    name_en: 'MANADO',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'MDC',
  },
  {
    code: 'MBL',
    name_ja: 'マニスティー',
    name_en: 'MANISTEE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MBL',
  },
  {
    code: 'MTW',
    name_ja: 'マニトウォク',
    name_en: 'MANITOWOC',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MTW',
  },
  {
    code: 'XMH',
    name_ja: 'マニヒ',
    name_en: 'MANIHI',
    area_code: 'oce',
    country_code: 'PF',
    flag: 1,
    display: null,
    air_city_code: 'XMH',
  },
  {
    code: 'MNL',
    name_ja: 'マニラ',
    name_en: 'MANILA',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: 1,
    air_city_code: 'MNL',
  },
  {
    code: 'MPM',
    name_ja: 'マプト',
    name_en: 'MAPUTO',
    area_code: 'afr',
    country_code: 'MZ',
    flag: 1,
    display: null,
    air_city_code: 'MPM',
  },
  {
    code: 'SEZ',
    name_ja: 'マヘ',
    name_en: 'MAHE ISLAND',
    area_code: 'afr',
    country_code: 'SC',
    flag: 1,
    display: null,
    air_city_code: 'SEZ',
  },
  {
    code: 'MAR',
    name_ja: 'マラカイボ',
    name_en: 'MARACAIBO',
    area_code: 'sam',
    country_code: 'VE',
    flag: 1,
    display: null,
    air_city_code: 'MAR',
  },
  {
    code: 'AGP',
    name_ja: 'マラガ',
    name_en: 'MALAGA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: 4,
    air_city_code: 'AGP',
  },
  {
    code: 'RAK',
    name_ja: 'マラケシュ',
    name_en: 'MARRAKECH',
    area_code: 'afr',
    country_code: 'MA',
    flag: 1,
    display: 2,
    air_city_code: 'RAK',
  },
  {
    code: 'MTH',
    name_ja: 'マラソン',
    name_en: 'MARATHON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MTH',
  },
  {
    code: 'MKZ',
    name_ja: 'マラッカ',
    name_en: 'MALACCA',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'MKZ',
  },
  {
    code: 'SSG',
    name_ja: 'マラボ',
    name_en: 'MALABO',
    area_code: 'afr',
    country_code: 'GQ',
    flag: 1,
    display: null,
    air_city_code: 'SSG',
  },
  {
    code: 'AAM',
    name_ja: 'マラマラ',
    name_en: 'MALA MALA',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'AAM',
  },
  {
    code: 'MHQ',
    name_ja: 'マリエハム',
    name_en: 'MARIEHAMN',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'MHQ',
  },
  {
    code: 'MWA',
    name_ja: 'マリオン',
    name_en: 'MARION',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MWA',
  },
  {
    code: 'MGF',
    name_ja: 'マリンガ',
    name_en: 'MARINGA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'MGF',
  },
  {
    code: 'MRQ',
    name_ja: 'マリンドゥケ',
    name_en: 'MARINDUQUE',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'MRQ',
  },
  {
    code: 'MRS',
    name_ja: 'マルセイユ',
    name_en: 'MARSEILLE',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: 4,
    air_city_code: 'MRS',
  },
  {
    code: 'MLA',
    name_ja: 'マルタ',
    name_en: 'MALTA',
    area_code: 'eur',
    country_code: 'MT',
    flag: 1,
    display: null,
    air_city_code: 'MLA',
  },
  {
    code: 'MUX',
    name_ja: 'マルタン',
    name_en: 'MULTAN',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'MUX',
  },
  {
    code: 'MUR',
    name_ja: 'マルディ',
    name_en: 'MARDI',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'MUR',
  },
  {
    code: 'MDQ',
    name_ja: 'マルデルプラタ',
    name_en: 'MAR DEL PLATA',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'MDQ',
  },
  {
    code: 'MBX',
    name_ja: 'マルボル',
    name_en: 'MARIBOR',
    area_code: 'eur',
    country_code: 'SI',
    flag: 1,
    display: null,
    air_city_code: 'MBX',
  },
  {
    code: 'ALA',
    name_ja: 'マルマトイ',
    name_en: 'ALMATY',
    area_code: 'asi',
    country_code: 'KZ',
    flag: 1,
    display: null,
    air_city_code: 'ALA',
  },
  {
    code: 'QRQ',
    name_ja: 'マルマリス',
    name_en: 'MARMARIS',
    area_code: 'afr',
    country_code: 'TR',
    flag: 1,
    display: null,
    air_city_code: 'DLM',
  },
  {
    code: 'MMA',
    name_ja: 'マルメ',
    name_en: 'MALMO',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'MMA',
  },
  {
    code: 'MLE',
    name_ja: 'マレ',
    name_en: 'MALE',
    area_code: 'asi',
    country_code: 'MV',
    flag: 1,
    display: null,
    air_city_code: 'MLE',
  },
  {
    code: 'IXE',
    name_ja: 'マンガロール',
    name_en: 'MANGALORE',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IXE',
  },
  {
    code: 'MAY',
    name_ja: 'マングローブカイ',
    name_en: 'MANGROVE CAY',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'MAY',
  },
  {
    code: 'MKT',
    name_ja: 'マンケート',
    name_en: 'MANKATO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MKT',
  },
  {
    code: 'ZLO',
    name_ja: 'マンサニヨ',
    name_en: 'MANZANILLO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'ZLO',
  },
  {
    code: 'MIE',
    name_ja: 'マンシー',
    name_en: 'MUNCIE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MIE',
  },
  {
    code: 'SHO',
    name_ja: 'マンジニ',
    name_en: 'SOKCHO',
    area_code: 'afr',
    country_code: 'SZ',
    flag: 1,
    display: null,
    air_city_code: 'SHO',
  },
  {
    code: 'MTS',
    name_ja: 'マンジニ',
    name_en: 'MANZINI',
    area_code: 'afr',
    country_code: 'SZ',
    flag: 1,
    display: null,
    air_city_code: 'MTS',
  },
  {
    code: 'MFD',
    name_ja: 'マンスフィールド',
    name_en: 'MANSFIELD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MFD',
  },
  {
    code: 'MDL',
    name_ja: 'マンダレー',
    name_en: 'MANDALAY',
    area_code: 'asi',
    country_code: 'MM',
    flag: 1,
    display: null,
    air_city_code: 'MDL',
  },
  {
    code: 'MHT',
    name_ja: 'マンチェスター',
    name_en: 'MANCHESTER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MHT',
  },
  {
    code: 'MAN',
    name_ja: 'マンチェスター',
    name_en: 'MANCHESTER',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: 2,
    air_city_code: 'MAN',
  },
  {
    code: 'MHG',
    name_ja: 'マンハイム',
    name_en: 'MANHEIM',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'MHG',
  },
  {
    code: 'MHK',
    name_ja: 'マンハッタン（カンザス州）',
    name_en: 'MANHATTAN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MHK',
  },
  {
    code: 'MMH',
    name_ja: 'マンモスレイク',
    name_en: 'MAMMOTH LAKES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MMH',
  },
  {
    code: 'IOM',
    name_ja: 'マン島',
    name_en: 'ISLE OF MAN',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'IOM',
  },
  {
    code: 'MQT',
    name_ja: 'マーケット（ミシガン州）',
    name_en: 'MARQUETTE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MQT',
  },
  {
    code: 'MVY',
    name_ja: 'マーサスビニヤード島',
    name_en: 'MARTHA&rsquo;S VINEYARD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MVY',
  },
  {
    code: 'MML',
    name_ja: 'マーシャル',
    name_en: 'MARSHALL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MML',
  },
  {
    code: 'MHH',
    name_ja: 'マーシュハーバー',
    name_en: 'MARSH HARBOUR',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'MHH',
  },
  {
    code: 'MST',
    name_ja: 'マーストリヒト',
    name_en: 'MAASTRICHT',
    area_code: 'eur',
    country_code: 'NL',
    flag: 1,
    display: null,
    air_city_code: 'MST',
  },
  {
    code: 'MCE',
    name_ja: 'マーセド',
    name_en: 'MERCED',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MCE',
  },
  {
    code: 'MYR',
    name_ja: 'マートルビーチ',
    name_en: 'MYRTLE BEACH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MYR',
  },
  {
    code: 'MYG',
    name_ja: 'マーヤグアーナ',
    name_en: 'MAYAGUANA',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'MYG',
  },
  {
    code: 'JMK',
    name_ja: 'ミコノス',
    name_en: 'MYKONOS',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'JMK',
  },
  {
    code: 'MSO',
    name_ja: 'ミズーラ',
    name_en: 'MISSOULA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MSO',
  },
  {
    code: 'MHE',
    name_ja: 'ミッチェル',
    name_en: 'MITCHELL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MHE',
  },
  {
    code: 'MAF',
    name_ja: 'ミッドランド（テキサス州）',
    name_en: 'MIDLAND/ODESSA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MAF',
  },
  {
    code: 'MTT',
    name_ja: 'ミナチトラン',
    name_en: 'MINATITLAN',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'MTT',
  },
  {
    code: 'MSP',
    name_ja: 'ミネアポリス',
    name_en: 'MINNEAPOLIS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MSP',
  },
  {
    code: 'ARV',
    name_ja: 'ミノッカ',
    name_en: 'MINOCQUA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ARV',
  },
  {
    code: 'FMO',
    name_ja: 'ミュンスター',
    name_en: 'MUNSTER',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'FMO',
  },
  {
    code: 'MUC',
    name_ja: 'ミュンヘン',
    name_en: 'MUNICH',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: 2,
    air_city_code: 'MUC',
  },
  {
    code: 'MLH',
    name_ja: 'ミュールーズ',
    name_en: 'MULHOUSE',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'MLH',
  },
  {
    code: 'MIL',
    name_ja: 'ミラノ',
    name_en: 'MILAN',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: 2,
    air_city_code: 'MIL',
  },
  {
    code: 'YCH',
    name_ja: 'ミラミチ',
    name_en: 'MIRAMICHI',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YCH',
  },
  {
    code: 'MYY',
    name_ja: 'ミリ',
    name_en: 'MIRI',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'MYY',
  },
  {
    code: 'MKE',
    name_ja: 'ミルウォーキー',
    name_en: 'MILWAUKEE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MKE',
  },
  {
    code: 'MQL',
    name_ja: 'ミルドューラ',
    name_en: 'MILDURA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MQL',
  },
  {
    code: 'MFN',
    name_ja: 'ミルフォードサウンド',
    name_en: 'MILFORD SOUND',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'MFN',
  },
  {
    code: 'MSQ',
    name_ja: 'ミンスク',
    name_en: 'MINSK',
    area_code: 'eur',
    country_code: 'BY',
    flag: 1,
    display: null,
    air_city_code: 'MSQ',
  },
  {
    code: 'MZV',
    name_ja: 'ムル',
    name_en: 'MULU',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'MZV',
  },
  {
    code: 'MJV',
    name_ja: 'ムルシア',
    name_en: 'MURCIA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: '',
  },
  {
    code: 'BOM',
    name_ja: 'ムンバイ',
    name_en: 'MUMBAI',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: 2,
    air_city_code: 'BOM',
  },
  {
    code: 'MMK',
    name_ja: 'ムーマンスク',
    name_en: 'MURMANSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'MMK',
  },
  {
    code: 'MCW',
    name_ja: 'メイソンシティ',
    name_en: 'MASON CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MCW',
  },
  {
    code: 'MEX',
    name_ja: 'メキシコシティ',
    name_en: 'MEXICO CITY',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: 1,
    air_city_code: 'MEX',
  },
  {
    code: 'MZM',
    name_ja: 'メス',
    name_en: 'METZ',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'MZM',
  },
  {
    code: 'MES',
    name_ja: 'メダン',
    name_en: 'MEDAN',
    area_code: 'asi',
    country_code: 'ID',
    flag: 1,
    display: null,
    air_city_code: 'MES',
  },
  {
    code: 'MAG',
    name_ja: 'メダン',
    name_en: 'MADANG',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'MAG',
  },
  {
    code: 'ETZ',
    name_ja: 'メッツナンシー',
    name_en: 'METZ NANCY LORRNE',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'ETZ',
  },
  {
    code: 'MFR',
    name_ja: 'メッドフォード（オレゴン州）',
    name_en: 'MEDFORD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MFR',
  },
  {
    code: 'YXH',
    name_ja: 'メディシンハット',
    name_en: 'MEDICINE HAT',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YXH',
  },
  {
    code: 'MED',
    name_ja: 'メディナ',
    name_en: 'MADINAH',
    area_code: 'afr',
    country_code: 'SA',
    flag: 1,
    display: null,
    air_city_code: 'MED',
  },
  {
    code: 'MDE',
    name_ja: 'メディン',
    name_en: 'MEDELLIN',
    area_code: 'sam',
    country_code: 'CO',
    flag: 1,
    display: null,
    air_city_code: 'MDE',
  },
  {
    code: 'MNM',
    name_ja: 'メノミニ',
    name_en: 'MENOMINEE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MNM',
  },
  {
    code: 'MAH',
    name_ja: 'メノルカ',
    name_en: 'MENORCA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'MAH',
  },
  {
    code: 'MXL',
    name_ja: 'メヒカリ',
    name_en: 'MEXICALI',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'MXL',
  },
  {
    code: 'HGN',
    name_ja: 'メホンソン',
    name_en: 'MAE HONGSON',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'HGN',
  },
  {
    code: 'MID',
    name_ja: 'メリダ',
    name_en: 'MERIDA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'MID',
  },
  {
    code: 'MEI',
    name_ja: 'メリディアン',
    name_en: 'MERIDIAN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MEI',
  },
  {
    code: 'MIM',
    name_ja: 'メリンブラ',
    name_en: 'MERIMBULA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MIM',
  },
  {
    code: 'MBH',
    name_ja: 'メリーボロー',
    name_en: 'MARYBOROUGH',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MBH',
  },
  {
    code: 'MUH',
    name_ja: 'メルサマトルーフ',
    name_en: 'MERSA MATRUH',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: null,
    air_city_code: 'MUH',
  },
  {
    code: 'MEL',
    name_ja: 'メルボルン',
    name_en: 'MELBOURNE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: 5,
    air_city_code: 'MEL',
  },
  {
    code: 'MLB',
    name_ja: 'メルボルン',
    name_en: 'MELBOURNE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MLB',
  },
  {
    code: 'MDZ',
    name_ja: 'メンドーサ',
    name_en: 'MENDOZA',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'MDZ',
  },
  {
    code: 'MEM',
    name_ja: 'メンフィス',
    name_en: 'MEMPHIS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MEM',
  },
  {
    code: 'MCN',
    name_ja: 'メーコン',
    name_en: 'MACON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MCN',
  },
  {
    code: 'CNY',
    name_ja: 'モアブ',
    name_en: 'MOAB',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'CNY',
  },
  {
    code: 'MGQ',
    name_ja: 'モガディシュ',
    name_en: 'MOGADISHU',
    area_code: 'afr',
    country_code: 'SO',
    flag: 1,
    display: null,
    air_city_code: 'MGQ',
  },
  {
    code: 'MOW',
    name_ja: 'モスクワ',
    name_en: 'MOSCOW',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: 1,
    air_city_code: 'MOW',
  },
  {
    code: 'MOD',
    name_ja: 'モデスト',
    name_en: 'MODESTO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MOD',
  },
  {
    code: 'MOB',
    name_ja: 'モビール',
    name_en: 'MOBILE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MOB',
  },
  {
    code: 'MJD',
    name_ja: 'モヘンジョダロ',
    name_en: 'MOHENJO DARO',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'MJD',
  },
  {
    code: 'MLI',
    name_ja: 'モリン',
    name_en: 'MOLINE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MLI',
  },
  {
    code: 'MRZ',
    name_ja: 'モリー',
    name_en: 'MOREE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MRZ',
  },
  {
    code: 'MOL',
    name_ja: 'モルデ',
    name_en: 'MOLDE',
    area_code: 'eur',
    country_code: 'NO',
    flag: 1,
    display: null,
    air_city_code: 'MOL',
  },
  {
    code: 'MYA',
    name_ja: 'モルヤ',
    name_en: 'MORUYA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MYA',
  },
  {
    code: 'MLM',
    name_ja: 'モレリア',
    name_en: 'MORELIA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'MLM',
  },
  {
    code: 'MKK',
    name_ja: 'モロカイ島',
    name_en: 'MOLOKAI',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 9,
    air_city_code: 'MKK',
  },
  {
    code: 'YVA',
    name_ja: 'モロニ',
    name_en: 'MORONI',
    area_code: 'afr',
    country_code: 'KM',
    flag: 1,
    display: null,
    air_city_code: 'YVA',
  },
  {
    code: 'MXM',
    name_ja: 'モロンベ',
    name_en: 'MOROMBE',
    area_code: 'afr',
    country_code: 'MG',
    flag: 1,
    display: null,
    air_city_code: 'MXM',
  },
  {
    code: 'MJK',
    name_ja: 'モンキーマイア',
    name_en: 'MONKEY MIA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'MJK',
  },
  {
    code: 'YQM',
    name_ja: 'モンクトン',
    name_en: 'MONCTON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQM',
  },
  {
    code: 'LOV',
    name_ja: 'モンクローバ',
    name_en: 'MONCLOVA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'LOV',
  },
  {
    code: 'MGM',
    name_ja: 'モンゴメリー（アラバマ州）',
    name_en: 'MONTGOMERY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MGM',
  },
  {
    code: 'MS1',
    name_ja: 'モンサンミシェル',
    name_en: 'MONT SAINT MICHEL',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'PAR',
  },
  {
    code: 'MBJ',
    name_ja: 'モンテゴベイ',
    name_en: 'MONTEGO BAY',
    area_code: 'sam',
    country_code: 'JM',
    flag: 1,
    display: null,
    air_city_code: 'MBJ',
  },
  {
    code: 'MVD',
    name_ja: 'モンテビデオ',
    name_en: 'MONTEVIDEO',
    area_code: 'sam',
    country_code: 'UY',
    flag: 1,
    display: null,
    air_city_code: 'MVD',
  },
  {
    code: 'MTY',
    name_ja: 'モンテレイ',
    name_en: 'MONTERREY',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'MTY',
  },
  {
    code: 'YYY',
    name_ja: 'モントジョイ',
    name_en: 'MONTJOLI',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YYY',
  },
  {
    code: 'MPV',
    name_ja: 'モントピーリア',
    name_en: 'MONTPELIER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MPV',
  },
  {
    code: 'YMQ',
    name_ja: 'モントリオール',
    name_en: 'MONTREAL',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: 6,
    air_city_code: 'YMQ',
  },
  {
    code: 'MRY',
    name_ja: 'モントレー（カリフォルニア州',
    name_en: 'MONTEREY.CA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MRY',
  },
  {
    code: 'MTJ',
    name_ja: 'モントローズ（コロラド州）',
    name_en: 'MONTROSE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MTJ',
  },
  {
    code: 'MBA',
    name_ja: 'モンバサ',
    name_en: 'MOMBASA',
    area_code: 'afr',
    country_code: 'KE',
    flag: 1,
    display: null,
    air_city_code: 'MBA',
  },
  {
    code: 'MPL',
    name_ja: 'モンペリエ',
    name_en: 'MONTPELLIER',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'MPL',
  },
  {
    code: 'MLW',
    name_ja: 'モンロビア',
    name_en: 'MONROVIA',
    area_code: 'afr',
    country_code: 'LR',
    flag: 1,
    display: null,
    air_city_code: 'MLW',
  },
  {
    code: 'MLU',
    name_ja: 'モンロー',
    name_en: 'MONROE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MLU',
  },
  {
    code: 'MGW',
    name_ja: 'モーガンタウン',
    name_en: 'MORGANTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MGW',
  },
  {
    code: 'MWH',
    name_ja: 'モーゼスレイク',
    name_en: 'MOSES LAKE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MWH',
  },
  {
    code: 'MRU',
    name_ja: 'モーリシャス',
    name_en: 'MAURITIUS',
    area_code: 'afr',
    country_code: 'MU',
    flag: 1,
    display: null,
    air_city_code: 'MRU',
  },
  {
    code: 'MGR',
    name_ja: 'モールトリー',
    name_en: 'MOULTRIE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'MGR',
  },
  {
    code: 'MOZ',
    name_ja: 'モーレア',
    name_en: 'MOOREA',
    area_code: 'oce',
    country_code: 'PF',
    flag: 1,
    display: null,
    air_city_code: 'MOZ',
  },
  {
    code: 'MXX',
    name_ja: 'モ－ラ',
    name_en: 'MORA',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'MXX',
  },
  {
    code: 'YAO',
    name_ja: 'ヤウンデ',
    name_en: 'YAOUNDE',
    area_code: 'afr',
    country_code: 'CM',
    flag: 1,
    display: null,
    air_city_code: 'YAO',
  },
  {
    code: 'YKM',
    name_ja: 'ヤキマ',
    name_en: 'YAKIMA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'YKM',
  },
  {
    code: 'YAK',
    name_ja: 'ヤクタット',
    name_en: 'YAKUTAT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'YAK',
  },
  {
    code: 'YAP',
    name_ja: 'ヤップ',
    name_en: 'YAP',
    area_code: 'mic',
    country_code: 'FM',
    flag: 1,
    display: null,
    air_city_code: 'YAP',
  },
  {
    code: 'YKN',
    name_ja: 'ヤンクトン',
    name_en: 'YANKTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'YKN',
  },
  {
    code: 'YNG',
    name_ja: 'ヤングスタウン／ワ－レン',
    name_en: 'YOUNGSTOWN/WARREN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'YNG',
  },
  {
    code: 'RGN',
    name_ja: 'ヤンゴン',
    name_en: 'YANGON',
    area_code: 'asi',
    country_code: 'MM',
    flag: 1,
    display: null,
    air_city_code: 'RGN',
  },
  {
    code: 'YNJ',
    name_ja: 'ヤンジ（延吉）',
    name_en: 'YANJI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'YNJ',
  },
  {
    code: 'IAS',
    name_ja: 'ヤーシ',
    name_en: 'IASI',
    area_code: 'eur',
    country_code: 'RO',
    flag: 1,
    display: null,
    air_city_code: 'IAS',
  },
  {
    code: 'UUS',
    name_ja: 'ユジノ サハリンスク',
    name_en: 'YUZHNO SAKHALINSK',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'UUS',
  },
  {
    code: 'EUG',
    name_ja: 'ユジーン',
    name_en: 'EUGENE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'EUG',
  },
  {
    code: 'YUM',
    name_ja: 'ユマ（アリゾナ州）',
    name_en: 'YUMA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'YUM',
  },
  {
    code: 'JYV',
    name_ja: 'ユヴァスキュラ',
    name_en: 'JYVASKYLA',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'JYV',
  },
  {
    code: 'JOE',
    name_ja: 'ヨエンスー',
    name_en: 'JOENSUU',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'JOE',
  },
  {
    code: 'JNB',
    name_ja: 'ヨハネスブルグ',
    name_en: 'JOHANNESBURG',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: 2,
    air_city_code: 'JNB',
  },
  {
    code: 'GOT',
    name_ja: 'ヨーテボリ',
    name_en: 'GOTHENBURG',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'GOT',
  },
  {
    code: 'RFP',
    name_ja: 'ライアテア',
    name_en: 'RAIATEA',
    area_code: 'oce',
    country_code: 'PF',
    flag: 1,
    display: null,
    air_city_code: 'RFP',
  },
  {
    code: 'LID',
    name_ja: 'ライデン',
    name_en: 'DEIDEN',
    area_code: 'eur',
    country_code: 'NL',
    flag: 1,
    display: null,
    air_city_code: 'LID',
  },
  {
    code: 'LHG',
    name_ja: 'ライトニングリッジ',
    name_en: 'LIGHTNING RIDGE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'LHG',
  },
  {
    code: 'LEJ',
    name_ja: 'ライプチヒ',
    name_en: 'LEIPZIG',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'LEJ',
  },
  {
    code: 'RHI',
    name_ja: 'ラインランダ',
    name_en: 'RHINELANDER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RHI',
  },
  {
    code: 'LAE',
    name_ja: 'ラエ',
    name_en: 'LAE',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'LAE',
  },
  {
    code: 'LAO',
    name_ja: 'ラオアグ',
    name_en: 'LAOAG',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'LAO',
  },
  {
    code: 'LKO',
    name_ja: 'ラクナウ',
    name_en: 'LUCKNOW',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'LKO',
  },
  {
    code: 'LSE',
    name_ja: 'ラクロス（ウイスコンシン州）',
    name_en: 'LA CROSSE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LSE',
  },
  {
    code: 'LCI',
    name_ja: 'ラコニア',
    name_en: 'LACONIA',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LCI',
  },
  {
    code: 'LCG',
    name_ja: 'ラコルーニャ',
    name_en: 'LA CORUNA',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'LCG',
  },
  {
    code: 'LOS',
    name_ja: 'ラゴス',
    name_en: 'LAGOS',
    area_code: 'afr',
    country_code: 'NG',
    flag: 1,
    display: null,
    air_city_code: 'LOS',
  },
  {
    code: 'LXA',
    name_ja: 'ラサ',
    name_en: 'LHASA',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LXA',
  },
  {
    code: 'LRU',
    name_ja: 'ラスクルーセス',
    name_en: 'LAS CRUCES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LRU',
  },
  {
    code: 'LAS',
    name_ja: 'ラスベガス',
    name_en: 'LAS VEGAS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: 6,
    air_city_code: 'LAS',
  },
  {
    code: 'LCE',
    name_ja: 'ラセイバ',
    name_en: 'LA CEIBA',
    area_code: 'sam',
    country_code: 'HN',
    flag: 1,
    display: null,
    air_city_code: 'LCE',
  },
  {
    code: 'LSC',
    name_ja: 'ラセレナ',
    name_en: 'LA SERENA',
    area_code: 'sam',
    country_code: 'CL',
    flag: 1,
    display: null,
    air_city_code: 'LSC',
  },
  {
    code: 'VKG',
    name_ja: 'ラックザー',
    name_en: 'RACH GIA',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'VKG',
  },
  {
    code: 'RUT',
    name_ja: 'ラットランド',
    name_en: 'RUTLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RUT',
  },
  {
    code: 'LPP',
    name_ja: 'ラッペーンランタ',
    name_en: 'LAPPEENRANTA',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'LPP',
  },
  {
    code: 'LBE',
    name_ja: 'ラトローブ',
    name_en: 'LATROBE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LBE',
  },
  {
    code: 'LNY',
    name_ja: 'ラナイ（ラナイ島）',
    name_en: 'LANAI',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 10,
    air_city_code: 'LNY',
  },
  {
    code: 'LAI',
    name_ja: 'ラニオン',
    name_en: 'LANNION',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'LAI',
  },
  {
    code: 'UNN',
    name_ja: 'ラノーン',
    name_en: 'RANONG',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'UNN',
  },
  {
    code: 'RAB',
    name_ja: 'ラバウル',
    name_en: 'RABAUL',
    area_code: 'oce',
    country_code: 'PG',
    flag: 1,
    display: null,
    air_city_code: 'RAB',
  },
  {
    code: 'LBB',
    name_ja: 'ラバック',
    name_en: 'LUBBOCK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LBB',
  },
  {
    code: 'RBA',
    name_ja: 'ラバト',
    name_en: 'RABAT',
    area_code: 'afr',
    country_code: 'MA',
    flag: 1,
    display: null,
    air_city_code: 'RBA',
  },
  {
    code: 'LPB',
    name_ja: 'ラパス',
    name_en: 'LA PAZ',
    area_code: 'sam',
    country_code: 'BO',
    flag: 1,
    display: null,
    air_city_code: 'LPB',
  },
  {
    code: 'LAP',
    name_ja: 'ラパス',
    name_en: 'LA PAZ',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: 3,
    air_city_code: 'LAP',
  },
  {
    code: 'RAP',
    name_ja: 'ラピッドシティ',
    name_en: 'RAPID CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RAP',
  },
  {
    code: 'LFT',
    name_ja: 'ラファイエット',
    name_en: 'LAFAYETTE（ルイジアナ州）',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LFT',
  },
  {
    code: 'LAF',
    name_ja: 'ラファイエット',
    name_en: 'LAFAYETTE（インディアナ州）',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LAF',
  },
  {
    code: 'BQN',
    name_ja: 'ラファエル・エルナンデス',
    name_en: 'AGUADILLA',
    area_code: 'sam',
    country_code: 'PR',
    flag: 1,
    display: null,
    air_city_code: 'BQN',
  },
  {
    code: 'LBU',
    name_ja: 'ラブアン',
    name_en: 'LABUAN',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'LBU',
  },
  {
    code: 'LHE',
    name_ja: 'ラホール',
    name_en: 'LAHORE',
    area_code: 'asi',
    country_code: 'PK',
    flag: 1,
    display: null,
    air_city_code: 'LHE',
  },
  {
    code: 'LAA',
    name_ja: 'ラマー',
    name_en: 'LAMAR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LAA',
  },
  {
    code: 'SUF',
    name_ja: 'ラメーツィアテルメ',
    name_en: 'LAMEZIA TERME',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'SUF',
  },
  {
    code: 'LAR',
    name_ja: 'ララミー',
    name_en: 'LARAMIE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LAR',
  },
  {
    code: 'LCA',
    name_ja: 'ラルナカ',
    name_en: 'LAMACA',
    area_code: 'eur',
    country_code: 'CY',
    flag: 1,
    display: null,
    air_city_code: 'LCA',
  },
  {
    code: 'LRD',
    name_ja: 'ラレード',
    name_en: 'LAREDO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LRD',
  },
  {
    code: 'RAR',
    name_ja: 'ラロトンガ',
    name_en: 'RAROTONGA',
    area_code: 'oce',
    country_code: 'CK',
    flag: 1,
    display: null,
    air_city_code: 'RAR',
  },
  {
    code: 'LRM',
    name_ja: 'ラロマーナ',
    name_en: 'LA ROMANA',
    area_code: 'sam',
    country_code: 'DO',
    flag: 1,
    display: null,
    air_city_code: 'LRM',
  },
  {
    code: 'YVC',
    name_ja: 'ラロンガ',
    name_en: 'LA RONGA',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YVC',
  },
  {
    code: 'LGK',
    name_ja: 'ランカウイ島',
    name_en: 'LANGKAWI',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: 3,
    air_city_code: 'LGK',
  },
  {
    code: 'LNS',
    name_ja: 'ランカスター',
    name_en: 'LANCASTER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LNS',
  },
  {
    code: 'RGI',
    name_ja: 'ランギロア',
    name_en: 'RANGIROA',
    area_code: 'oce',
    country_code: 'PF',
    flag: 1,
    display: null,
    air_city_code: 'RGI',
  },
  {
    code: 'ACE',
    name_ja: 'ランサローテ',
    name_en: 'LANZOROTE',
    area_code: 'eur',
    country_code: 'ES',
    flag: 1,
    display: null,
    air_city_code: 'ACE',
  },
  {
    code: 'LAN',
    name_ja: 'ランシング',
    name_en: 'LANSING',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LAN',
  },
  {
    code: 'LPT',
    name_ja: 'ランパーン',
    name_en: 'LAMPANG',
    area_code: 'asi',
    country_code: 'TH',
    flag: 1,
    display: null,
    air_city_code: 'LPT',
  },
  {
    code: 'LMP',
    name_ja: 'ランペドゥーザ島',
    name_en: 'LAMPEDUSA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'LMP',
  },
  {
    code: 'EUN',
    name_ja: 'ラーユーン',
    name_en: 'LAAYOUNE',
    area_code: 'afr',
    country_code: 'EH',
    flag: 1,
    display: null,
    air_city_code: 'EUN',
  },
  {
    code: 'IXR',
    name_ja: 'ラーンチー',
    name_en: 'RANCHI',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IXR',
  },
  {
    code: 'LEA',
    name_ja: 'リアマンス',
    name_en: 'REARMONTH',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'LEA',
  },
  {
    code: 'RGL',
    name_ja: 'リオガジェゴス',
    name_en: 'RIO GALLEGOS',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'RGL',
  },
  {
    code: 'RBR',
    name_ja: 'リオブランコ',
    name_en: 'RIO BRANCO',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'RBR',
  },
  {
    code: 'RIO',
    name_ja: 'リオ・デ・ジャネイロ',
    name_en: 'RIO DE JANEIRO',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: 2,
    air_city_code: 'RIO',
  },
  {
    code: 'RIX',
    name_ja: 'リガ',
    name_en: 'RIGA',
    area_code: 'eur',
    country_code: 'LV',
    flag: 1,
    display: null,
    air_city_code: 'RIX',
  },
  {
    code: 'LZR',
    name_ja: 'リザード島',
    name_en: 'LIZRAD ISLAND',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'LZR',
  },
  {
    code: 'LIS',
    name_ja: 'リスボン',
    name_en: 'LISBON',
    area_code: 'eur',
    country_code: 'PT',
    flag: 1,
    display: 1,
    air_city_code: 'LIS',
  },
  {
    code: 'LSY',
    name_ja: 'リスモアー',
    name_en: 'LISMORE',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'LSY',
  },
  {
    code: 'RCB',
    name_ja: 'リチャーズ ベイ',
    name_en: 'RICHARDS BAY',
    area_code: 'afr',
    country_code: 'ZA',
    flag: 1,
    display: null,
    air_city_code: 'RCB',
  },
  {
    code: 'RIF',
    name_ja: 'リッチフィールド（ユタ州）',
    name_en: 'RICHFIELD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RIF',
  },
  {
    code: 'RIC',
    name_ja: 'リッチモンド',
    name_en: 'RICHMOND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RIC',
  },
  {
    code: 'LIT',
    name_ja: 'リトルロック',
    name_en: 'LITTLE ROCK',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LIT',
  },
  {
    code: 'RNO',
    name_ja: 'リノ',
    name_en: 'RENO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RNO',
  },
  {
    code: 'LPL',
    name_ja: 'リバプール',
    name_en: 'LIVERPOOL',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'LPL',
  },
  {
    code: 'RIW',
    name_ja: 'リバートン',
    name_en: 'RIVERTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RIW',
  },
  {
    code: 'LVI',
    name_ja: 'リビングストーン',
    name_en: 'LIVINGSTON',
    area_code: 'afr',
    country_code: 'ZM',
    flag: 1,
    display: null,
    air_city_code: 'LVI',
  },
  {
    code: 'LIH',
    name_ja: 'リフェ（カウアイ島）',
    name_en: 'LIHE (KAUAI)',
    area_code: 'hwi',
    country_code: 'HW',
    flag: 1,
    display: 7,
    air_city_code: 'LIH',
  },
  {
    code: 'RAO',
    name_ja: 'リベイラプレト',
    name_en: 'RIBEIRAO PRETO',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'RAO',
  },
  {
    code: 'LBL',
    name_ja: 'リベラル',
    name_en: 'LIBERAL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LBL',
  },
  {
    code: 'LIR',
    name_ja: 'リベリア',
    name_en: 'LIBERIA',
    area_code: 'sam',
    country_code: 'CR',
    flag: 1,
    display: null,
    air_city_code: 'LIR',
  },
  {
    code: 'LIM',
    name_ja: 'リマ',
    name_en: 'LIMA',
    area_code: 'sam',
    country_code: 'PE',
    flag: 1,
    display: 1,
    air_city_code: 'LIM',
  },
  {
    code: 'RMI',
    name_ja: 'リミニ',
    name_en: 'RIMINI',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'RMI',
  },
  {
    code: 'LIG',
    name_ja: 'リモージュ',
    name_en: 'LIMOGES',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'LIG',
  },
  {
    code: 'RUH',
    name_ja: 'リヤド',
    name_en: 'RIYADH',
    area_code: 'afr',
    country_code: 'SA',
    flag: 1,
    display: null,
    air_city_code: 'RUH',
  },
  {
    code: 'LJU',
    name_ja: 'リュブリャーナ',
    name_en: 'LIUBLIANA',
    area_code: 'eur',
    country_code: 'SI',
    flag: 1,
    display: null,
    air_city_code: 'LJU',
  },
  {
    code: 'LEW',
    name_ja: 'リューイストン（メイン州）',
    name_en: 'LEWISTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LEW',
  },
  {
    code: 'LYS',
    name_ja: 'リヨン',
    name_en: 'LYON',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: 3,
    air_city_code: 'LYS',
  },
  {
    code: 'LLW',
    name_ja: 'リロングウェ',
    name_en: 'LILONGWE',
    area_code: 'afr',
    country_code: 'MW',
    flag: 1,
    display: null,
    air_city_code: 'LLW',
  },
  {
    code: 'LNK',
    name_ja: 'リンカーン',
    name_en: 'LINCOLN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LNK',
  },
  {
    code: 'LPI',
    name_ja: 'リンコピン',
    name_en: 'LINKOPING',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'LPI',
  },
  {
    code: 'LYH',
    name_ja: 'リンチバーグ',
    name_en: 'LYNCHBURG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LYH',
  },
  {
    code: 'LNZ',
    name_ja: 'リンツ',
    name_en: 'LINZ',
    area_code: 'eur',
    country_code: 'AT',
    flag: 1,
    display: null,
    air_city_code: 'LNZ',
  },
  {
    code: 'LMN',
    name_ja: 'リンバン',
    name_en: 'LIMBANG',
    area_code: 'asi',
    country_code: 'MY',
    flag: 1,
    display: null,
    air_city_code: 'LMN',
  },
  {
    code: 'LWO',
    name_ja: 'リヴィウ',
    name_en: 'LVIV',
    area_code: 'eur',
    country_code: 'UA',
    flag: 1,
    display: null,
    air_city_code: 'LWO',
  },
  {
    code: 'LBA',
    name_ja: 'リーズ',
    name_en: 'LEEDS/BRADFORD',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: null,
    air_city_code: 'LBA',
  },
  {
    code: 'LBV',
    name_ja: 'リーブルビル',
    name_en: 'LIBREVILLE',
    area_code: 'afr',
    country_code: 'GA',
    flag: 1,
    display: null,
    air_city_code: 'LBV',
  },
  {
    code: 'LIL',
    name_ja: 'リール',
    name_en: 'LILLE',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'LIL',
  },
  {
    code: 'LAD',
    name_ja: 'ルアンダ',
    name_en: 'LUANDA',
    area_code: 'afr',
    country_code: 'AO',
    flag: 1,
    display: null,
    air_city_code: 'LAD',
  },
  {
    code: 'LPQ',
    name_ja: 'ルアンプラバン',
    name_en: 'LUAN PRABANG',
    area_code: 'asi',
    country_code: 'LA',
    flag: 1,
    display: null,
    air_city_code: 'LPQ',
  },
  {
    code: 'LEH',
    name_ja: 'ルアーブル',
    name_en: 'LE HAVRE',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'LEH',
  },
  {
    code: 'LWT',
    name_ja: 'ルイスタウン（モンタナ州）',
    name_en: 'LEWISTOWN',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LWT',
  },
  {
    code: 'LWS',
    name_ja: 'ルイストン',
    name_en: 'LEWISTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LWS',
  },
  {
    code: 'LWB',
    name_ja: 'ルイスバーグ（ウエストバージニア州）',
    name_en: 'LEWISBURG',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LWB',
  },
  {
    code: 'SDF',
    name_ja: 'ルイスビル',
    name_en: 'LOUISVILLE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'SDF',
  },
  {
    code: 'RUI',
    name_ja: 'ルイドソ',
    name_en: 'RUIDOSO',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RUI',
  },
  {
    code: 'LOU',
    name_ja: 'ルイビル（ケンタッキー州）',
    name_en: 'Louisville',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LOU',
  },
  {
    code: 'LUG',
    name_ja: 'ルガーノ',
    name_en: 'LUGANO',
    area_code: 'eur',
    country_code: 'CH',
    flag: 1,
    display: null,
    air_city_code: 'LUG',
  },
  {
    code: 'LUX',
    name_ja: 'ルクセンブルグ',
    name_en: 'LUXEMBOURG',
    area_code: 'eur',
    country_code: 'LU',
    flag: 1,
    display: null,
    air_city_code: 'LUX',
  },
  {
    code: 'LXR',
    name_ja: 'ルクソール',
    name_en: 'LUXOR',
    area_code: 'afr',
    country_code: 'EG',
    flag: 1,
    display: 2,
    air_city_code: 'LXR',
  },
  {
    code: 'LUN',
    name_ja: 'ルサカ',
    name_en: 'LUSAKA',
    area_code: 'afr',
    country_code: 'ZM',
    flag: 1,
    display: null,
    air_city_code: 'LUN',
  },
  {
    code: 'FBM',
    name_ja: 'ルブンバシ',
    name_en: 'LUBUMBASHI',
    area_code: 'afr',
    country_code: 'CG',
    flag: 1,
    display: null,
    air_city_code: 'FBM',
  },
  {
    code: 'LME',
    name_ja: 'ルマン',
    name_en: 'LE MANS',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'LME',
  },
  {
    code: 'LDE',
    name_ja: 'ルルド',
    name_en: 'LOURDES',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'LDE',
  },
  {
    code: 'LLA',
    name_ja: 'ルレア',
    name_en: 'LULEA',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'LLA',
  },
  {
    code: 'REK',
    name_ja: 'レイキャビック',
    name_en: 'REYKJAVIK',
    area_code: 'eur',
    country_code: 'IS',
    flag: 1,
    display: null,
    air_city_code: '',
  },
  {
    code: 'LHU',
    name_ja: 'レイクハバス',
    name_en: 'LAKE HAVASU CITY',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LHU',
  },
  {
    code: 'REX',
    name_ja: 'レイノサ',
    name_en: 'REYNOSA',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'REX',
  },
  {
    code: 'BJX',
    name_ja: 'レオングアナフアト',
    name_en: 'LEON GUANAJUATO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'BJX',
  },
  {
    code: 'LGP',
    name_ja: 'レガスピ',
    name_en: 'LEGASPI',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'LGP',
  },
  {
    code: 'LEX',
    name_ja: 'レキシントン',
    name_en: 'LEXINGTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LEX',
  },
  {
    code: 'RES',
    name_ja: 'レシステンシア',
    name_en: 'RESISTENCIA',
    area_code: 'sam',
    country_code: 'AR',
    flag: 1,
    display: null,
    air_city_code: 'RES',
  },
  {
    code: 'REC',
    name_ja: 'レシフェ',
    name_en: 'RECIFE',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'REC',
  },
  {
    code: 'YQR',
    name_ja: 'レジャイナ',
    name_en: 'REGINA',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQR',
  },
  {
    code: 'YQL',
    name_ja: 'レスブリッジ',
    name_en: 'LETHBRIDGE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQL',
  },
  {
    code: 'REG',
    name_ja: 'レッジョカラブリア',
    name_en: 'REGGIO CALABRIA',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: null,
    air_city_code: 'REG',
  },
  {
    code: 'RDM',
    name_ja: 'レッドモンド',
    name_en: 'REDMOND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RDM',
  },
  {
    code: 'LET',
    name_ja: 'レティシア',
    name_en: 'LETICIA',
    area_code: 'sam',
    country_code: 'CO',
    flag: 1,
    display: null,
    air_city_code: 'LET',
  },
  {
    code: 'RDD',
    name_ja: 'レディング',
    name_en: 'REDDING',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RDD',
  },
  {
    code: 'RDG',
    name_ja: 'レディング',
    name_en: 'READING',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RDG',
  },
  {
    code: 'LEB',
    name_ja: 'レバノン',
    name_en: 'LEBANON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LEB',
  },
  {
    code: 'RUN',
    name_ja: 'レユニオン島',
    name_en: 'SAINT DENIS DE LA REUNION',
    area_code: 'afr',
    country_code: 'RE',
    flag: 1,
    display: null,
    air_city_code: 'RUN',
  },
  {
    code: 'RNS',
    name_ja: 'レンヌ',
    name_en: 'RENNES',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'RNS',
  },
  {
    code: 'RMK',
    name_ja: 'レンマーク',
    name_en: 'RENMARK',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'RMK',
  },
  {
    code: 'IXL',
    name_ja: 'レー',
    name_en: 'LEH',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'IXL',
  },
  {
    code: 'LCH',
    name_ja: 'レークチャールズ',
    name_en: 'LAKE CHARLES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LCH',
  },
  {
    code: 'RTB',
    name_ja: 'ロアタン',
    name_en: 'ROATAN',
    area_code: 'sam',
    country_code: 'HN',
    flag: 1,
    display: null,
    air_city_code: 'RTB',
  },
  {
    code: 'ROA',
    name_ja: 'ロアノーク',
    name_en: 'ROANOKE',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ROA',
  },
  {
    code: 'LAX',
    name_ja: 'ロサンゼルス',
    name_en: 'LOS ANGELES',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: 5,
    air_city_code: 'LAX',
  },
  {
    code: 'RCE',
    name_ja: 'ロシュハーバー',
    name_en: 'ROCHE HARBOR',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RCE',
  },
  {
    code: 'LAM',
    name_ja: 'ロスアラモス',
    name_en: 'LOS ALAMOS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LAM',
  },
  {
    code: 'RLG',
    name_ja: 'ロストック',
    name_en: 'ROSTOCK',
    area_code: 'eur',
    country_code: 'DE',
    flag: 1,
    display: null,
    air_city_code: 'RLG',
  },
  {
    code: 'ROV',
    name_ja: 'ロストフ',
    name_en: 'ROSTOV',
    area_code: 'eur',
    country_code: 'RU',
    flag: 1,
    display: null,
    air_city_code: 'ROV',
  },
  {
    code: 'LMM',
    name_ja: 'ロスモチス',
    name_en: 'LOS MOCHIS',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'LMM',
  },
  {
    code: 'ROW',
    name_ja: 'ロズウェル',
    name_en: 'ROSWELL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ROW',
  },
  {
    code: 'ROP',
    name_ja: 'ロタ',
    name_en: 'ROTA',
    area_code: 'mic',
    country_code: 'MP',
    flag: 1,
    display: null,
    air_city_code: 'ROP',
  },
  {
    code: 'ROC',
    name_ja: 'ロチェスター',
    name_en: 'ROCHESTER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'ROC',
  },
  {
    code: 'RST',
    name_ja: 'ロチェスター（ミネソタ州）',
    name_en: 'ROCHESTER',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RST',
  },
  {
    code: 'RWI',
    name_ja: 'ロッキーマウント（ノースカロライナ州）',
    name_en: 'ROCKY MOUNT',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RWI',
  },
  {
    code: 'RSD',
    name_ja: 'ロックサウンド',
    name_en: 'ROCK SOUND',
    area_code: 'sam',
    country_code: 'BS',
    flag: 1,
    display: null,
    air_city_code: 'RSD',
  },
  {
    code: 'RKS',
    name_ja: 'ロックスプリングス',
    name_en: 'ROCK SPRINGS',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RKS',
  },
  {
    code: 'ROK',
    name_ja: 'ロックハンプトン',
    name_en: 'ROCKHAMPTON',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'ROK',
  },
  {
    code: 'RFD',
    name_ja: 'ロックフォード',
    name_en: 'ROCKFORD',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RFD',
  },
  {
    code: 'RKD',
    name_ja: 'ロックランド',
    name_en: 'ROCK LAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RKD',
  },
  {
    code: 'RTM',
    name_ja: 'ロッテルダム',
    name_en: 'ROTTERDAM',
    area_code: 'eur',
    country_code: 'NL',
    flag: 1,
    display: null,
    air_city_code: 'RTM',
  },
  {
    code: 'RTS',
    name_ja: 'ロットネストアイランド',
    name_en: 'ROTTNEST ISLAND',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'RTS',
  },
  {
    code: 'RDZ',
    name_ja: 'ロデズ',
    name_en: 'RODEZ',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'RDZ',
  },
  {
    code: 'ROT',
    name_ja: 'ロトルア',
    name_en: 'ROTORUA',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'ROT',
  },
  {
    code: 'RNB',
    name_ja: 'ロネビー',
    name_en: 'RONNEBY',
    area_code: 'eur',
    country_code: 'SE',
    flag: 1,
    display: null,
    air_city_code: 'RNB',
  },
  {
    code: 'RXS',
    name_ja: 'ロハス',
    name_en: 'ROXAS CITY',
    area_code: 'asi',
    country_code: 'PH',
    flag: 1,
    display: null,
    air_city_code: 'RXS',
  },
  {
    code: 'LPS',
    name_ja: 'ロペツアイランド',
    name_en: 'LOPEZ ISLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LPS',
  },
  {
    code: 'LFW',
    name_ja: 'ロメ',
    name_en: 'LOME',
    area_code: 'afr',
    country_code: 'TG',
    flag: 1,
    display: null,
    air_city_code: 'LFW',
  },
  {
    code: 'LRT',
    name_ja: 'ロリヤン',
    name_en: 'LORIENT',
    area_code: 'eur',
    country_code: 'FR',
    flag: 1,
    display: null,
    air_city_code: 'LRT',
  },
  {
    code: 'LTO',
    name_ja: 'ロレト',
    name_en: 'LORETO',
    area_code: 'sam',
    country_code: 'MX',
    flag: 1,
    display: null,
    air_city_code: 'LTO',
  },
  {
    code: 'HAP',
    name_ja: 'ロングアイランド',
    name_en: 'LONG ISLAND',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'HAP',
  },
  {
    code: 'GGG',
    name_ja: 'ロングビュー',
    name_en: 'LONGVIEW',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'GGG',
  },
  {
    code: 'LGB',
    name_ja: 'ロングビーチ',
    name_en: 'LONG BEACH',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LGB',
  },
  {
    code: 'LDB',
    name_ja: 'ロンドリナ',
    name_en: 'LONDRINA',
    area_code: 'sam',
    country_code: 'BR',
    flag: 1,
    display: null,
    air_city_code: 'LDB',
  },
  {
    code: 'YXU',
    name_ja: 'ロンドン',
    name_en: 'LONDON',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YXU',
  },
  {
    code: 'LON',
    name_ja: 'ロンドン',
    name_en: 'LONDON',
    area_code: 'eur',
    country_code: 'GB',
    flag: 1,
    display: 1,
    air_city_code: 'LON',
  },
  {
    code: 'RVN',
    name_ja: 'ロヴァニエミ',
    name_en: 'ROVANIEMI',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'RVN',
  },
  {
    code: 'YUY',
    name_ja: 'ローイン',
    name_en: 'ROUYN',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YUY',
  },
  {
    code: 'LAW',
    name_ja: 'ロートン（オクラホマ州）',
    name_en: 'LAWTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LAW',
  },
  {
    code: 'RHO',
    name_ja: 'ロードス',
    name_en: 'RHODES',
    area_code: 'eur',
    country_code: 'GR',
    flag: 1,
    display: null,
    air_city_code: 'RHO',
  },
  {
    code: 'LDH',
    name_ja: 'ロードハウ',
    name_en: 'LOAD HOWE ISLAND',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'LDH',
  },
  {
    code: 'ROM',
    name_ja: 'ローマ',
    name_en: 'ROME',
    area_code: 'eur',
    country_code: 'IT',
    flag: 1,
    display: 1,
    air_city_code: 'ROM',
  },
  {
    code: 'RDU',
    name_ja: 'ローリーダーラム',
    name_en: 'RALEIGH/DURHAM',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'RDU',
  },
  {
    code: 'LUL',
    name_ja: 'ローレル',
    name_en: 'LAUREL',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'LUL',
  },
  {
    code: 'LAU',
    name_ja: 'ローレンシャン',
    name_en: 'LAURENTIANS',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YMQ',
  },
  {
    code: 'LST',
    name_ja: 'ローンセストン',
    name_en: 'LAUNCESTON',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'LST',
  },
  {
    code: 'WHK',
    name_ja: 'ワカタネ',
    name_en: 'WHAKATANE',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'WHK',
  },
  {
    code: 'OUA',
    name_ja: 'ワガドゥグ－',
    name_en: 'OUAGADOUGOU',
    area_code: 'afr',
    country_code: 'BF',
    flag: 1,
    display: null,
    air_city_code: 'OUA',
  },
  {
    code: 'WGA',
    name_ja: 'ワガワガ',
    name_en: 'WAGGA WAGGA',
    area_code: 'oce',
    country_code: 'AU',
    flag: 1,
    display: null,
    air_city_code: 'WGA',
  },
  {
    code: 'WAS',
    name_ja: 'ワシントンDC',
    name_en: 'WASHINGTON',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: 2,
    air_city_code: 'WAS',
  },
  {
    code: 'YQH',
    name_ja: 'ワトソンレイク',
    name_en: 'WATSON LAKE',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YQH',
  },
  {
    code: 'WKA',
    name_ja: 'ワナカ',
    name_en: 'WANAKA',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'WKA',
  },
  {
    code: 'YWK',
    name_ja: 'ワブッシュ',
    name_en: 'WABUSH',
    area_code: 'ame',
    country_code: 'CA',
    flag: 1,
    display: null,
    air_city_code: 'YWK',
  },
  {
    code: 'WLS',
    name_ja: 'ワリス諸島',
    name_en: 'WALLIS ISLAND',
    area_code: 'oce',
    country_code: 'WF',
    flag: 1,
    display: null,
    air_city_code: 'WLS',
  },
  {
    code: 'WAW',
    name_ja: 'ワルシャワ',
    name_en: 'WARSAW',
    area_code: 'eur',
    country_code: 'PL',
    flag: 1,
    display: 1,
    air_city_code: 'WAW',
  },
  {
    code: 'WAG',
    name_ja: 'ワンガヌイ',
    name_en: 'WANGANUI',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'WAG',
  },
  {
    code: 'WRE',
    name_ja: 'ワンガレイ',
    name_en: 'WHANGAREI',
    area_code: 'oce',
    country_code: 'NZ',
    flag: 1,
    display: null,
    air_city_code: 'WRE',
  },
  {
    code: 'WRL',
    name_ja: 'ワーランド',
    name_en: 'WORLAND',
    area_code: 'ame',
    country_code: 'US',
    flag: 1,
    display: null,
    air_city_code: 'WRL',
  },
  {
    code: 'NDJ',
    name_ja: 'ンジャメナ',
    name_en: 'NDIAMENA',
    area_code: 'afr',
    country_code: 'TD',
    flag: 1,
    display: null,
    air_city_code: 'NDJ',
  },
  {
    code: 'BDQ',
    name_ja: 'ヴァドーダラー',
    name_en: 'VADODARA',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'BDQ',
  },
  {
    code: 'VRK',
    name_ja: 'ヴァルカウス',
    name_en: 'VARKAUS',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'VRK',
  },
  {
    code: 'VAA',
    name_ja: 'ヴァーサ',
    name_en: 'VAASA',
    area_code: 'eur',
    country_code: 'FI',
    flag: 1,
    display: null,
    air_city_code: 'VAA',
  },
  {
    code: 'VFA',
    name_ja: 'ヴィクトリアフォ－ルズ',
    name_en: 'VICTORIA FALLS',
    area_code: 'afr',
    country_code: 'ZW',
    flag: 1,
    display: null,
    air_city_code: 'VFA',
  },
  {
    code: 'VTZ',
    name_ja: 'ヴィッシャーカパトナム',
    name_en: 'VISHAKHAPATNAM',
    area_code: 'asi',
    country_code: 'IN',
    flag: 1,
    display: null,
    air_city_code: 'VTZ',
  },
  {
    code: 'VII',
    name_ja: 'ヴィン',
    name_en: 'VINH CITY',
    area_code: 'asi',
    country_code: 'VN',
    flag: 1,
    display: null,
    air_city_code: 'VII',
  },
  {
    code: 'WRO',
    name_ja: 'ヴラツラフ',
    name_en: 'WROCLAW',
    area_code: 'eur',
    country_code: 'PL',
    flag: 1,
    display: null,
    air_city_code: 'WRO',
  },
  {
    code: 'WXN',
    name_ja: '万県（バンケン）',
    name_en: 'WANXIAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'WXN',
  },
  {
    code: 'DDG',
    name_ja: '丹東（タントン）',
    name_en: 'DANDONG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DDG',
  },
  {
    code: 'JZH',
    name_ja: '九塞溝',
    name_en: 'SONG PAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'JZH',
  },
  {
    code: 'JGS',
    name_ja: '井岡山（イオカサン）',
    name_en: 'JINGGANGSHAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'JGS',
  },
  {
    code: 'JMU',
    name_ja: '佳木斯',
    name_en: 'JIAMUSI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'JMU',
  },
  {
    code: 'KWJ',
    name_ja: '光州',
    name_en: 'GWANGJU',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'KWJ',
  },
  {
    code: 'BAV',
    name_ja: '包頭',
    name_en: 'BAOTOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'BAV',
  },
  {
    code: 'BHY',
    name_ja: '北海（ベイハイ）',
    name_en: 'BEIHAI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'BHY',
  },
  {
    code: 'KHN',
    name_ja: '南昌',
    name_en: 'NANCHANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'KHN',
  },
  {
    code: 'NTG',
    name_ja: '南通',
    name_en: 'NANTONG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'NTG',
  },
  {
    code: 'TXG',
    name_ja: '台中',
    name_en: 'TAICHUNG',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: 3,
    air_city_code: 'TXG',
  },
  {
    code: 'TPE',
    name_ja: '台北',
    name_en: 'TAIPEI',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: 1,
    air_city_code: 'TPE',
  },
  {
    code: 'TNN',
    name_ja: '台南',
    name_en: 'TAINAN',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: null,
    air_city_code: 'TNN',
  },
  {
    code: 'TTT',
    name_ja: '台東',
    name_en: 'TAITUNG',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: null,
    air_city_code: 'TTT',
  },
  {
    code: 'HFE',
    name_ja: '合肥',
    name_en: 'HEFEI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HFE',
  },
  {
    code: 'HET',
    name_ja: '呼和浩特',
    name_en: 'HOHHOT',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HET',
  },
  {
    code: 'HTN',
    name_ja: '和田／ホータン',
    name_en: 'HOTAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HTN',
  },
  {
    code: 'HRB',
    name_ja: '哈爾浜',
    name_en: 'HARBIN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HRB',
  },
  {
    code: 'JGN',
    name_ja: '嘉峪関（チアユーコワン）',
    name_en: 'JIAYUGUAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'JGN',
  },
  {
    code: 'CYI',
    name_ja: '嘉義',
    name_en: 'CHIAYI',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: null,
    air_city_code: 'CYI',
  },
  {
    code: 'DAT',
    name_ja: '大同（ダイドウ）',
    name_en: 'DATONG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DAT',
  },
  {
    code: 'DQA',
    name_ja: '大慶薩爾図空港',
    name_en: 'SAERTU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DQA',
  },
  {
    code: 'DLU',
    name_ja: '大理',
    name_en: 'DALI CITY',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DLU',
  },
  {
    code: 'YIH',
    name_ja: '宜昌',
    name_en: 'YICHANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'YIH',
  },
  {
    code: 'YBP',
    name_ja: '宜賓（ＹＩＰＩＮ）',
    name_en: 'YIBIN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'YBP',
  },
  {
    code: 'NGB',
    name_ja: '寧波',
    name_en: 'NINGBO',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'NGB',
  },
  {
    code: 'TXN',
    name_ja: '屯渓（黄山）',
    name_en: 'TUNXI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'TXN',
  },
  {
    code: 'CZX',
    name_ja: '常州（ジョウシュウ）',
    name_en: 'CHANGZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CZX',
  },
  {
    code: 'CGD',
    name_ja: '常徳（ジョウトク）',
    name_en: 'CHANGDE',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CGD',
  },
  {
    code: 'GYS',
    name_ja: '広元／コウゲン',
    name_en: 'GUANG YUAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'GYS',
  },
  {
    code: 'DYG',
    name_ja: '張家界',
    name_en: 'DAYONG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DYG',
  },
  {
    code: 'XUZ',
    name_ja: '徐州（ジョシュウ）',
    name_en: 'XUZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'XUZ',
  },
  {
    code: 'HCN',
    name_ja: '恒春',
    name_en: 'HENGCHUN',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: null,
    air_city_code: 'HCN',
  },
  {
    code: 'KYJ',
    name_ja: '慶州',
    name_en: 'KYONGJU',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: 4,
    air_city_code: 'SEL',
  },
  {
    code: 'YTY',
    name_ja: '揚州',
    name_en: 'YANGZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'YTY',
  },
  {
    code: 'PZI',
    name_ja: '攀枝花（パンシカ）',
    name_en: 'PAN ZHI HUA',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'PZI',
  },
  {
    code: 'DNH',
    name_ja: '敦煌（トンコウ）',
    name_en: 'DUNHUANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DNH',
  },
  {
    code: 'NDG',
    name_ja: '斉斉哈爾',
    name_en: 'QIQIHAR',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'NDG',
  },
  {
    code: 'BPX',
    name_ja: '昌都（ショウト）',
    name_en: 'CHANGDU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'BPX',
  },
  {
    code: 'HIN',
    name_ja: '晋州（チンジュ）',
    name_en: 'JINJU',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'HIN',
  },
  {
    code: 'JJN',
    name_ja: '晋江',
    name_en: 'JINJIANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'JJN',
  },
  {
    code: 'JDZ',
    name_ja: '景徳鎮（ケイトクチン）',
    name_en: 'JINGDEZHEN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'JDZ',
  },
  {
    code: 'JHG',
    name_ja: '景洪',
    name_en: 'JINGHONG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'JHG',
  },
  {
    code: 'CHG',
    name_ja: '朝陽',
    name_en: 'Chaoyang',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CHG',
  },
  {
    code: 'LZY',
    name_ja: '林芝（リンジィ）',
    name_en: 'LINZHI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LZY',
  },
  {
    code: 'LZH',
    name_ja: '柳州',
    name_en: 'LIUZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LZH',
  },
  {
    code: 'GOQ',
    name_ja: '格爾木／ゴルムド',
    name_en: 'GOLMUD',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'GOQ',
  },
  {
    code: 'UYN',
    name_ja: '楡林',
    name_en: 'YULIN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'UYN',
  },
  {
    code: 'WUS',
    name_ja: '武夷山',
    name_en: 'WUYISHAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'WUS',
  },
  {
    code: 'SWA',
    name_ja: '汕頭（サントウ）',
    name_en: 'SHANTOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'SWA',
  },
  {
    code: 'LYA',
    name_ja: '洛陽（ラクヨウ）',
    name_en: 'LUOYANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LYA',
  },
  {
    code: 'KPO',
    name_ja: '浦項（ポハン）',
    name_en: 'POHANG',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'KPO',
  },
  {
    code: 'HLD',
    name_ja: '海拉尓（ハイラル）',
    name_en: 'HAILAR',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HLD',
  },
  {
    code: 'HIA',
    name_ja: '淮安',
    name_en: 'HUAIAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HIA',
  },
  {
    code: 'CJJ',
    name_ja: '清州（チョンジュ）',
    name_en: 'CHEONGJU',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'CJJ',
  },
  {
    code: 'WNZ',
    name_ja: '温州',
    name_en: 'WENZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'WNZ',
  },
  {
    code: 'HLH',
    name_ja: '烏蘭浩特／ウランホト',
    name_en: 'ULANHOT',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HLH',
  },
  {
    code: 'WUX',
    name_ja: '無錫',
    name_en: 'WUXI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'WUX',
  },
  {
    code: 'YNT',
    name_ja: '煙台',
    name_en: 'YANTAI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'YNT',
  },
  {
    code: 'MDG',
    name_ja: '牡丹江',
    name_en: 'MUDANJIANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'MDG',
  },
  {
    code: 'ZUH',
    name_ja: '珠海',
    name_en: 'ZHUHAI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'ZUH',
  },
  {
    code: 'SJW',
    name_ja: '石家荘',
    name_en: 'SHIJIAZHUANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'SJW',
  },
  {
    code: 'BPE',
    name_ja: '秦皇島（チンホワンタオ）',
    name_en: 'QINHUANGDAO',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'BPE',
  },
  {
    code: 'KUV',
    name_ja: '群山（クンサン）',
    name_en: 'GUNSAN',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'KUV',
  },
  {
    code: 'YIW',
    name_ja: '義烏（ギウ）',
    name_en: 'YIWU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'YIW',
  },
  {
    code: 'LYI',
    name_ja: '臨沂',
    name_en: 'LINXI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LYI',
  },
  {
    code: 'HSN',
    name_ja: '舟山',
    name_en: 'ZHOUSHAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HSN',
  },
  {
    code: 'LUM',
    name_ja: '芒市＜ルーシー＞',
    name_en: 'LUXI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LUM',
  },
  {
    code: 'HUN',
    name_ja: '花蓮',
    name_en: 'HUALIEN',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: null,
    air_city_code: 'HUN',
  },
  {
    code: 'USN',
    name_ja: '蔚山（ウルサン）',
    name_en: 'ULSAN',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'USN',
  },
  {
    code: 'LHW',
    name_ja: '蘭州',
    name_en: 'LANZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LHW',
  },
  {
    code: 'XFN',
    name_ja: '襄樊（ジョウハン）',
    name_en: 'XIANGFAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'XFN',
  },
  {
    code: 'SIA',
    name_ja: '西安',
    name_en: 'XI AN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'SIA',
  },
  {
    code: 'KWE',
    name_ja: '貴陽',
    name_en: 'GUIYANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'KWE',
  },
  {
    code: 'CIF',
    name_ja: '赤峰／セキホウ',
    name_en: 'CHIFENG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CIF',
  },
  {
    code: 'TGO',
    name_ja: '通遼',
    name_en: 'TONGLIAO',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'TGO',
  },
  {
    code: 'LYG',
    name_ja: '連雲港',
    name_en: 'LIANYUNGANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'LYG',
  },
  {
    code: 'YCU',
    name_ja: '運城（ウンジョウ）',
    name_en: 'YUNCHANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'YCU',
  },
  {
    code: 'DAX',
    name_ja: '達州（タツシュウ）',
    name_en: 'DAZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DAX',
  },
  {
    code: 'DSN',
    name_ja: '鄂尓多斯（ガカトス）',
    name_en: 'ERDUOSI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'DSN',
  },
  {
    code: 'CGO',
    name_ja: '鄭州',
    name_en: 'ZHENGZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CGO',
  },
  {
    code: 'KNH',
    name_ja: '金門島',
    name_en: 'KINMEN',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: null,
    air_city_code: 'KNH',
  },
  {
    code: 'INC',
    name_ja: '銀川',
    name_en: 'YINCHUAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'INC',
  },
  {
    code: 'JNZ',
    name_ja: '錦州',
    name_en: 'JINZHOU',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'JNZ',
  },
  {
    code: 'MIG',
    name_ja: '錦陽（メンヨウ）',
    name_en: 'MIANYANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'MIG',
  },
  {
    code: 'XIL',
    name_ja: '錫林浩特（シリンホト）',
    name_en: 'XILINHOT',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'XIL',
  },
  {
    code: 'ZUJ',
    name_ja: '鎮江',
    name_en: 'ZHENJIANG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'ZUJ',
  },
  {
    code: 'CIH',
    name_ja: '長治（チョウジ）',
    name_en: 'CHANGZHI',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'CIH',
  },
  {
    code: 'MZG',
    name_ja: '馬公',
    name_en: 'MAKUNG',
    area_code: 'asi',
    country_code: 'TW',
    flag: 1,
    display: null,
    air_city_code: 'MZG',
  },
  {
    code: 'YNZ',
    name_ja: '鹽城（エンジョウ）',
    name_en: 'YANCHENG',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'YNZ',
  },
  {
    code: 'RSU',
    name_ja: '麗水（ヨス）',
    name_en: 'YEOSU',
    area_code: 'asi',
    country_code: 'KR',
    flag: 1,
    display: null,
    air_city_code: 'RSU',
  },
  {
    code: 'HYN',
    name_ja: '黄岩',
    name_en: 'HUANGYAN',
    area_code: 'asi',
    country_code: 'CN',
    flag: 1,
    display: null,
    air_city_code: 'HYN',
  },
]

export default cityCode
